const KLAY = ({ ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    fill="none"
    {...props}
  >
    <path d="m6.184 12.817.043-.022-.058.005.015.017Z" fill="#FF0C00" />
    <path d="m7.04 11.144-.125-.428-.252.666.377-.238Z" fill="#FF1200" />
    <path d="m10.296 4.401.433-.182-.401-.348-.032.53Z" fill="#FF7600" />
    <path
      d="m6.16 12.782.01.018.057-.005-.068-.013ZM6.153 12.759l.08-.006-.08-.018v.024Z"
      fill="#FF0C00"
    />
    <path d="m11.45 2.124-.375.33.574.053-.2-.383Z" fill="#FF8500" />
    <path d="m6.153 12.759.006.023.073-.029-.08.006Z" fill="#FF0C00" />
    <path d="m7.167 10.05.08.405.287-.267-.367-.138Z" fill="#FF1A00" />
    <path d="m6.203 12.83.024-.035-.043.022.02.012Z" fill="#FF0C00" />
    <path d="m11.135 3.09.524-.166-.32-.2-.204.367Z" fill="#FF8200" />
    <path d="m6.28 12.832-.053-.037.017.044.035-.007Z" fill="#FF0C00" />
    <path d="m10.838 2.036-.126.348.32-.325-.194-.023Z" fill="#FF8300" />
    <path d="m11.45 2.124-.225-.038-.15.368.375-.33Z" fill="#FF8500" />
    <path d="m6.227 12.795.083.017-.078-.059-.005.042Z" fill="#FF0C00" />
    <path
      d="m6.158 12.714-.005.02.08.02-.075-.04ZM6.227 12.795l.052.037.03-.02-.082-.017Z"
      fill="#FF0C00"
    />
    <path d="m15.09 3.927-.136.153.182-.094-.047-.06Z" fill="#FF8F00" />
    <path d="m6.222 12.836.005-.041-.024.034.019.007Z" fill="#FF0C00" />
    <path d="m11.45 2.124.2.383-.008-.345-.192-.038Z" fill="#FF8500" />
    <path d="m11.075 2.454.15-.368-.193-.027.043.395Z" fill="#FF8400" />
    <path d="m10.537 2.993-.1-.364-.285.422.385-.058Z" fill="#FF8100" />
    <path d="m6.282 12.57.002-.19-.126.334.124-.144Z" fill="#FF0C00" />
    <path d="m10.268 2.066-.066-.025-.009.017.075.008Z" fill="#FF8200" />
    <path d="m10.268 2.066-.054-.04-.012.015.066.025Z" fill="#FF8200" />
    <path d="m11.075 2.454-.043-.395-.32.325.363.07Z" fill="#FF8400" />
    <path d="m10.555 4.792-.219.34.342.17-.123-.51Z" fill="#FF7400" />
    <path d="m10.268 2.066-.022-.062-.016.008.038.054Z" fill="#FF8200" />
    <path d="m10.214 2.025.054.041-.038-.054-.016.013Z" fill="#FF8200" />
    <path d="m14.444 4.122-.141.28.281.136-.14-.416Z" fill="#FF8E00" />
    <path d="m9.807 8.09-.117.387.41-.184-.293-.204Z" fill="#FF4300" />
    <path d="m10.246 2.004.022.062.012-.068-.034.006Z" fill="#FF8300" />
    <path d="m7.5 11.246-.481.344.394.119.087-.463Z" fill="#FF1300" />
    <path d="m10.447 2.005-.18.061-.059.188.239-.249Z" fill="#FF8300" />
    <path d="m10.208 2.254-.14.137.37.238-.23-.375Z" fill="#FF8200" />
    <path
      d="m14.867 3.64-.055.207.188-.104-.133-.103ZM15.026 3.844l.109.01-.136-.11.027.1Z"
      fill="#FF8F00"
    />
    <path d="m10.28 1.998-.012.068.179-.06-.167-.008Z" fill="#FF8300" />
    <path d="m10.194 2.058-.127.333.141-.137-.014-.196Z" fill="#FF8200" />
    <path
      d="m6.233 12.753-.074.029.068.013.006-.042ZM6.245 12.84l-.018-.045-.005.041.023.003Z"
      fill="#FF0C00"
    />
    <path d="m15.147 3.869-.013-.015-.018.042.03-.027Z" fill="#FF8F00" />
    <path d="m10.712 2.384-.07-.365-.195-.014.265.379Z" fill="#FF8300" />
    <path d="m11.65 2.507-.31.216.319.201-.01-.417Z" fill="#FF8600" />
    <path d="m14.812 3.847.048.415.094-.182-.142-.233Z" fill="#FF8F00" />
    <path d="m12.93 6.193.096-.455-.274.18.177.275Z" fill="#FF7A00" />
    <path d="m10.405 7.503.111.33.28-.231-.391-.099Z" fill="#FF5100" />
    <path
      d="m15.026 3.844.09.052.018-.042-.108-.01ZM15.155 3.957l-.066-.03.047.06.02-.03Z"
      fill="#FF8F00"
    />
    <path d="m15.09 3.927-.064-.083-.072.236.135-.153Z" fill="#FF8F00" />
    <path d="m15.116 3.896-.09-.052.063.083.027-.03Z" fill="#FF8F00" />
    <path
      d="m14.035 3.08-.195.645.48-.47-.285-.175ZM14.443 4.122l.141.416.276-.276-.417-.14Z"
      fill="#FF8E00"
    />
    <path d="m14.86 4.262.276-.276-.182.094-.094.182Z" fill="#FF8F00" />
    <path d="m6.233 12.753.05-.183-.125.144.075.04Z" fill="#FF0C00" />
    <path d="m7.137 11.985-.461-.217.186.492.275-.275Z" fill="#FF0F00" />
    <path d="m13.63 3.465.21.26.194-.645-.404.385Z" fill="#FF8D00" />
    <path d="m15.155 3.957.006-.018-.072-.012.066.03Z" fill="#FF8F00" />
    <path d="m11.846 3.553-.35-.245.04.54.31-.295Z" fill="#FF8400" />
    <path d="m11.135 3.09.023.37.337-.152-.36-.217Z" fill="#FF8200" />
    <path d="m15.16 3.94.003-.02-.047-.024.045.043Z" fill="#FF8F00" />
    <path
      d="m15.161 3.94-.045-.044-.027.031.072.012ZM15.163 3.92l-.007-.034-.04.01.047.024Z"
      fill="#FF8F00"
    />
    <path d="m14.32 3.255-.15.522.327-.023-.177-.5Z" fill="#FF8E00" />
    <path d="m14.597 3.441-.1.313.37-.114-.27-.199Z" fill="#FF8F00" />
    <path d="m11.967 2.643.18-.359-.157-.042-.023.401Z" fill="#FF8700" />
    <path d="m15.156 3.886-.01-.017-.03.027.04-.01Z" fill="#FF8F00" />
    <path d="m13.14 2.63-.156-.063.133.419.022-.355Z" fill="#FF8B00" />
    <path d="m15.026 3.844-.026-.1-.188.103.214-.003Z" fill="#FF8F00" />
    <path d="m12.57 2.795-.236-.457-.107.612.343-.155Z" fill="#FF8900" />
    <path d="m12.147 2.284-.18.36.367-.306-.187-.054Z" fill="#FF8700" />
    <path d="m11.659 2.924.308-.28-.318-.137.01.417Z" fill="#FF8500" />
    <path d="m13.84 3.725-.417.04.26.255.157-.295Z" fill="#FF8D00" />
    <path d="m11.642 2.162.007.345.151-.31-.158-.035Z" fill="#FF8600" />
    <path d="m11.99 2.242-.19-.046-.151.311.34-.265Z" fill="#FF8700" />
    <path d="m11.659 2.924.274.233.034-.514-.308.281Z" fill="#FF8500" />
    <path d="m10.208 2.254.505.13-.266-.379-.239.249Z" fill="#FF8200" />
    <path d="m8.138 9.837-.27-.37-.392.319.662.051Z" fill="#FF2100" />
    <path d="m12.227 2.95.107-.612-.367.305.26.307Z" fill="#FF8700" />
    <path d="m13.444 2.768-.305-.137-.022.355.327-.218Z" fill="#FF8C00" />
    <path d="m12.984 2.567-.414.228.546.19-.132-.418Z" fill="#FF8A00" />
    <path d="m10.193 2.058.015.196.06-.188-.075-.008Z" fill="#FF8200" />
    <path d="m14.812 3.847.142.233.072-.236-.214.003Z" fill="#FF8F00" />
    <path d="m12.797 2.495-.307-.108.08.408.227-.3Z" fill="#FF8900" />
    <path d="m12.57 2.795.414-.228-.187-.072-.227.3Z" fill="#FF8900" />
    <path d="m10.85 2.782.225-.328-.363-.07.137.398Z" fill="#FF8200" />
    <path d="m13.887 4.801-.274-.385-.049.4.323-.015Z" fill="#FF8A00" />
    <path d="m6.282 12.57.58-.31-.578.12-.002.19Z" fill="#FF0C00" />
    <path d="m12.57 2.795-.08-.408-.155-.049.236.457Z" fill="#FF8900" />
    <path d="m13.743 2.918-.232.237.524-.075-.292-.162Z" fill="#FF8D00" />
    <path d="m7.5 11.246.008-.472-.309.09.301.382Z" fill="#FF1300" />
    <path d="m6.232 12.753.078.06-.028-.243-.05.183Z" fill="#FF0C00" />
    <path d="m11.967 2.643.023-.4-.341.264.318.136Z" fill="#FF8700" />
    <path d="m14.042 4.129-.202-.404-.156.295.358.109Z" fill="#FF8D00" />
    <path d="m14.497 3.754-.054.368.369-.275-.315-.093Z" fill="#FF8F00" />
    <path d="m6.41 12.048-.126.333.578-.12-.452-.213Z" fill="#FF0D00" />
    <path d="m6.862 12.26-.58.31.028.242.552-.551Z" fill="#FF0D00" />
    <path
      d="m10.208 2.254.229.375.276-.245-.505-.13ZM10.068 2.39l-.127.334.496-.095-.37-.238Z"
      fill="#FF8200"
    />
    <path d="m10.537 2.993-.385.058.254.295.13-.353Z" fill="#FF8100" />
    <path d="m14.041 4.129.261.272.141-.28-.402.008Z" fill="#FF8D00" />
    <path d="m14.867 3.64-.37.114.315.093.055-.207Z" fill="#FF8F00" />
    <path d="m13.444 2.768-.327.218.394.169-.066-.387Z" fill="#FF8C00" />
    <path d="m12.848 3.527.212.273.165-.476-.377.203Z" fill="#FF8900" />
    <path
      d="m10.85 2.782-.413-.153.1.364.312-.21ZM12.541 4.773l-.04.474.339-.103-.299-.371Z"
      fill="#FF8200"
    />
    <path d="m11.34 2.723.309-.216-.574-.053.264.27Z" fill="#FF8400" />
    <path d="m11.495 3.308.351.245.088-.396-.439.15Z" fill="#FF8300" />
    <path d="m14.812 3.847-.369.275.417.14-.048-.415Z" fill="#FF8F00" />
    <path d="m14.17 3.777-.33-.052.202.404.128-.352Z" fill="#FF8E00" />
    <path
      d="m11.075 2.454-.225.328.49-.059-.265-.269ZM11.34 2.723l-.49.06.285.308.205-.368Z"
      fill="#FF8400"
    />
    <path d="m10.643 2.019.07.365.125-.348-.195-.017Z" fill="#FF8300" />
    <path d="m10.85 2.782-.137-.398-.276.245.412.153Z" fill="#FF8200" />
    <path d="m10.059 3.563-.172.422.44-.114-.268-.308Z" fill="#FF7C00" />
    <path d="m11.135 3.09.36.218.164-.384-.524.167Z" fill="#FF8200" />
    <path
      d="m14.32 3.255.177.499.1-.313-.278-.186ZM14.444 4.122l.053-.368-.327.023.274.345Z"
      fill="#FF8E00"
    />
    <path d="m13.278 4.16.335.256.07-.396-.405.14Z" fill="#FF8A00" />
    <path d="m14.584 4.538-.281-.137-.27.689.551-.552Z" fill="#FF8E00" />
    <path
      d="m10.798 3.296.051-.514-.312.21.26.304ZM10.797 3.296l.169.48.191-.316-.36-.164Z"
      fill="#FF8000"
    />
    <path d="m10.152 3.051.285-.422-.496.095.21.327Z" fill="#FF7F00" />
    <path d="m10.537 2.993-.131.353.392-.05-.261-.303Z" fill="#FF8100" />
    <path d="m9.941 2.724-.252.666.463-.339-.21-.327Z" fill="#FF8000" />
    <path d="m10.06 3.563.092-.512-.463.339.37.173Z" fill="#FF7C00" />
    <path
      d="m14.041 4.129.402-.007-.273-.345-.129.352ZM14.303 4.401l-.297.1-.12.3.417-.4Z"
      fill="#FF8D00"
    />
    <path d="m12.93 6.193.55-.552-.454.097-.097.455Z" fill="#FF7A00" />
    <path d="m13.887 4.801-.323.015.067.423.256-.438Z" fill="#FF8A00" />
    <path d="m10.797 3.296.36.164-.022-.37-.338.206Z" fill="#FF8000" />
    <path d="m11.197 4.237.29-.09-.25-.218-.04.308Z" fill="#FF7C00" />
    <path
      d="m10.797 3.296.338-.205-.286-.309-.052.514ZM10.798 3.296l-.392.05.252.55.14-.6Z"
      fill="#FF8000"
    />
    <path d="m7.138 11.985.275-.276-.394-.12.119.396Z" fill="#FF0F00" />
    <path d="m7.018 11.59-.342.178.461.217-.119-.395Z" fill="#FF1000" />
    <path d="m6.676 11.768.343-.178-.356-.208.013.386Z" fill="#FF0E00" />
    <path d="m7.925 10.167-.391.02.162.302.229-.322Z" fill="#FF1D00" />
    <path d="m7.5 11.246-.46-.102-.021.446.481-.344Z" fill="#FF1300" />
    <path d="m6.662 11.382-.252.666.266-.28-.014-.386Z" fill="#FF1000" />
    <path d="m6.676 11.768-.266.28.452.213-.186-.493Z" fill="#FF0E00" />
    <path d="m7.2 10.865.047-.41-.332.26.284.15Z" fill="#FF1400" />
    <path d="m7.019 11.59.021-.446-.377.238.356.208Z" fill="#FF1000" />
    <path d="m7.696 10.489-.163-.301-.286.267.45.034Z" fill="#FF1900" />
    <path d="m7.2 10.865-.285-.15.125.429.16-.28Z" fill="#FF1400" />
    <path d="m7.247 10.455-.048.41.309-.09-.261-.32Z" fill="#FF1700" />
    <path d="m7.5 11.246-.3-.381-.16.28.46.1Z" fill="#FF1300" />
    <path d="m7.793 10.899.172.258.276-.275-.448.017Z" fill="#FF1600" />
    <path d="m6.915 10.716.332-.261-.08-.405-.252.666Z" fill="#FF1400" />
    <path d="m9.068 10.054.203-.348-.39.005.187.343Z" fill="#FF2600" />
    <path d="m7.476 9.786.058.402.39-.02-.448-.382Z" fill="#FF1E00" />
    <path d="m7.696 10.489-.45-.034.262.32.188-.286Z" fill="#FF1900" />
    <path d="m9.068 10.054-.188-.343-.42.35.608-.007Z" fill="#FF2600" />
    <path d="m8.325 9.492-.456-.024.27.37.186-.346Z" fill="#FF2500" />
    <path d="m8.417 8.053.135-.426-.381.138.246.288Z" fill="#FF3800" />
    <path d="m7.534 10.188-.058-.402-.309.264.367.138Z" fill="#FF1A00" />
    <path d="m7.925 10.168.213-.33-.662-.052.449.382Z" fill="#FF1D00" />
    <path d="m7.475 9.786.394-.318-.45-.084.056.402Z" fill="#FF1E00" />
    <path d="m13.84 3.725.33.052.15-.522-.48.47Z" fill="#FF8D00" />
    <path d="m13.423 3.765.417-.04-.21-.26-.207.3Z" fill="#FF8B00" />
    <path d="m12.227 2.95-.26-.307-.034.514.294-.207Z" fill="#FF8700" />
    <path d="m12.631 4.305-.46.154.37.314.09-.468Z" fill="#FF8500" />
    <path d="m13.613 4.416.429-.287-.358-.109-.071.396Z" fill="#FF8A00" />
    <path d="m14.302 4.401-.26-.272-.036.372.296-.1Z" fill="#FF8D00" />
    <path
      d="m13.423 3.765.207-.3-.405-.14.198.44ZM13.423 3.765l-.363.035.218.36.145-.395Z"
      fill="#FF8B00"
    />
    <path d="m13.254 4.54-.277-.208-.167.27.444-.063Z" fill="#F80" />
    <path d="m13.887 4.801-.256.438.402-.15-.146-.288Z" fill="#FF8A00" />
    <path d="m14.006 4.501.036-.372-.43.287.394.085Z" fill="#FF8C00" />
    <path d="m13.631 5.24-.47.053.32.348.15-.402Z" fill="#FF8600" />
    <path d="m14.303 4.401-.416.4.146.289.27-.689Z" fill="#FF8D00" />
    <path d="m13.613 4.416.274.385.12-.3-.394-.085Z" fill="#FF8A00" />
    <path d="m13.684 4.02-.261-.255-.145.396.406-.14Z" fill="#FF8C00" />
    <path d="m13.564 4.816.049-.4-.36.124.31.276Z" fill="#F80" />
    <path d="m13.06 3.8-.429-.003.345.535.084-.532Z" fill="#FF8A00" />
    <path d="m13.254 4.54.024-.38-.301.172.277.208Z" fill="#F80" />
    <path d="m12.632 3.797.216-.27-.624-.157.408.427Z" fill="#FF8700" />
    <path d="m11.495 3.308-.337.152.378.389-.04-.541Z" fill="#FF8300" />
    <path d="m13.254 4.54-.232.3.279.162-.047-.462Z" fill="#F80" />
    <path
      d="m13.613 4.416-.335-.255-.025.379.36-.124ZM13.06 3.8l-.083.532.3-.171-.217-.361Z"
      fill="#FF8A00"
    />
    <path d="m12.631 4.305-.09.468.27-.17-.18-.298Z" fill="#FF8500" />
    <path d="m13.564 4.816-.31-.276.047.462.263-.186Z" fill="#F80" />
    <path d="m13.3 5.002.331.237-.067-.423-.263.186Z" fill="#FF8600" />
    <path d="m13.481 5.641.552-.551-.402.15-.15.401Z" fill="#FF8300" />
    <path d="m12.84 5.144.32.149-.138-.453-.182.304Z" fill="#FF8100" />
    <path d="m13.481 5.641-.32-.348-.135.445.455-.097Z" fill="#FF8300" />
    <path d="m13.022 4.84.139.453.14-.29-.279-.163Z" fill="#FF8500" />
    <path d="m13.631 5.24-.33-.238-.14.29.47-.053Z" fill="#FF8600" />
    <path d="m11.87 5.441-.144-.34-.328.17.472.17Z" fill="#F70" />
    <path d="m12.17 5.293-.444-.192.143.34.3-.148Z" fill="#FF7B00" />
    <path
      d="m13.026 5.738.135-.445-.321-.15.186.595ZM12.501 5.247l-.07.602.32.068-.25-.67Z"
      fill="#FF7E00"
    />
    <path d="m13.022 4.84-.481-.067.299.37.182-.303Z" fill="#FF8500" />
    <path d="m12.43 5.849.071-.602-.332.046.261.556Z" fill="#FF7800" />
    <path d="m13.022 4.84-.212-.237-.269.17.48.067Z" fill="#FF8500" />
    <path d="m13.026 5.738-.186-.594-.338.103.524.491Z" fill="#FF7E00" />
    <path d="m11.486 4.147.505-.032-.456-.266-.049.298Z" fill="#FF7F00" />
    <path d="m12.501 5.247.04-.474-.47.2.43.274Z" fill="#FF7E00" />
    <path d="m10.501 6.28.367.217-.11-.412-.257.195Z" fill="#FF6200" />
    <path d="m11.126 6.837-.258-.34-.076.326.334.014Z" fill="#FF6100" />
    <path d="m13.254 4.54-.444.063.212.237.232-.3Z" fill="#F80" />
    <path d="m12.631 4.305.18.298.166-.271-.346-.027Z" fill="#FF8500" />
    <path d="m10.987 4.61-.033.428.431-.268-.398-.16Z" fill="#FF7800" />
    <path d="m12.072 4.973-.346.128.443.192-.098-.32Z" fill="#FF7D00" />
    <path
      d="m11.236 3.929-.078-.47-.192.318.27.152ZM11.695 4.367l.476.092-.18-.344-.296.252Z"
      fill="#FF7F00"
    />
    <path d="m12.171 4.459-.1.514.47-.2-.37-.314Z" fill="#FF8100" />
    <path
      d="m11.883 4.67-.498.1.34.331.159-.431ZM12.502 5.247l.25.67.274-.179-.524-.49Z"
      fill="#FF7E00"
    />
    <path d="m12.443 6.299.309-.382-.321-.068.012.45Z" fill="#FF7400" />
    <path d="m12.34 4.11-.35.005.181.344.17-.348Z" fill="#FF8400" />
    <path d="m11.884 4.67.287-.211-.476-.092.189.303Z" fill="#FF7E00" />
    <path d="M12.631 4.305v-.508l-.29.314.29.194Z" fill="#FF8500" />
    <path d="m11.933 3.157.29.213.004-.42-.294.207Z" fill="#FF8600" />
    <path d="m11.695 4.367-.291.096.48.207-.189-.303Z" fill="#FF7F00" />
    <path d="m12.072 4.973.1-.514-.288.21.188.304Z" fill="#FF7D00" />
    <path d="m10.987 4.61.398.16.019-.307-.417.148Z" fill="#FF7800" />
    <path d="m10.555 4.792-.38-.03.161.37.219-.34Z" fill="#FF7400" />
    <path d="m11.404 4.463.083-.316-.29.09.207.226Z" fill="#FF7C00" />
    <path d="m11.385 4.77-.431.268.444.233-.013-.501Z" fill="#FF7900" />
    <path d="m12.34 4.11-.169.349.46-.154-.29-.194Z" fill="#FF8400" />
    <path d="m11.99 4.115.213-.326-.357-.236.145.562Z" fill="#FF8200" />
    <path
      d="m12.631 4.305.346.027-.345-.535v.508ZM12.203 3.79l-.212.325.35-.004-.138-.322Z"
      fill="#FF8500"
    />
    <path d="m12.848 3.527-.217.27.429.003-.212-.273Z" fill="#FF8900" />
    <path d="m12.203 3.79.137.32.291-.313-.428-.008Z" fill="#FF8500" />
    <path
      d="m13.06 3.8.363-.035-.198-.44-.165.475ZM12.82 3.183l-.334-.021.362.365-.027-.344Z"
      fill="#FF8A00"
    />
    <path d="m13.225 3.324.405.14-.12-.309-.285.17Z" fill="#FF8B00" />
    <path d="m12.82 3.183.028.344.377-.203-.404-.14Z" fill="#FF8A00" />
    <path d="m14.035 3.08-.524.075.12.31.404-.385Z" fill="#FF8E00" />
    <path d="m13.444 2.768.067.387.232-.237-.299-.15Z" fill="#FF8C00" />
    <path d="m12.82 3.183.405.141-.108-.338-.296.197Z" fill="#FF8A00" />
    <path d="m13.117 2.986.108.338.286-.169-.394-.17Z" fill="#FF8B00" />
    <path d="m10.296 4.401.259.391.174-.573-.433.182Z" fill="#FF7600" />
    <path d="m11.883 4.67-.48-.207-.018.307.498-.1Z" fill="#FF7E00" />
    <path d="m11.459 5.973.33-.045-.2-.283-.13.328Z" fill="#FF6E00" />
    <path d="m12.501 5.247-.43-.274.098.32.332-.046Z" fill="#FF7E00" />
    <path d="m11.99 4.115-.144-.562-.31.296.455.266Z" fill="#FF8200" />
    <path d="m11.846 3.553.357.236.02-.42-.377.184Z" fill="#FF8400" />
    <path d="m12.223 3.37-.02.42.428.007-.408-.427Z" fill="#FF8700" />
    <path d="m12.486 3.162-.262.208.624.157-.362-.365Z" fill="#F80" />
    <path d="m11.495 3.308.439-.15-.275-.234-.164.384Z" fill="#FF8300" />
    <path d="m11.846 3.553.377-.183-.29-.213-.087.396Z" fill="#FF8400" />
    <path d="m13.116 2.986-.546-.19.25.387.296-.197Z" fill="#FF8B00" />
    <path d="m12.227 2.95-.003.42.262-.208-.259-.212Z" fill="#FF8700" />
    <path d="m12.227 2.95.26.212.083-.367-.343.155Z" fill="#FF8700" />
    <path d="m12.82 3.183-.25-.388-.084.367.335.021Z" fill="#FF8A00" />
    <path d="m10.954 5.038-.4-.246.124.51.276-.264Z" fill="#FF7400" />
    <path d="m11.039 5.403-.25.361.462-.052-.212-.309Z" fill="#FF7100" />
    <path d="m11.99 4.115-.504.032.209.22.296-.252Z" fill="#FF8200" />
    <path d="m11.236 3.929.25.218.05-.298-.3.08Z" fill="#FF7F00" />
    <path d="m11.158 3.46.078.469.3-.08-.378-.39Z" fill="#FF8100" />
    <path
      d="m10.966 3.777.231.46.04-.308-.27-.152ZM10.966 3.777l-.308.12.07.322.238-.442Z"
      fill="#FF7E00"
    />
    <path d="m10.954 5.038.033-.427-.432.181.399.246Z" fill="#FF7400" />
    <path d="m10.729 4.22.258.39.21-.373-.468-.018Z" fill="#FF7A00" />
    <path d="m10.987 4.61-.258-.39-.174.572.432-.181Z" fill="#FF7800" />
    <path
      d="m11.197 4.237-.231-.46-.237.442.468.018ZM10.658 3.896l-.252-.55-.078.525.33.025Z"
      fill="#FF7C00"
    />
    <path d="m10.176 4.761-.424-.296.106.506.318-.21Z" fill="#FF7200" />
    <path d="m10.555 4.792-.258-.391-.121.36.379.031Z" fill="#FF7400" />
    <path d="m10.406 3.346-.347.217.269.308.078-.525Z" fill="#FF7E00" />
    <path d="m9.563 3.723.496-.16-.37-.173-.126.333Z" fill="#FF7900" />
    <path d="m10.136 6.287-.059-.589-.294.296.353.293Z" fill="#FF5F00" />
    <path d="m10.792 6.823.076-.326-.453.159.377.167Z" fill="#FF5E00" />
    <path d="m9.887 3.985.12.292.32-.406-.44.114Z" fill="#FF7800" />
    <path d="m9.362 5.5.09.448.252-.364-.342-.084Z" fill="#FF6400" />
    <path d="m10.415 6.656-.28-.37-.105.35.385.02Z" fill="#FF5D00" />
    <path d="m11.038 5.403.36-.132-.444-.233.084.365Z" fill="#FF7100" />
    <path d="m9.858 4.97.478.162-.16-.37-.318.209Z" fill="#FF6D00" />
    <path d="m10.336 5.131.038.402.304-.23-.342-.171Z" fill="#FF6F00" />
    <path d="m10.788 5.764-.11-.462-.305.231.415.231Z" fill="#FF6B00" />
    <path d="m10.954 5.038-.276.264.36.101-.084-.365Z" fill="#FF7400" />
    <path d="m9.55 4.771-.238.38.333.092-.096-.472Z" fill="#FF6E00" />
    <path d="m11.25 5.712-.461.052.322.448.14-.5Z" fill="#FF6F00" />
    <path d="m9.705 5.584.372.114-.051-.335-.321.22Z" fill="#FF6500" />
    <path d="m11.11 6.212-.322-.448-.03.321.353.127Z" fill="#FF6900" />
    <path d="m8.892 7.917-.02.33.537-.037-.517-.293Z" fill="#FF3D00" />
    <path d="m10.501 6.28-.365.007.28.369.085-.376Z" fill="#FF6200" />
    <path d="m11.11 6.212-.242.285.531.14-.288-.425Z" fill="#FF6900" />
    <path d="m11.11 6.212-.352-.127.11.412.243-.285Z" fill="#FF6900" />
    <path d="m10.788 5.764.25-.36-.36-.102.11.462Z" fill="#FF6B00" />
    <path d="m11.398 5.271-.36.132.213.309.147-.441Z" fill="#FF7500" />
    <path d="m10.788 5.764-.396.15.366.171.03-.32Z" fill="#FF6B00" />
    <path d="m10.525 7.025.386.232-.12-.434-.266.202Z" fill="#FF5900" />
    <path d="m10.415 6.656.453-.159-.367-.217-.086.376Z" fill="#FF5D00" />
    <path d="m12.43 5.849-.302.192.315.258-.012-.45Z" fill="#FF7800" />
    <path d="m10.392 5.914.396-.15-.415-.23.019.38Z" fill="#F60" />
    <path d="m11.755 6.633-.356.004.164.297.192-.301Z" fill="#FF6A00" />
    <path d="m10.03 6.637-.187.309.332.12-.145-.43Z" fill="#FF5900" />
    <path d="m10.91 7.256.436.112-.22-.53-.215.418Z" fill="#FF5A00" />
    <path d="M10.175 7.067 9.91 7.3l.494.202-.23-.436Z" fill="#F50" />
    <path d="m11.398 5.271-.147.44.339-.066-.192-.374Z" fill="#FF7500" />
    <path d="m11.999 6.374.13-.333-.34-.113.21.446Z" fill="#FF6F00" />
    <path d="m12.43 5.849-.26-.556-.3.148.56.408Z" fill="#FF7800" />
    <path d="m11.4 6.637-.532-.14.258.34.273-.2Z" fill="#F60" />
    <path d="m10.175 7.067.23.436.12-.478-.35.042Z" fill="#F50" />
    <path d="m11.11 6.212.364.094-.015-.333-.348.239Z" fill="#FF6900" />
    <path d="m11.486 4.147-.082.316.291-.096-.209-.22Z" fill="#FF7F00" />
    <path d="m10.987 4.61.417-.147-.207-.226-.21.374Z" fill="#FF7800" />
    <path d="m11.884 4.67-.158.431.345-.128-.187-.303Z" fill="#FF7E00" />
    <path d="m11.385 4.77.013.501.328-.17-.34-.331Z" fill="#FF7900" />
    <path d="m10.658 3.896.308-.12-.168-.48-.14.6Z" fill="#FF7C00" />
    <path d="m10.328 3.871.4.348-.07-.323-.33-.025Z" fill="#FF7B00" />
    <path d="m10.152 3.051-.093.512.347-.217-.254-.295Z" fill="#FF7F00" />
    <path d="m9.753 4.465-.442-.076.238.382.204-.306Z" fill="#FF7200" />
    <path d="m10.006 4.277.17.484.12-.36-.29-.124Z" fill="#FF7500" />
    <path d="m9.563 3.723-.126.333.45-.07-.324-.263Z" fill="#FF7900" />
    <path d="m9.55 4.771-.24-.382-.125.333.364.05Z" fill="#FF6E00" />
    <path d="m9.437 4.056.316.409.134-.48-.45.07Z" fill="#FF7500" />
    <path d="m10.006 4.277-.12-.292-.134.48.254-.188Z" fill="#FF7500" />
    <path d="m10.176 4.761-.17-.484-.254.188.424.296Z" fill="#FF7200" />
    <path d="m10.06 3.563-.497.16.324.262.172-.422Z" fill="#FF7C00" />
    <path d="m10.328 3.871-.322.406.29.124.032-.53Z" fill="#FF7B00" />
    <path d="m9.645 5.243.38.12-.167-.392-.213.272Z" fill="#FF6900" />
    <path d="m9.806 6.368-.024-.374-.303.286.327.088Z" fill="#FF5B00" />
    <path d="m10.175 7.067.24-.411-.385-.02.145.43Z" fill="#F50" />
    <path d="m10.792 6.823-.377-.167.11.369.267-.202Z" fill="#FF5E00" />
    <path d="m9.312 5.15.05.35.283-.257-.333-.092Z" fill="#FF6800" />
    <path d="m9.753 4.465-.316-.41-.126.334.442.076Z" fill="#FF7200" />
    <path d="m9.859 4.97-.106-.505-.204.306.31.2Z" fill="#FF6D00" />
    <path d="m9.843 6.946-.332.145.399.21-.067-.355Z" fill="#FF5300" />
    <path d="m9.109 5.746-.023.398.367-.196-.344-.202Z" fill="#FF5F00" />
    <path d="m9.109 5.746-.429.308.406.09.023-.398Z" fill="#FF5F00" />
    <path d="m9.312 5.15-.128-.428-.252.666.38-.237Z" fill="#FF6800" />
    <path d="m9.362 5.5-.43-.112.177.358.253-.246Z" fill="#FF6400" />
    <path d="m10.026 5.363.348.17-.038-.402-.31.232Z" fill="#FF6A00" />
    <path d="m9.858 4.97.167.393.311-.232-.478-.16Z" fill="#FF6D00" />
    <path d="m9.806 6.368-.179.288.403-.02-.224-.268Z" fill="#FF5B00" />
    <path d="m10.136 6.287.256-.373-.315-.216.059.589Z" fill="#FF5F00" />
    <path d="m10.374 5.533-.348-.17.051.335.297-.165Z" fill="#FF6A00" />
    <path d="m10.758 6.085-.366-.17.109.365.257-.195Z" fill="#FF6700" />
    <path d="m10.373 5.533-.296.165.315.216-.018-.38Z" fill="#FF6A00" />
    <path d="m10.392 5.914-.256.373.365-.007-.11-.366Z" fill="#F60" />
    <path d="m8.552 7.627.034-.467-.41.226.376.24Z" fill="#FF3F00" />
    <path d="m7.413 11.709.552-.552-.465.089-.087.463Z" fill="#F10" />
    <path d="m7.793 10.899-.293.347.465-.089-.172-.258Z" fill="#FF1600" />
    <path
      d="m8.136 10.5.105.381.275-.275-.38-.105ZM8.136 10.5l-.44-.011.097.41.343-.398Z"
      fill="#FF1B00"
    />
    <path d="m7.793 10.899-.097-.41-.188.285.285.125Z" fill="#FF1600" />
    <path d="m8.136 10.5-.343.399.448-.017-.105-.381Z" fill="#FF1B00" />
    <path d="m7.5 11.246.293-.347-.285-.124-.008.47Z" fill="#FF1300" />
    <path d="m8.792 10.33.276-.276-.607.008.331.268Z" fill="#FF2100" />
    <path d="m7.696 10.489.44.012-.211-.334-.229.322Z" fill="#FF1900" />
    <path d="m10.136 6.287-.33.08.224.27.106-.35Z" fill="#FF5F00" />
    <path d="m11.473 6.306-.074.331.356-.004-.282-.327Z" fill="#FF6B00" />
    <path d="m10.526 7.025-.121.478.506-.246-.385-.232Z" fill="#FF5900" />
    <path d="m11.347 7.368.48-.072-.264-.362-.216.434Z" fill="#FF5D00" />
    <path d="m10.187 7.946.329-.113-.111-.33-.218.443Z" fill="#FF4900" />
    <path d="m11.275 7.848.072-.48-.236.21.164.27Z" fill="#FF5700" />
    <path d="m11.126 6.837-.334-.014.119.434.215-.42Z" fill="#FF6100" />
    <path d="m10.796 7.602-.28.231.322.13-.041-.361Z" fill="#FF5400" />
    <path d="m11.274 7.848.552-.552-.48.072-.072.48Z" fill="#FF5700" />
    <path d="m11.985 6.904-.422.03.263.362.16-.392Z" fill="#FF6900" />
    <path d="m11.563 6.934.422-.03-.23-.271-.192.301Z" fill="#FF6500" />
    <path d="m11.826 7.296.552-.551-.393.159-.159.392Z" fill="#FF6400" />
    <path
      d="m11.985 6.904.393-.16-.38-.37-.013.53ZM11.11 6.212l.29.425.073-.33-.362-.095Z"
      fill="#FF6900"
    />
    <path d="m11.126 6.837.437.097-.164-.297-.273.2Z" fill="#FF6100" />
    <path
      d="m12.443 6.299-.444.075.379.37.065-.445ZM12.128 6.04l-.259-.599-.08.487.34.113Z"
      fill="#FF7400"
    />
    <path d="m11.985 6.904.014-.53-.244.259.23.27Z" fill="#FF6900" />
    <path d="m11.473 6.306.282.327.244-.26-.526-.067Z" fill="#FF6B00" />
    <path d="m12.378 6.744.552-.551-.487.106-.065.445Z" fill="#FF6F00" />
    <path d="m12.752 5.917-.31.382.487-.106-.178-.276Z" fill="#FF7B00" />
    <path d="m11.59 5.645.2.283.08-.487-.28.204Z" fill="#FF7300" />
    <path d="m11.473 6.306.526.068-.21-.446-.316.378Z" fill="#FF6B00" />
    <path d="m12.443 6.3-.314-.26-.13.334.444-.075Z" fill="#FF7400" />
    <path d="m11.87 5.441.259.6.302-.192-.561-.408Z" fill="#F70" />
    <path d="m11.398 5.271.192.374.28-.204-.472-.17Z" fill="#FF7500" />
    <path d="m11.459 5.973.131-.328-.34.067.209.26Z" fill="#FF6E00" />
    <path d="m11.11 6.212.349-.24-.208-.26-.14.5Z" fill="#FF6900" />
    <path d="m11.473 6.306.316-.378-.33.045.014.333Z" fill="#FF6B00" />
    <path d="m9.479 6.28.304-.286-.33-.046.026.332Z" fill="#FF5A00" />
    <path d="m9.086 6.144.146.593.247-.457-.393-.136Z" fill="#FF5900" />
    <path d="m9.705 5.584.078.41.294-.296-.372-.114Z" fill="#FF6500" />
    <path d="m9.91 7.3-.34.163.318.229.022-.391Z" fill="#FF4F00" />
    <path d="m9.704 5.584-.059-.341-.283.257.342.084Z" fill="#FF6500" />
    <path d="m9.511 7.09-.575-.1.144.362.431-.261Z" fill="#FF4E00" />
    <path d="m9.312 5.15.237-.379-.364-.05.127.43Z" fill="#FF6800" />
    <path d="m9.453 5.948.33.046-.078-.41-.252.364Z" fill="#FF5E00" />
    <path d="m8.68 6.054.429-.308-.177-.358-.252.666Z" fill="#FF5800" />
    <path d="m9.453 5.948-.367.196.393.136-.026-.332Z" fill="#FF5E00" />
    <path d="m9.807 8.09-.313-.259-.085.38.398-.122Z" fill="#FF4300" />
    <path d="m8.68 6.054-.252.666.37-.24-.118-.426Z" fill="#FF5800" />
    <path d="m8.798 6.48.138.51.296-.253-.434-.258Z" fill="#FF5200" />
    <path d="m8.936 6.99-.508-.27.157.44.35-.17Z" fill="#FF4B00" />
    <path d="m9.91 7.3.265-.233-.332-.121.067.355Z" fill="#FF4F00" />
    <path d="m10.025 5.363-.38-.12.06.34.32-.22Z" fill="#FF6A00" />
    <path d="m9.55 4.771.095.472.214-.272-.31-.2Z" fill="#FF6E00" />
    <path d="m8.932 5.388.43.112-.05-.35-.38.238Z" fill="#FF6300" />
    <path d="M9.453 5.948 9.362 5.5l-.253.246.344.202Z" fill="#FF5E00" />
    <path d="m8.586 7.16-.158-.44-.252.666.41-.226Z" fill="#FF4600" />
    <path d="m8.108 9.012.356.082-.105-.356-.25.274Z" fill="#FF2900" />
    <path d="m9.479 6.28-.247.457.395-.081-.148-.376Z" fill="#FF5A00" />
    <path d="m9.627 6.656-.395.081.28.354.115-.435Z" fill="#FF5600" />
    <path d="m9.783 5.994.023.374.33-.081-.353-.293Z" fill="#FF6000" />
    <path d="m9.479 6.28.148.376.18-.288-.328-.088Z" fill="#FF5A00" />
    <path d="m8.68 6.054.119.425.287-.335-.406-.09Z" fill="#FF5800" />
    <path d="m9.57 7.463-.49-.11.414.478.076-.368Z" fill="#FF4A00" />
    <path d="m10.03 6.637-.403.019.216.29.187-.31Z" fill="#FF5900" />
    <path d="m9.511 7.09.332-.144-.216-.29-.116.435Z" fill="#FF4E00" />
    <path d="m9.91 7.3-.022.392.517-.189-.495-.202Z" fill="#FF4F00" />
    <path d="m10.175 7.067.35-.042-.11-.37-.24.412Z" fill="#F50" />
    <path d="m9.91 7.3-.399-.209.06.372.339-.162Z" fill="#FF4F00" />
    <path d="m9.08 7.352.49.11-.059-.371-.431.261Z" fill="#FF4700" />
    <path d="m8.871 7.596-.285-.436-.034.467.32-.03Z" fill="#FF4200" />
    <path d="m8.936 6.99.575.1-.28-.353-.295.253Z" fill="#FF4B00" />
    <path d="m8.722 9.353.158.358.193-.59-.35.232Z" fill="#FF2A00" />
    <path d="m10.445 8.184.07-.35-.329.112.26.238Z" fill="#FF4900" />
    <path d="m9.494 7.831.394-.14-.318-.228-.076.368Z" fill="#F40" />
    <path d="m10.405 7.503-.517.189.299.254.218-.443Z" fill="#FF5100" />
    <path d="m10.839 7.963-.323-.13-.07.351.393-.22Z" fill="#FF5000" />
    <path d="m10.839 7.963-.116.436.552-.551-.436.115Z" fill="#FF5000" />
    <path d="m11.563 6.934-.437-.097.22.531.217-.434Z" fill="#FF6500" />
    <path d="m11.111 7.578-.273.385.436-.115-.163-.27Z" fill="#FF5800" />
    <path d="m10.723 8.4.116-.437-.394.221.278.215Z" fill="#FF4A00" />
    <path d="m11.11 7.578-.2-.321-.114.345.315-.024Z" fill="#FF5800" />
    <path d="m9.69 8.477-.29.169.334.245-.044-.414Z" fill="#FF3D00" />
    <path d="m10.006 8.637.165.314.186-.366-.35.052Z" fill="#FF3F00" />
    <path d="m10.1 8.293.086-.347-.379.143.294.204Z" fill="#F40" />
    <path d="m10.723 8.4-.278-.216-.088.4.366-.185Z" fill="#FF4A00" />
    <path d="m10.171 8.95.552-.55-.366.185-.186.366Z" fill="#FF3D00" />
    <path d="m9.888 7.692-.08.397.378-.143-.298-.254Z" fill="#FF4A00" />
    <path d="m9.073 9.121.045-.654-.323.472.278.182Z" fill="#FF2F00" />
    <path d="m9.734 8.891.438.06-.165-.314-.273.254Z" fill="#FF3800" />
    <path d="m10.357 8.585.088-.401-.344.109.256.292Z" fill="#FF4300" />
    <path d="m8.795 8.94-.073.413.35-.232-.277-.182Z" fill="#FF2F00" />
    <path
      d="m9.494 7.831.313.258.081-.397-.394.14ZM10.1 8.293l-.41.184.317.16.094-.344Z"
      fill="#F40"
    />
    <path d="m9.373 8.98-.023.33.546-.083-.523-.248Z" fill="#FF3400" />
    <path d="m9.734 8.891-.361.088.523.248-.162-.336Z" fill="#FF3800" />
    <path d="m10.357 8.585-.256-.292-.095.344.35-.052Z" fill="#FF4300" />
    <path d="m10.445 8.184-.259-.238-.085.347.344-.109Z" fill="#FF4900" />
    <path d="m9.118 8.467.255.512.028-.333-.283-.18Z" fill="#FF3800" />
    <path d="m7.703 9.11.31-.428-.342.036.032.392Z" fill="#FF2600" />
    <path d="m9.271 9.706.349-.204-.27-.192-.079.396Z" fill="#FF2B00" />
    <path
      d="m10.172 8.95-.438-.059.162.336.276-.276ZM9.69 8.477l.044.414.273-.254-.317-.16Z"
      fill="#FF3D00"
    />
    <path d="m9.41 8.21-.292.257.283.179.008-.436Z" fill="#FF3E00" />
    <path d="m9.494 7.831-.602.086.517.293.085-.379Z" fill="#F40" />
    <path d="m9.896 9.227-.546.083.27.192.276-.275Z" fill="#FF3600" />
    <path d="m9.073 9.121.277.19.023-.332-.3.142Z" fill="#FF2F00" />
    <path d="m9.118 8.467-.045.654.3-.142-.255-.512Z" fill="#FF3800" />
    <path d="m8.795 8.94-.33.154.257.26.073-.415Z" fill="#FF2F00" />
    <path d="m7.42 9.384-.253.666.309-.264-.057-.402Z" fill="#F20" />
    <path d="m7.925 10.167.211.334.325-.44-.536.106Z" fill="#FF1D00" />
    <path d="m9.35 9.31-.47.401.391-.005.078-.396Z" fill="#FF3000" />
    <path d="m9.35 9.31-.277-.189-.193.59.47-.4Z" fill="#FF3000" />
    <path d="m9.068 10.054.552-.552-.348.204-.204.348Z" fill="#FF2600" />
    <path d="m8.325 9.492.223.248.174-.387-.397.14Z" fill="#FF2500" />
    <path d="m8.138 9.838.323.224.088-.322-.41.098Z" fill="#FF2100" />
    <path d="m8.516 10.606-.055-.544-.325.439.38.105Z" fill="#FF1D00" />
    <path d="m8.548 9.74-.087.322.42-.351-.333.029Z" fill="#FF2400" />
    <path d="m9.734 8.891-.333-.245-.028.333.361-.088Z" fill="#FF3800" />
    <path d="m9.409 8.21-.008.436.29-.169-.282-.267Z" fill="#FF3E00" />
    <path d="m9.807 8.09-.398.12.281.267.117-.388Z" fill="#FF4300" />
    <path d="m9.494 7.831-.415-.479-.208.244.623.235Z" fill="#F40" />
    <path d="m8.17 7.765.382-.138-.376-.241-.005.379Z" fill="#FF3B00" />
    <path d="m8.417 8.053.454.194.02-.33-.474.136Z" fill="#FF3800" />
    <path d="m8.722 9.353-.174.387.332-.029-.158-.358Z" fill="#FF2A00" />
    <path
      d="m8.46 10.062.056.544.276-.276-.331-.268ZM8.138 9.837l.41-.097-.222-.248-.188.345Z"
      fill="#FF2100"
    />
    <path d="m8.108 9.012-.095-.33-.31.428.405-.098Z" fill="#FF2900" />
    <path d="m7.925 10.168.536-.106-.323-.224-.213.33Z" fill="#FF1D00" />
    <path d="m7.671 8.718-.252.666.284-.274-.032-.392Z" fill="#FF2B00" />
    <path d="m8.108 9.012-.24.456.457.024-.217-.48Z" fill="#FF2900" />
    <path d="m8.464 9.094-.139.398.397-.139-.258-.259Z" fill="#FF2B00" />
    <path d="m8.36 8.738.435.201-.079-.4-.357.199Z" fill="#FF2E00" />
    <path d="m9.118 8.467-.402.072.08.4.322-.472Z" fill="#FF3800" />
    <path d="m8.326 9.492.138-.398-.356-.082.218.48Z" fill="#FF2500" />
    <path d="m8.417 8.053.474-.136-.34-.29-.134.426Z" fill="#FF3800" />
    <path d="m8.871 8.247-.454-.194.299.486.155-.292Z" fill="#FF3900" />
    <path d="m8.795 8.94-.436-.202.105.356.331-.155Z" fill="#FF2F00" />
    <path d="m9.409 8.21-.538.037.247.22.291-.257Z" fill="#FF3E00" />
    <path d="m8.417 8.053-.494-.001.247.325.247-.324Z" fill="#FF3800" />
    <path d="m7.419 9.384.45.084-.166-.357-.284.273Z" fill="#F20" />
    <path d="m8.17 8.377-.157.305.346.056-.19-.361Z" fill="#FF3200" />
    <path d="m8.716 8.539-.299-.486-.247.324.546.162Z" fill="#F30" />
    <path d="m9.118 8.467-.247-.22-.155.292.402-.072Z" fill="#FF3800" />
    <path d="m8.892 7.917-.02-.32-.32.03.34.29Z" fill="#FF3D00" />
    <path d="m9.232 6.737-.146-.593-.288.335.434.258Z" fill="#FF5100" />
    <path d="m8.936 6.99-.35.17.493.192-.143-.362Z" fill="#FF4B00" />
    <path d="m9.08 7.352-.495-.192.286.436.208-.244Z" fill="#FF4700" />
    <path d="m8.176 7.386-.253.666.248-.287.005-.38Z" fill="#FF4000" />
    <path d="M7.923 8.052h.494l-.246-.287-.248.287Z" fill="#FF3500" />
    <path d="m8.013 8.682-.216-.297-.126.333.342-.036Z" fill="#FF2D00" />
    <path d="m8.716 8.539-.546-.162.19.36.356-.198Z" fill="#F30" />
    <path d="m9.494 7.831-.623-.235.02.32.603-.085Z" fill="#F40" />
    <path d="m8.17 8.377-.247-.325-.126.333.373-.008Z" fill="#FF3200" />
    <path d="m8.936 6.99-.138-.51-.37.24.508.27Z" fill="#FF4B00" />
    <path d="m10.405 7.503.392.099.114-.345-.506.246Z" fill="#FF5100" />
    <path d="m8.108 9.012-.405.099.165.357.24-.456Z" fill="#FF2900" />
    <path d="m8.36 8.738-.347-.056.095.33.251-.274Z" fill="#FF2E00" />
    <path d="m7.797 8.385.216.297.157-.305-.373.008Z" fill="#FF3000" />
    <path d="m10.91 7.257.2.32.236-.209-.435-.111Z" fill="#FF5A00" />
    <path d="m10.838 7.963.273-.385-.315.024.042.361Z" fill="#FF5000" />
    <path d="m16.04 15.152.036.007.01-.075-.045.068Z" fill="#EE0050" />
    <path d="m16.259 5.005-.172-.093-.167.177.339-.084Z" fill="#FF9500" />
    <path d="m16.128 15.143-.043-.06.026.069.017-.01Z" fill="#EE0050" />
    <path d="m11.483 9.998-.224.382.59-.075-.366-.307Z" fill="#FF2E00" />
    <path d="m16.105 14.591.153.399.125-.16-.277-.239Z" fill="#EE004F" />
    <path d="m16.143 15.13-.058-.046.043.059.015-.013Z" fill="#EE0050" />
    <path d="m10.943 9.933-.02.03.085.035-.065-.065Z" fill="#FF2E00" />
    <path d="m16.01 15.132-.09-.226-.226-.091.317.317Z" fill="#EE0050" />
    <path d="m15.92 14.906.09.226.076-.048-.167-.178Z" fill="#EE0050" />
    <path d="m16.523 13.649.256-.446-.449.039.193.407Z" fill="#F0014A" />
    <path d="m16.076 15.159.035-.007-.025-.068-.01.075Z" fill="#EE0050" />
    <path d="m16.085 15.084.058.046.115-.14-.173.094Z" fill="#EE0050" />
    <path d="m17.564 12.618-.368-.01.3.2.068-.19Z" fill="#F20D3D" />
    <path d="m17.77 8.07-.052-.196-.245.309.296-.113Z" fill="#FD660C" />
    <path d="m11.85 10.305-.59.075.316.317.274-.392Z" fill="#FF2D00" />
    <path d="m17.422 12.997-.226-.39-.149.327.375.063Z" fill="#F10841" />
    <path d="m16.085 15.084.173-.094-.339-.084.166.178Z" fill="#EE0050" />
    <path d="m16.62 14.499.112-.17-.32-.164.208.334Z" fill="#EF004F" />
    <path d="m16.732 14.33-.114-.391-.206.226.32.165Z" fill="#EF004E" />
    <path d="m16.111 5.372.393-.042-.12-.164-.273.206Z" fill="#FF9400" />
    <path d="m17.112 8.962.174-.523-.413.12.239.403Z" fill="#FB5512" />
    <path d="m15.92 14.906.186-.315-.412.224.225.09Z" fill="#EE0050" />
    <path d="m16.111 5.372.023.34.37-.382-.393.042Z" fill="#FF9400" />
    <path d="m16.412 14.165.206-.226-.414-.069.208.295Z" fill="#EF004D" />
    <path d="m17.027 13.832-.204-.307-.205.414.41-.107Z" fill="#F0014A" />
    <path d="m16.336 7.962.186-.505-.4.01.214.495Z" fill="#FD6C08" />
    <path d="m17.274 13.341-.495-.138.42.295.075-.157Z" fill="#F10545" />
    <path d="m15.834 6.893-.249.255.57-.079-.321-.176Z" fill="#FF8001" />
    <path d="m17.912 8.78-.35-.182.016.317.334-.136Z" fill="#FB5712" />
    <path d="m15.996 13.543.208.327.318-.221-.526-.106Z" fill="#F00048" />
    <path d="m17.019 7.818.06.342.287-.275-.347-.067Z" fill="#FD6E08" />
    <path d="m17.027 13.832-.409.107.325.044.084-.151Z" fill="#F0014A" />
    <path d="m17.561 8.598.35.181-.033-.2-.317.019Z" fill="#FC5C0F" />
    <path d="m16.01 15.132.03.02.046-.068-.075.048Z" fill="#EE0050" />
    <path d="m15.616 13.923.133.52.308-.214-.441-.306Z" fill="#F0004A" />
    <path d="m17.532 11.074.425-.203-.309-.28-.116.483Z" fill="#F6272A" />
    <path d="m10.943 10.063.065-.065-.086.035.02.03Z" fill="#FF2E00" />
    <path d="m15.88 12.708-.024.345.328-.18-.304-.165Z" fill="#F2083D" />
    <path
      d="m11.008 9.998-.086-.035-.007.035h.093ZM10.915 9.998l.007.035.086-.035h-.092Z"
      fill="#FF2E00"
    />
    <path d="m11.101 9.774-.158.159.065.065.093-.224Z" fill="#FF2F00" />
    <path d="m16.105 14.591.399.074-.093-.5-.306.426Z" fill="#EE004F" />
    <path d="m17.112 8.962.013.353.348-.055-.361-.298Z" fill="#FB5512" />
    <path d="m15.694 14.815.412-.224-.357-.148-.055.372Z" fill="#EF004F" />
    <path
      d="m16.011 4.864-.317.317.226-.092.091-.225ZM16.041 4.844l.045.068-.01-.075-.035.007Z"
      fill="#FF9500"
    />
    <path d="m16.086 4.912.043-.06-.017-.008-.026.068Z" fill="#FF9500" />
    <path d="m16.086 4.912.026-.068-.035-.007.01.075Z" fill="#FF9500" />
    <path d="m15.92 14.906.338.084-.152-.399-.187.315Z" fill="#EE0050" />
    <path d="m12.373 9.581.121.265.14-.44-.26.175Z" fill="#FF3400" />
    <path d="m16.086 4.912-.045-.068-.03.02.075.048Z" fill="#FF9500" />
    <path d="m12.297 10.465.344.256.002-.37-.346.114Z" fill="#FF2C01" />
    <path d="m15.766 5.569.345-.197-.417-.191.072.388Z" fill="#FF9200" />
    <path d="m15.378 5.497.388.072-.071-.388-.317.316Z" fill="#FF9000" />
    <path d="m11.951 9.838-.468.16.367.307.101-.467Z" fill="#FF3000" />
    <path d="m16.733 5.666-.112-.17-.487.217.6-.047Z" fill="#FF9100" />
    <path d="m16.855 5.862-.122-.196-.229.503.351-.307Z" fill="#FF8F00" />
    <path d="m16.855 5.863-.35.306.438-.157-.088-.15Z" fill="#FF8F00" />
    <path d="m16.044 6.238.46-.069-.26-.167-.2.236Z" fill="#FF8C00" />
    <path d="m15.392 14.167.357.276-.133-.52-.224.244Z" fill="#F0004A" />
    <path d="m16.244 6.002.49-.336-.6.047.11.29Z" fill="#FF8F00" />
    <path d="m11.483 9.998-.224-.382-.158.158.382.224Z" fill="#FF2E00" />
    <path d="m16.327 6.563-.173.506.49-.213-.317-.293Z" fill="#FF8701" />
    <path
      d="m16.086 4.912.058-.047-.015-.012-.043.059ZM16.259 5.005l-.115-.14-.058.047.173.093ZM15.92 5.09l.192.282.147-.367-.339.084Z"
      fill="#FF9500"
    />
    <path d="m15.995 13.543.335-.301-.474-.19.14.491Z" fill="#F00048" />
    <path d="m15.26 8.435.349.038-.14-.32-.21.282Z" fill="#FD5D07" />
    <path d="m16.505 5.33-.37.383.486-.216-.116-.167Z" fill="#FF9400" />
    <path d="m11.63 9.662-.37-.046.223.382.146-.336Z" fill="#FF3000" />
    <path d="m16.244 6.002-.394-.068.194.304.2-.236Z" fill="#FF8F00" />
    <path d="m16.75 6.477.278-.313-.524.005.246.308Z" fill="#FF8801" />
    <path d="m17.028 6.164-.278.313.36-.16-.082-.153Z" fill="#FF8B01" />
    <path d="m14.955 12.788.254-.185-.435-.244.18.43Z" fill="#F40A37" />
    <path d="m17.047 12.934.227.407.082-.185-.309-.222Z" fill="#F10842" />
    <path d="m15.975 11.644.363-.36-.37-.004.007.364Z" fill="#F5192E" />
    <path d="m16.523 13.649.3-.124-.044-.322-.256.446Z" fill="#F0014A" />
    <path d="m17.23 11.077.101-.356-.371.22.27.136Z" fill="#F6262A" />
    <path d="m17.564 12.618-.246-.348-.122.338.368.01Z" fill="#F20D3D" />
    <path d="m17.217 11.378-.283.118.463.253-.18-.37Z" fill="#F5202E" />
    <path d="m17.496 7.187-.49-.108.27.478.22-.37Z" fill="#FE7905" />
    <path d="m17.318 12.27-.348.058.226.28.122-.338Z" fill="#F31139" />
    <path d="m17.718 12.122-.32-.373-.08.52.4-.147Z" fill="#F41537" />
    <path d="m17.619 12.454-.301-.184.246.348.055-.164Z" fill="#F3103B" />
    <path d="m16.97 12.328-.119.323.345-.043-.226-.28Z" fill="#F30F3A" />
    <path d="m16.535 13 .316-.348-.343.034.027.315Z" fill="#F10543" />
    <path d="m17.398 11.749.411.008-.262-.352-.15.344Z" fill="#F41A33" />
    <path d="m17.718 7.874-.352.01.107.299.245-.31Z" fill="#FD6B0A" />
    <path d="m17.578 8.915-.105.345.484-.136-.38-.21Z" fill="#FB5512" />
    <path d="m17.845 11.587-.298-.182.262.352.036-.17Z" fill="#F51E30" />
    <path d="m17.196 12.607.226.39.074-.189-.3-.2Z" fill="#F20C3E" />
    <path d="m17.619 12.454.051-.166-.352-.018.3.184Z" fill="#F3103B" />
    <path d="m16.694 7.179.312-.1-.361-.223.05.323Z" fill="#FE7C04" />
    <path d="m17.912 11.216-.365.19.331.01.034-.2Z" fill="#F6252B" />
    <path d="m17.648 10.592.31.279.016-.174-.326-.105Z" fill="#F73124" />
    <path d="m17.473 9.26.216.205.268-.34-.484.135Z" fill="#FB4E15" />
    <path d="m17.648 10.592.35-.244-.344-.099-.006.343Z" fill="#F73124" />
    <path d="m17.267 10.399.387-.15-.313-.17-.074.32Z" fill="#F83422" />
    <path d="m17.532 11.074.38.142.024-.172-.404.03Z" fill="#F6272A" />
    <path d="m17.997 10.348-.349.244.34-.069.01-.175Z" fill="#F83621" />
    <path d="m17.267 10.399.381.193.006-.343-.387.15Z" fill="#F83422" />
    <path d="m17.997 10.348.006-.175-.349.076.343.1Z" fill="#F83621" />
    <path d="m18.005 9.998-.35.251.348-.076.002-.175Z" fill="#F93E1E" />
    <path d="m15.075 9.28-.146.357.376-.084-.23-.272Z" fill="#FC490D" />
    <path d="m16.552 11.868-.214-.215-.253.337.467-.122Z" fill="#F41634" />
    <path d="m17.398 11.748.32.374.052-.196-.372-.178Z" fill="#F41A33" />
    <path d="m17.67 12.288.048-.166-.4.148.352.018Z" fill="#F31239" />
    <path d="m17.136 11.976.182.294.08-.521-.262.226Z" fill="#F41536" />
    <path d="m17.547 11.405.364-.189-.38-.142.016.331Z" fill="#F5212E" />
    <path d="m17.136 11.975-.166.353.348-.058-.182-.295Z" fill="#F41536" />
    <path d="m17.34 10.078.254-.33-.362-.015.108.345Z" fill="#F93C1E" />
    <path d="m17.532 11.074.404-.03.021-.173-.425.203Z" fill="#F6272A" />
    <path d="m17.957 9.125-.02-.174-.36-.036.38.21Z" fill="#FB5015" />
    <path d="m17.594 9.748.41.074-.007-.175-.403.101Z" fill="#F9431B" />
    <path d="m11.008 9.998-.065.066.158.158-.093-.224Z" fill="#FF2E00" />
    <path d="m17.366 7.885.304-.178-.394-.15.09.328Z" fill="#FD6C09" />
    <path d="m17.276 7.557.343-.015-.055-.165-.288.18Z" fill="#FE7307" />
    <path d="m16.953 7.45-.259-.271-.171.278.43-.008Z" fill="#FE7606" />
    <path d="m17.006 7.079.49.108L17.423 7l-.417.08Z" fill="#FE7D04" />
    <path d="m16.823 13.525.377-.027-.421-.295.044.322Z" fill="#F00248" />
    <path d="m17.423 6.999-.067-.16-.35.24.417-.08Z" fill="#FE7C04" />
    <path d="M11.483 9.998h-.475l.093.224.382-.224Z" fill="#FF2E00" />
    <path d="m11.26 10.38.223-.382-.382.224.158.158Z" fill="#FF2D00" />
    <path
      d="m17.11 6.317-.36.16.45.02-.09-.18ZM16.75 6.477l.204.26.246-.24-.45-.02Z"
      fill="#FF8801"
    />
    <path d="m17.006 7.078.35-.24-.402-.1.052.34Z" fill="#FE7D04" />
    <path d="m16.087 4.912-.075-.048-.092.225.167-.177Z" fill="#FF9500" />
    <path d="m15.766 5.569-.239.205.323.16-.084-.365Z" fill="#FF9200" />
    <path d="m16.954 6.737.402.102-.082-.185-.32.083Z" fill="#FE8302" />
    <path d="m16.62 14.499-.208-.334.092.5.116-.166Z" fill="#EF004F" />
    <path d="m17.109 13.679-.286-.154.205.307.08-.153Z" fill="#F00248" />
    <path d="m17.276 7.557-.27-.478-.052.37.322.108Z" fill="#FE7307" />
    <path d="m17.718 7.874-.047-.167-.305.178.352-.011Z" fill="#FD6B0A" />
    <path d="m17.912 8.78-.334.135.358.036-.024-.172Z" fill="#FB5712" />
    <path d="m17.69 9.465.284-.167-.017-.173-.268.34Z" fill="#FA4918" />
    <path d="m17.594 9.748-.253.33.313.171-.06-.501Z" fill="#F9431B" />
    <path d="m16.044 6.238.283.325.178-.394-.461.069Z" fill="#FF8C00" />
    <path d="m16.522 13.649-.192-.407-.334.301.526.106Z" fill="#F0014A" />
    <path d="m17.69 9.465-.096.283.403-.1-.308-.183Z" fill="#FA4918" />
    <path d="m17.047 12.934.309.222.066-.16-.375-.062Z" fill="#F10842" />
    <path d="m17.398 11.749.371.177.04-.169-.412-.008Z" fill="#F41A33" />
    <path d="m17.125 9.315.107.418.241-.473-.348.055Z" fill="#FB4D15" />
    <path d="m17.473 8.183.373.225-.037-.17-.336-.055Z" fill="#FD650C" />
    <path d="m17.473 8.183.336.055-.04-.168-.296.113Z" fill="#FD650C" />
    <path d="m18.005 9.998-.411-.25.06.501.351-.251Z" fill="#F93E1E" />
    <path d="m17.594 9.748.411.25-.002-.176-.41-.074Z" fill="#F9431B" />
    <path d="m17.473 8.183.088.415.285-.19-.373-.225Z" fill="#FD650C" />
    <path d="m16.33 13.242.449-.039-.244-.202-.205.24Z" fill="#F10345" />
    <path d="m16.657 7.794.362.024-.065-.369-.297.345Z" fill="#FD6F07" />
    <path d="m17.276 7.557.394.15-.05-.165-.344.015Z" fill="#FE7307" />
    <path d="m17.997 9.647-.01-.175-.297-.007.307.182Z" fill="#FA451A" />
    <path d="m17.028 6.164-.085-.152-.439.157.524-.005Z" fill="#FF8B01" />
    <path d="m16.75 6.477-.423.086.318.293.105-.38Z" fill="#FF8801" />
    <path d="m17.274 13.341-.227-.407-.268.27.495.137Z" fill="#F10545" />
    <path d="m17.532 11.074-.315.304.33.027-.015-.33Z" fill="#F6272A" />
    <path d="M11.008 9.998h.475l-.382-.224-.093.224Z" fill="#FF2E00" />
    <path d="m15.378 6.447.393.086-.3-.45-.093.364Z" fill="#FF8500" />
    <path d="m15.833 6.893.494-.33-.557-.03.063.36Z" fill="#FF8001" />
    <path d="m16.044 6.238-.573-.155.3.45.273-.295Z" fill="#FF8C00" />
    <path d="m16.733 8.153.14.407.207-.4-.347-.007Z" fill="#FD670A" />
    <path d="m17.397 11.749.15-.344-.33-.027.18.37Z" fill="#F41A33" />
    <path d="m17.845 11.587.033-.17-.331-.012.298.182Z" fill="#F51E30" />
    <path d="m17.974 9.298-.285.167.299.007-.014-.174Z" fill="#FA4C16" />
    <path d="m17.232 9.733.457-.268-.216-.205-.241.473Z" fill="#FA431A" />
    <path d="m17.08 8.16.393.023-.108-.298-.285.275Z" fill="#FD670B" />
    <path d="m17.287 8.44.275.158-.089-.415-.186.256Z" fill="#FC600D" />
    <path d="m17.846 8.408-.285.19.317-.019-.032-.17Z" fill="#FC5F0E" />
    <path d="m17.112 8.962.45-.364-.276-.159-.174.523Z" fill="#FB5512" />
    <path d="m16.733 5.666-.489.336.26.167.229-.503Z" fill="#FF9100" />
    <path d="m15.85 5.934.394.068-.11-.29-.284.222Z" fill="#FF8F00" />
    <path d="m16.057 14.23.147-.36-.588.053.44.306Z" fill="#EF004D" />
    <path d="m15.377 14.498.317.317.054-.372-.371.055Z" fill="#EF004C" />
    <path d="m15.475 13.054.109.406.273-.407h-.382Z" fill="#F2053F" />
    <path d="m15.616 13.923-.032-.463-.372.288.404.175Z" fill="#F0004A" />
    <path d="m16.504 14.665-.399-.074.278.238.12-.164Z" fill="#EE004F" />
    <path d="m15.748 14.443.357.148-.048-.362-.308.214Z" fill="#EF004E" />
    <path
      d="m15.766 5.569-.388-.072.15.277.238-.205ZM15.766 5.569l.368.144-.023-.34-.345.196Z"
      fill="#FF9200"
    />
    <path d="m15.47 6.083.058-.309-.467.04.41.27Z" fill="#FF8B00" />
    <path d="m16.694 7.179-.54-.11.369.388.171-.278Z" fill="#FE7C04" />
    <path d="m15.06 5.814-.316.317.368.051-.051-.368Z" fill="#FF8A00" />
    <path d="m15.85 5.934-.38.15.574.154-.194-.304Z" fill="#FF8F00" />
    <path d="m16.258 5.005-.147.367.273-.206-.126-.16Z" fill="#FF9500" />
    <path d="m15.528 5.774-.15-.277-.317.317.467-.04Z" fill="#FF8F00" />
    <path d="m16.111 5.372-.191-.283-.226.092.417.191Z" fill="#FF9400" />
    <path d="m16.154 7.07.54.109-.05-.323-.49.213Z" fill="#FE7E02" />
    <path d="m16.523 7.457.134.337.296-.344-.43.007Z" fill="#FE7705" />
    <path d="m17.019 7.818.347.067-.09-.328-.257.261Z" fill="#FD6E08" />
    <path d="m17.006 7.079-.312.1.26.27.052-.37Z" fill="#FE7D04" />
    <path d="m15.061 5.814.051.368.359-.099-.41-.269Z" fill="#FF8A00" />
    <path d="m15.378 6.447-.21.253.31.108-.1-.361Z" fill="#FF8500" />
    <path d="m14.583 7.17-.288.053-.057.295.345-.349Z" fill="#FF7001" />
    <path d="m15.47 6.083-.358.1.266.264.093-.364Z" fill="#FF8B00" />
    <path d="m12.635 9.406.261-.394-.317.085.056.31Z" fill="#FF3700" />
    <path d="m15.834 6.893-.356-.085.107.34.249-.255Z" fill="#FF8001" />
    <path d="m14.766 7.933-.272-.257-.015.406.287-.149Z" fill="#FE6403" />
    <path d="m15.174 7.178.304-.37-.31-.108.006.478Z" fill="#FF7602" />
    <path d="m13.999 12.685.114-.38-.317.149.203.231Z" fill="#F6102B" />
    <path d="m15.378 6.447.1.361.293-.275-.393-.086Z" fill="#FF8500" />
    <path d="m15.112 6.182.055.518.211-.253-.266-.265Z" fill="#FF8600" />
    <path d="m14.494 7.676.09-.507-.346.35.256.157Z" fill="#FF6602" />
    <path d="m15.834 6.893-.063-.36-.293.275.356.085Z" fill="#FF8001" />
    <path d="m16.327 6.563-.284-.325-.272.295.556.03Z" fill="#FF8701" />
    <path d="m14.744 6.131.07.391.298-.34-.368-.051Z" fill="#FF8300" />
    <path d="m14.11 6.765.27.158.047-.475-.317.317Z" fill="#FF7100" />
    <path d="m15.174 7.178-.42.23.345.132.075-.362Z" fill="#FF7602" />
    <path d="m15.418 7.576.167-.428-.411.03.244.398Z" fill="#FE7003" />
    <path d="m15.776 7.987-.5-.123.194.29.306-.167Z" fill="#FE6906" />
    <path d="m15.723 7.475-.305.101.357.41-.052-.51Z" fill="#FE7403" />
    <path d="m15.585 7.148.138.327.431-.406-.569.079Z" fill="#FF7A02" />
    <path d="m16.327 6.563-.494.33.321.176.173-.506Z" fill="#FF8701" />
    <path d="m15.305 11.82.36.132-.118-.429-.242.297Z" fill="#F6162C" />
    <path d="m15.167 6.7-.178.241.185.237-.007-.478Z" fill="#FF7F00" />
    <path d="m15.478 6.808-.304.37.41-.03-.106-.34Z" fill="#FF8001" />
    <path d="m16.154 7.07-.43.405.399-.007.031-.399Z" fill="#FE7E02" />
    <path d="m15.418 7.576-.244-.398-.075.362.32.036Z" fill="#FE7003" />
    <path d="m14.543 8.398.395.178.037-.355-.432.177Z" fill="#FE5805" />
    <path d="M15.418 7.576 15.1 7.54l.177.324.142-.288Z" fill="#FE7003" />
    <path d="m15.776 7.987-.358-.41-.142.287.5.123Z" fill="#FE6906" />
    <path d="m15.585 7.148-.167.428.305-.1-.138-.328Z" fill="#FF7A02" />
    <path d="m16.523 13.649.095.29.205-.414-.3.124Z" fill="#F0014A" />
    <path d="m17.2 13.498-.377.027.286.154.09-.181Z" fill="#F00347" />
    <path d="m17.047 12.934-.196-.282-.316.349.512-.067Z" fill="#F10842" />
    <path d="m16.97 12.328-.197-.238-.302.07.5.168Z" fill="#F30F3A" />
    <path d="M16.338 11.283v.37l.37-.363-.37-.007Z" fill="#F6202B" />
    <path d="m15.996 13.543-.14-.49-.272.407.412.083Z" fill="#F00048" />
    <path d="m17.047 12.934-.512.067.244.202.268-.269Z" fill="#F10842" />
    <path d="m16.184 12.872.351.129-.027-.315-.324.186Z" fill="#F20640" />
    <path d="m16.508 12.685.343-.034-.38-.49.037.524Z" fill="#F2093F" />
    <path d="m14.384 13.091.276.143-.173-.432-.103.29Z" fill="#F40A35" />
    <path d="m16.33 13.242.205-.241-.35-.129.145.37Z" fill="#F10345" />
    <path d="m15.857 13.053-.341-.379-.04.38.38-.001Z" fill="#F10442" />
    <path d="m16.187 12.497-.348-.133.04.344.308-.211Z" fill="#F30B3B" />
    <path d="m16.33 13.242-.146-.37-.328.18.474.19Z" fill="#F10345" />
    <path d="m17.648 10.592-.317.13.2.352.117-.482Z" fill="#F73124" />
    <path d="m17.988 10.523-.34.069.326.105.014-.174Z" fill="#F83323" />
    <path d="m15.616 13.923.588-.053-.209-.327-.38.38Z" fill="#F0004A" />
    <path d="m16.412 14.165-.208-.295-.147.36.355-.065Z" fill="#EF004D" />
    <path d="m16.412 14.165-.355.064.049.362.306-.426Z" fill="#EF004D" />
    <path d="m16.618 13.939.114.39.123-.196-.237-.194Z" fill="#EF004C" />
    <path d="m16.943 13.983-.325-.044.237.194.088-.15Z" fill="#EF014B" />
    <path d="m16.204 13.87.414.07-.095-.291-.319.221Z" fill="#EF004B" />
    <path d="m16.934 11.496.202.48.261-.227-.463-.253Z" fill="#F51D2F" />
    <path d="m17.136 11.976-.291-.187-.072.301.363-.114Z" fill="#F41536" />
    <path d="m15.766 5.569.084.365.284-.221-.368-.144Z" fill="#FF9200" />
    <path d="m15.47 6.083.38-.149-.322-.16-.057.31Z" fill="#FF8B00" />
    <path d="m17.496 7.187-.22.37.288-.18-.068-.19Z" fill="#FE7905" />
    <path d="m17.02 7.818.256-.261-.322-.108.065.37Z" fill="#FD6E08" />
    <path d="m15.609 8.473.422-.127-.256-.36-.166.487Z" fill="#FD5E09" />
    <path d="m16.154 7.07-.031.398.4-.01-.369-.389Z" fill="#FE7E02" />
    <path d="m15.776 7.987.272-.194-.325-.318.053.512Z" fill="#FE6906" />
    <path d="m16.031 8.346.305-.384-.288-.169-.017.553Z" fill="#FD6209" />
    <path d="m17.196 12.607-.345.044.196.283.15-.326Z" fill="#F20C3E" />
    <path d="m16.471 12.16.38.491.12-.323-.5-.168Z" fill="#F31138" />
    <path d="m16.96 10.517.307-.118-.477-.338.17.456Z" fill="#F83123" />
    <path d="m16.187 12.497-.102-.507-.246.374.348.133Z" fill="#F30B3B" />
    <path d="m15.209 12.603.306.071-.28-.384-.026.313Z" fill="#F40B37" />
    <path d="m14.744 13.864.316.317.153-.433-.47.116Z" fill="#F10342" />
    <path d="m15.277 7.864-.178-.324-.333.393.51-.069Z" fill="#FE6904" />
    <path d="m15.609 8.473.166-.486-.305.167.139.32Z" fill="#FD5E09" />
    <path d="m12.776 9.92-.132.431.368-.028-.236-.403Z" fill="#FF3202" />
    <path d="m13.477 12.598.316.316.003-.46-.32.143Z" fill="#F81523" />
    <path d="m15.277 7.864-.511.069.21.288.3-.357Z" fill="#FE6904" />
    <path d="m15.733 10.209-.11.352.456-.243-.346-.11Z" fill="#FA361A" />
    <path d="m14.975 8.221.495-.067-.194-.29-.3.357Z" fill="#FE5F05" />
    <path d="m15.847 9.231-.096-.436-.384.282.48.154Z" fill="#FC4D10" />
    <path d="m16.79 10.061.11-.474-.251.191.14.283Z" fill="#F93B1D" />
    <path d="m17.08 8.16-.207.4.413-.121-.206-.279Z" fill="#FD670B" />
    <path d="m16.048 7.793.288.17-.213-.495-.075.325Z" fill="#FE6F06" />
    <path d="m16.733 8.153-.397-.19.113.526.284-.336Z" fill="#FD670A" />
    <path d="m17.136 11.975-.363.115.197.238.166-.353Z" fill="#F41536" />
    <path d="m16.552 11.868.22.222.073-.301-.293.079Z" fill="#F41634" />
    <path
      d="m15.475 13.054.04-.38-.306-.07.266.45ZM15.475 13.054l-.284.255.393.15-.109-.405Z"
      fill="#F2053F"
    />
    <path d="m14.841 13.485-.181-.251-.233.314.415-.063Z" fill="#F2043F" />
    <path d="m15.616 13.923.38-.38-.412-.083.032.463Z" fill="#F0004A" />
    <path d="m15.255 10.562.169-.545-.356-.049.187.594Z" fill="#F92E1B" />
    <path d="m16.471 12.16.081-.292-.467.122.386.17Z" fill="#F31138" />
    <path d="m15.403 8.741.348.054-.142-.322-.206.268Z" fill="#FD560A" />
    <path d="m16.336 7.962-.305.384.417.143-.112-.527Z" fill="#FD6C08" />
    <path d="m15.723 7.475.325.318.075-.325-.4.007Z" fill="#FE7403" />
    <path d="m16.031 8.346.017-.553-.273.194.256.359Z" fill="#FD6209" />
    <path d="m16.733 8.153-.285.336.425.07-.14-.406Z" fill="#FD670A" />
    <path d="m16.657 7.794.076.359.286-.335-.362-.024Z" fill="#FD6F07" />
    <path d="m17.473 9.26.105-.345-.466.047.361.298Z" fill="#FB4E15" />
    <path d="m17.578 8.915-.017-.317-.45.364.466-.047Z" fill="#FB5512" />
    <path d="m16.58 9.079.233-.211-.365-.38.133.59Z" fill="#FB5211" />
    <path d="m16.448 8.489-.417-.143.124.319.293-.176Z" fill="#FD600C" />
    <path d="m17.08 8.16.206.28.187-.257-.393-.023Z" fill="#FD670B" />
    <path d="m17.02 7.818-.287.335.347.007-.06-.342Z" fill="#FD6E08" />
    <path d="m16.449 8.489-.294.176.426.414-.132-.59Z" fill="#FD600C" />
    <path d="m15.778 10.979.378.003-.183-.302-.195.299Z" fill="#F82624" />
    <path d="m17.232 9.733.362.015.095-.283-.457.268Z" fill="#FA431A" />
    <path d="m16.79 10.061.442-.328-.331-.146-.111.474Z" fill="#F93B1D" />
    <path d="m17.125 9.315-.013-.353-.299-.094.312.447Z" fill="#FB4D15" />
    <path d="m17.232 9.733-.107-.418-.225.272.332.146Z" fill="#FA431A" />
    <path d="m16.523 7.457-.187.505.321-.168-.134-.337Z" fill="#FE7705" />
    <path d="m16.733 8.153-.076-.359-.321.168.397.19Z" fill="#FD670A" />
    <path d="m16.707 11.29-.369.363.214.215.155-.578Z" fill="#F6212C" />
    <path d="m16.085 11.99-.42-.038.174.412.246-.374Z" fill="#F41334" />
    <path d="m16.707 11.29.138.499.089-.293-.227-.205Z" fill="#F6212C" />
    <path d="m15.975 11.644.11.346.253-.338-.363-.008Z" fill="#F5192E" />
    <path d="m16.773 12.09-.22-.222-.082.292.302-.07Z" fill="#F41237" />
    <path d="m16.707 11.29-.155.578.293-.08-.138-.498Z" fill="#F6212C" />
    <path d="m17.23 11.077-.013.301.315-.304-.302.003Z" fill="#F6262A" />
    <path d="m16.53 10.904.43-.387-.421-.038-.009.425Z" fill="#F72826" />
    <path d="m15.44 11.091.529.19-.19-.302-.34.113Z" fill="#F82323" />
    <path d="m15.975 11.644-.428-.12.117.428.311-.308Z" fill="#F5192E" />
    <path d="m16.96 10.517-.43.387.43.037v-.424Z" fill="#F83123" />
    <path d="m16.707 11.29-.177-.386-.192.38.37.006Z" fill="#F6212C" />
    <path d="m16.538 10.479.252-.418-.4.044.148.373Z" fill="#F83221" />
    <path d="m15.968 11.28.37.003-.183-.301-.187.298Z" fill="#F62029" />
    <path d="m16.96 10.94-.43-.036.177.386.253-.35Z" fill="#F72828" />
    <path d="m16.53 10.904.009-.425-.245.207.236.218Z" fill="#F72826" />
    <path d="m16.96 10.94-.253.35.227.206.026-.555Z" fill="#F72828" />
    <path d="m16.96 10.94.371-.219-.37-.204-.001.424Z" fill="#F72828" />
    <path d="m16.39 10.105.4-.044-.141-.283-.259.327Z" fill="#F93A1C" />
    <path d="m15.624 10.561-.184.53.338-.112-.154-.418Z" fill="#F92E1D" />
    <path d="m16.338 11.283.192-.38-.375.079.183.301Z" fill="#F6202B" />
    <path d="m16.294 10.686-.139.296.375-.078-.236-.218Z" fill="#F82D23" />
    <path d="m17.332 10.721-.102.356.302-.003-.2-.353Z" fill="#F72E26" />
    <path d="m16.96 10.94.257.438.013-.301-.27-.136Z" fill="#F72828" />
    <path d="m17.332 10.721-.065-.322-.307.118.372.204Z" fill="#F72E26" />
    <path d="m17.34 10.078-.108-.345-.442.328.55.017Z" fill="#F93C1E" />
    <path d="m16.08 10.318.459.16-.149-.373-.31.213Z" fill="#F9341D" />
    <path d="m16.155 10.982.139-.296-.321-.006.182.302Z" fill="#F72626" />
    <path d="m17.267 10.399.064.322.317-.13-.38-.192Z" fill="#F83422" />
    <path d="m16.79 10.061.477.338.074-.32-.551-.018Z" fill="#F93B1D" />
    <path d="m16.58 9.079.32.508.225-.272-.544-.236Z" fill="#FB5211" />
    <path d="m16.539 10.478.421.04-.17-.457-.251.417Z" fill="#F83221" />
    <path d="m15.609 8.473-.35-.038.144.306.206-.268Z" fill="#FD5E09" />
    <path d="m15.99 9.952-.258.257.347.11-.09-.367Z" fill="#FA3C18" />
    <path d="m15.041 8.921.362-.18-.466-.165.104.345Z" fill="#FD500A" />
    <path d="m14.279 8.741.116.342.283-.241-.4-.1Z" fill="#FE4F05" />
    <path d="m14.938 8.576.465.165-.143-.306-.322.14Z" fill="#FE5707" />
    <path d="m15.555 9.343.292-.112-.48-.154.188.266Z" fill="#FC4910" />
    <path d="m16.813 8.868.3.094-.24-.402-.06.308Z" fill="#FC5710" />
    <path d="m15.99 9.952.4.153-.049-.399-.351.246Z" fill="#FA3C18" />
    <path d="m16.031 8.346-.422.127.142.322.28-.449Z" fill="#FD6209" />
    <path d="m16.341 9.706-.216-.33-.34.2.556.13Z" fill="#FA4317" />
    <path d="m15.367 9.077.384-.282-.348-.054-.036.336Z" fill="#FC4F0C" />
    <path d="m15.751 8.795.294.193.11-.323-.404.13Z" fill="#FD570C" />
    <path d="m16.46 9.392.44.195-.32-.508-.12.313Z" fill="#FB4A14" />
    <path d="m16.39 10.105.259-.327-.308-.072.05.399Z" fill="#F93A1C" />
    <path d="m15.99 9.952.351-.246-.557-.13.206.376Z" fill="#FA3C18" />
    <path d="m16.08 10.318.214.368.245-.208-.46-.16Z" fill="#F9341D" />
    <path d="m15.99 9.952-.206-.376-.09.294.296.082Z" fill="#FA3C18" />
    <path d="m16.294 10.686-.215-.368-.106.362.32.006Z" fill="#F82D23" />
    <path d="m15.751 8.795.404-.13-.123-.319-.281.449Z" fill="#FD570C" />
    <path d="m16.58 9.079-.425-.414-.11.323.536.09Z" fill="#FB5211" />
    <path d="m15.555 9.343-.25.21.479.023-.229-.233Z" fill="#FC4910" />
    <path d="m15.693 9.87-.388-.317.118.464.27-.147Z" fill="#FA3E16" />
    <path d="m16.39 10.105-.4-.153.089.366.311-.213Z" fill="#F93A1C" />
    <path d="m15.99 9.952-.297-.082.04.339.257-.257Z" fill="#FA3C18" />
    <path d="m15.254 10.562.37-.001-.2-.544-.17.545Z" fill="#F92E1B" />
    <path d="m15.733 10.209-.31-.192.2.544.11-.352Z" fill="#FA361A" />
    <path d="m15.305 9.552.388.318.09-.294-.478-.024Z" fill="#FC4410" />
    <path d="m15.733 10.209-.04-.34-.27.148.31.192Z" fill="#FA361A" />
    <path d="m16.934 11.496-.09.293.292.187-.202-.48Z" fill="#F51D2F" />
    <path d="m16.96 10.94-.026.556.283-.118-.257-.437Z" fill="#F72828" />
    <path d="M16.338 11.653v-.37l-.363.36.363.01Z" fill="#F51930" />
    <path d="m15.547 12.245.292.12-.175-.413-.117.293Z" fill="#F40F34" />
    <path d="m15.547 11.523.421-.243-.528-.188.107.431Z" fill="#F61B2A" />
    <path d="m15.665 11.952.42.038-.11-.346-.31.308Z" fill="#F51431" />
    <path d="m15.88 12.708-.365-.034.341.379.024-.345Z" fill="#F2083D" />
    <path
      d="m16.187 12.497-.307.21.304.165.003-.375ZM16.187 12.497l-.003.375.324-.186-.321-.189Z"
      fill="#F30B3B"
    />
    <path d="m15.515 12.674.365.034-.041-.344-.324.31Z" fill="#F3093A" />
    <path d="m16.508 12.685-.037-.525-.284.337.321.188Z" fill="#F2093F" />
    <path d="m16.085 11.99.102.507.284-.337-.386-.17Z" fill="#F41334" />
    <path d="m16.9 9.587-.44-.195.189.386.251-.19Z" fill="#FA4617" />
    <path d="m15.847 9.231.278.144-.08-.387-.198.243Z" fill="#FC4D10" />
    <path d="m16.044 8.988.08.387.457-.296-.537-.09Z" fill="#FC530F" />
    <path d="m16.46 9.392-.335-.017.216.331.12-.314Z" fill="#FB4A14" />
    <path d="m16.649 9.778-.189-.386-.119.314.308.072Z" fill="#FA4219" />
    <path d="m16.58 9.079-.455.296.335.017.12-.313Z" fill="#FB5211" />
    <path d="m16.448 8.489.365.379.06-.308-.425-.071Z" fill="#FD600C" />
    <path d="m17.125 9.315-.312-.447-.232.21.544.237Z" fill="#FB4D15" />
    <path d="m15.041 8.921-.318.314.352.046-.034-.36Z" fill="#FD500A" />
    <path d="m15.305 9.552.062-.475-.292.204.23.271Z" fill="#FC4410" />
    <path d="m15.784 9.576.34-.2-.277-.145-.063.345Z" fill="#FB4513" />
    <path d="m15.367 9.077-.062.475.25-.209-.188-.266Z" fill="#FC4F0C" />
    <path d="m15.751 8.795.096.436.198-.243-.294-.193Z" fill="#FD570C" />
    <path d="m15.784 9.576.063-.345-.292.112.229.233Z" fill="#FB4513" />
    <path d="m12.495 9.846.414-.286-.274-.154-.14.44Z" fill="#FF3200" />
    <path d="m15.305 9.553-.376.084.139.331.237-.415Z" fill="#FC4410" />
    <path d="m15.041 8.921.035.36.291-.204-.326-.156Z" fill="#FD500A" />
    <path d="m14.272 9.422.299.199.152-.386-.451.187Z" fill="#FD4109" />
    <path d="m15.404 8.741-.363.18.326.156.037-.336Z" fill="#FD560A" />
    <path d="m15.041 8.921-.103-.345-.26.266.363.08Z" fill="#FD500A" />
    <path d="m13.475 9.474-.265.325.351.084-.086-.409Z" fill="#FE3C04" />
    <path d="m13.986 11.507-.34.37.515.051-.175-.42Z" fill="#F91E1B" />
    <path d="m14.723 9.235.206.402.146-.356-.352-.046Z" fill="#FD480A" />
    <path
      d="m15.067 9.968-.138-.331-.22.315.358.016ZM15.067 9.968l-.358-.016.01.54.348-.524Z"
      fill="#FB3A13"
    />
    <path d="m15.305 9.553-.237.415.356.05-.119-.466Z" fill="#FC4410" />
    <path d="M15.623 10.561h-.369l.186.53.183-.53Z" fill="#F92E1D" />
    <path d="m16.08 10.318-.456.243.349.119.106-.362Z" fill="#F9341D" />
    <path d="m15.291 11.357-.27-.416-.034.444.304-.027Z" fill="#F71E25" />
    <path d="m15.547 11.523.428.12-.006-.363-.422.243Z" fill="#F61B2A" />
    <path d="m15.305 11.82-.318-.436-.051.537.37-.101Z" fill="#F6162C" />
    <path d="m15.291 11.357.014.463.242-.297-.256-.165Z" fill="#F71E25" />
    <path d="m14.987 11.385.034-.444-.21.207.176.237Z" fill="#F81E23" />
    <path d="m14.098 11.22.108-.489-.491.3.383.19Z" fill="#FA2218" />
    <path d="m14.955 12.788-.18-.43-.288.444.468-.014Z" fill="#F40A37" />
    <path d="m15.236 12.29.312-.045-.243-.425-.07.47Z" fill="#F40F32" />
    <path d="m15.291 11.357.256.166-.107-.431-.149.265Z" fill="#F71E25" />
    <path d="m15.236 12.29.07-.47-.37.101.3.369Z" fill="#F40F32" />
    <path d="m15.021 10.94.419.152-.185-.53-.234.379Z" fill="#F9261E" />
    <path d="m14.492 12.006.18-.38-.395-.017.215.397Z" fill="#F71527" />
    <path d="m14.775 12.359.161-.438-.444.085.283.353Z" fill="#F50F2F" />
    <path d="m15.515 12.674.324-.31-.292-.12-.032.43Z" fill="#F3093A" />
    <path d="m15.021 10.94.27.418.149-.267-.419-.15Z" fill="#F9261E" />
    <path d="m15.305 11.82-.014-.463-.304.028.318.435Z" fill="#F6162C" />
    <path d="m14.29 12.586.197.216-.046-.466-.151.25Z" fill="#F60F2D" />
    <path d="m14.944 13.107.53-.053-.519-.266-.011.32Z" fill="#F3063B" />
    <path d="m14.774 12.359.461-.069-.3-.369-.16.438Z" fill="#F50F2F" />
    <path d="m15.475 13.054-.531.053.247.202.284-.255Z" fill="#F2053F" />
    <path d="m15.305 11.82.243.425.117-.293-.36-.132Z" fill="#F6162C" />
    <path d="m15.515 12.674.033-.43-.312.046.28.384Z" fill="#F3093A" />
    <path d="m14.774 12.359.435.244.026-.313-.46.069Z" fill="#F50F2F" />
    <path d="m15.475 13.054-.266-.45-.254.184.52.266Z" fill="#F2053F" />
    <path d="m14.936 11.921-.263-.296-.18.381.443-.085Z" fill="#F6152A" />
    <path d="m13.998 12.685.386.406.103-.29-.489-.116Z" fill="#F6102B" />
    <path d="m14.492 12.006-.215-.397-.116.32.331.077Z" fill="#F71527" />
    <path d="m14.775 12.359-.283-.353-.05.33.333.023Z" fill="#F50F2F" />
    <path d="m13.998 12.685.112.546.274-.14-.386-.406Z" fill="#F6102B" />
    <path d="m14.441 12.336.046.466.288-.443-.334-.023Z" fill="#F6112B" />
    <path d="m14.099 11.22.178.389.238-.484-.416.096Z" fill="#FA2218" />
    <path d="m13.369 11.134-.043.359.36.082-.317-.44Z" fill="#FC240F" />
    <path d="m14.113 12.305.38-.299-.332-.078-.048.377Z" fill="#F71327" />
    <path d="m13.796 12.454.317-.15-.252-.214-.065.364Z" fill="#F71325" />
    <path
      d="m14.16 11.928.117-.32-.29-.1.174.42ZM14.16 11.928l-.299.162.252.215.048-.377Z"
      fill="#F81722"
    />
    <path d="m16.156 10.982-.378-.003.19.301.188-.298Z" fill="#F72626" />
    <path d="m15.623 10.561.155.418.195-.299-.35-.119Z" fill="#F92E1D" />
    <path d="m14.97 10.648.098-.68-.35.525.253.155Z" fill="#FA2C1A" />
    <path d="m15.02 10.94.234-.378-.283.086.05.293Z" fill="#F9261E" />
    <path d="m14.505 10.226.213.267-.01-.54-.203.273Z" fill="#FB3311" />
    <path d="m14.515 11.125-.238.484.396.016-.158-.5Z" fill="#F9231B" />
    <path d="m15.021 10.94-.478-.155.267.363.211-.207Z" fill="#F9261E" />
    <path d="m14.543 10.785-.038-.559-.299.505.337.054Z" fill="#FA2917" />
    <path d="m15.068 9.968-.097.68.283-.086-.186-.594Z" fill="#FB3A13" />
    <path d="m14.971 10.648-.252-.155-.176.292.428-.137Z" fill="#FA2C1A" />
    <path d="m14.543 10.785.478.156-.05-.293-.428.137Z" fill="#FA2917" />
    <path d="m14.673 11.625.137-.477-.295-.023.158.5Z" fill="#F81A24" />
    <path d="m14.936 11.921.051-.537-.314.241.263.296Z" fill="#F6152A" />
    <path d="m14.673 11.625.314-.24-.177-.237-.137.477Z" fill="#F81A24" />
    <path d="m14.487 12.802-.197-.216-.291.1.488.116Z" fill="#F50C32" />
    <path d="m14.842 13.486.35-.177-.248-.201-.102.377Z" fill="#F2043F" />
    <path d="m14.396 9.083-.507.037.383.302.123-.339Z" fill="#FD4907" />
    <path d="m13.326 11.493.043-.359-.336.134.293.225Z" fill="#FB2013" />
    <path d="m14.744 13.864.469-.116-.371-.262-.098.378Z" fill="#F10342" />
    <path d="m14.66 13.234.181.252.103-.379-.284.127Z" fill="#F3073A" />
    <path d="m15.191 13.31-.35.175.372.263-.022-.439Z" fill="#F20440" />
    <path d="m14.487 12.802.457.306.011-.32-.468.014Z" fill="#F50C32" />
    <path d="m15.377 14.498.015-.331-.332.014.317.317Z" fill="#EF004C" />
    <path d="m15.584 13.46-.393-.15.022.438.37-.288Z" fill="#F10145" />
    <path d="m15.392 14.167-.18-.419-.152.433.332-.014Z" fill="#F0004A" />
    <path d="m15.748 14.443-.357-.276-.014.331.371-.055Z" fill="#EF004E" />
    <path d="m15.212 13.748.18.419.224-.244-.404-.175Z" fill="#F10145" />
    <path d="m14.93 9.637-.36-.016.139.331.22-.315Z" fill="#FC400F" />
    <path d="m13.862 10.509.344.222-.042-.499-.302.277Z" fill="#FC2D0E" />
    <path d="m13.24 11.883-.397.081.317.317.08-.398Z" fill="#FA1D17" />
    <path d="m14.098 11.22-.112.287.291.102-.179-.389Z" fill="#FA2218" />
    <path d="m14.22 9.829.489.123-.138-.331-.351.208Z" fill="#FD390B" />
    <path d="m14.206 10.731.299-.505-.341.006.042.5Z" fill="#FB2914" />
    <path d="m14.206 10.731-.107.49.416-.096-.309-.394Z" fill="#FB2914" />
    <path d="m13.715 11.032-.029.543.3-.067-.27-.476Z" fill="#FB2512" />
    <path d="m14.543 10.785-.337-.054.31.394.027-.34Z" fill="#FA2917" />
    <path d="m13.854 10.07.008.44.302-.278-.31-.161Z" fill="#FD340A" />
    <path d="m14.384 13.091-.274.14.317.317-.043-.457Z" fill="#F40A35" />
    <path d="m13.524 12.234-.364.047.317.316.047-.363Z" fill="#F9171E" />
    <path d="m13.715 11.032.271.476.112-.287-.383-.189Z" fill="#FB2512" />
    <path d="m13.686 11.575-.04.301.34-.368-.3.067Z" fill="#FA1E18" />
    <path d="m14.543 10.785-.028.34.295.023-.267-.363Z" fill="#FA2917" />
    <path d="m14.505 10.226.037.56.176-.293-.213-.267Z" fill="#FB3311" />
    <path d="m13.423 10.681.44-.172-.312-.266-.128.438Z" fill="#FD2A0B" />
    <path d="m13.715 11.032.49-.3-.343-.223-.147.523Z" fill="#FB2512" />
    <path d="m13.3 10.407-.09-.608-.198.524.288.084Z" fill="#FD2D08" />
    <path d="m13.16 12.28.364-.046-.283-.35-.08.397Z" fill="#F91A1A" />
    <path d="m13.646 11.876-.123.358.338-.143-.215-.215Z" fill="#F91A1B" />
    <path d="m13.646 11.876-.405.007.283.35.122-.357Z" fill="#F91A1B" />
    <path d="m13.423 10.681.128-.438-.25.164.122.274Z" fill="#FD2A0B" />
    <path d="m12.617 11.24.365.388.05-.36-.415-.028Z" fill="#FD2509" />
    <path d="m13.646 11.876.215.215.3-.162-.515-.053Z" fill="#F91A1B" />
    <path d="m13.326 11.493-.344.135.259.255.085-.39Z" fill="#FB2013" />
    <path d="m13.646 11.876-.32-.383-.085.39.405-.007Z" fill="#F91A1B" />
    <path d="m13.326 11.493.32.383.04-.3-.36-.083Z" fill="#FB2013" />
    <path d="m12.526 11.647.456-.02-.365-.387-.09.407Z" fill="#FC230C" />
    <path d="m12.843 11.964.398-.08-.26-.256-.138.336Z" fill="#FB1F13" />
    <path d="m13.369 11.134.317.441.03-.543-.347.102Z" fill="#FC240F" />
    <path d="m13.033 11.268-.051.36.344-.135-.293-.225Z" fill="#FC230D" />
    <path d="m12.526 11.647.09-.407-.406.09.316.317Z" fill="#FC230C" />
    <path d="m12.843 11.964.139-.336-.456.02.317.316Z" fill="#FB1F13" />
    <path d="m13.423 10.681.292.35.147-.522-.44.172Z" fill="#FD2A0B" />
    <path d="m13.423 10.681-.054.454.346-.103-.292-.35Z" fill="#FD2A0B" />
    <path d="m12.842 10.99.313-.11-.207-.244-.106.355Z" fill="#FD2709" />
    <path d="m13.369 11.134.054-.453-.267.198.213.255Z" fill="#FC240F" />
    <path d="m12.354 11.017.488-.026-.202-.27-.287.296Z" fill="#FE2805" />
    <path d="m12.125 10.762-.26-.155.028.407.232-.252Z" fill="#FF2A02" />
    <path d="m12.297 10.465.346-.114-.277-.244-.069.358Z" fill="#FF2C01" />
    <path d="m12.842 10.99-.225.25.416.028-.19-.277Z" fill="#FD2709" />
    <path d="m12.297 10.465-.172.297.516-.04-.344-.257Z" fill="#FF2C01" />
    <path d="m13.156 10.88-.123.388.336-.134-.213-.255Z" fill="#FD270B" />
    <path d="m13.012 10.323-.368.028.304.285.064-.313Z" fill="#FE2E05" />
    <path d="m13.21 9.799.09.608.251-.164-.341-.444Z" fill="#FE3504" />
    <path d="m13.3 10.407-.288-.084-.064.313.352-.229Z" fill="#FD2D08" />
    <path d="m13.423 10.681-.123-.274-.352.229.475.045Z" fill="#FD2A0B" />
    <path d="m13.033 11.268.123-.389-.314.112.19.277Z" fill="#FC230D" />
    <path d="m13.551 10.243.01-.36-.351-.084.341.444Z" fill="#FD3009" />
    <path d="m13.475 9.474.016-.4-.363.17.347.23Z" fill="#FE3C04" />
    <path d="m12.948 10.636-.305-.285-.002.37.307-.085Z" fill="#FE2A07" />
    <path d="m12.776 9.92.236.403.198-.524-.434.121Z" fill="#FF3202" />
    <path d="m12.842 10.99.106-.354-.307.085.201.27Z" fill="#FD2709" />
    <path d="m12.948 10.636.207.243.268-.198-.475-.045Z" fill="#FE2A07" />
    <path d="m13.855 10.07-.008-.407-.286.22.294.188Z" fill="#FD340A" />
    <path d="m12.644 10.351.132-.43-.41.186.278.244Z" fill="#FE2D02" />
    <path d="m13.128 9.244-.22.316.302.239-.082-.555Z" fill="#FF3D02" />
    <path d="m12.776 9.92.434-.122-.301-.238-.133.36Z" fill="#FF3202" />
    <path d="m12.635 9.406.493-.162-.232-.232-.261.394Z" fill="#FF3700" />
    <path d="m12.495 9.846-.13.261.411-.187-.281-.074Z" fill="#FF3200" />
    <path d="m13.723 8.809-.028-.351-.374.234.402.117Z" fill="#FE4903" />
    <path d="m12.037 9.503.204-.49-.348-.03.144.52Z" fill="#F30" />
    <path d="m13.027 8.744-.445-.023.314.291.13-.268Z" fill="#FF4301" />
    <path d="m12.037 9.503-.408.159.322.176.086-.335Z" fill="#F30" />
    <path d="m12.91 9.56-.415.286.281.074.133-.36Z" fill="#FF3702" />
    <path d="m11.951 9.838.543.008-.12-.265-.423.257Z" fill="#FF3000" />
    <path d="m14.505 10.226.204-.274-.49-.123.286.397Z" fill="#FB3311" />
    <path d="m13.49 9.074-.014.4.413-.354-.398-.046Z" fill="#FE4203" />
    <path d="m11.893 8.982-.317.317.461.204-.144-.52Z" fill="#FF3600" />
    <path d="m11.63 9.662.407-.159-.46-.204.052.363Z" fill="#FF3000" />
    <path d="m13.128 9.244-.493.162.274.154.219-.316Z" fill="#FF3D02" />
    <path d="m12.579 9.097-.206.484.261-.175-.055-.309Z" fill="#FF3B00" />
    <path d="m12.495 9.846-.544-.008.415.27.129-.262Z" fill="#FF3200" />
    <path d="m11.951 9.838.423-.257-.337-.078-.086.335Z" fill="#FF3000" />
    <path d="m12.64 10.721-.515.04.229.256.287-.296Z" fill="#FE2A05" />
    <path d="m12.366 10.107-.415-.27.12.271h.295Z" fill="#FF2F00" />
    <path d="m12.374 9.581.205-.484-.338-.084.133.568Z" fill="#FF3400" />
    <path d="m12.037 9.503.337.078-.133-.568-.204.49Z" fill="#F30" />
    <path d="m11.26 9.616.37.046-.054-.363-.317.317Z" fill="#FF2F00" />
    <path d="m11.483 9.998.468-.16-.321-.176-.147.336Z" fill="#FF2E00" />
    <path d="m11.893 11.014.317.316.144-.313-.46-.003Z" fill="#FE2A02" />
    <path d="m12.617 11.24-.264-.223-.143.313.407-.09Z" fill="#FD2509" />
    <path
      d="m12.298 10.465.068-.358-.296.001.228.357ZM11.865 10.607l-.015-.302-.274.392.289-.09Z"
      fill="#FF2C01"
    />
    <path d="m12.354 11.017.263.223.225-.25-.489.027Z" fill="#FE2805" />
    <path d="m12.125 10.761-.232.253.46.003-.228-.255Z" fill="#FF2A02" />
    <path d="m11.951 9.838-.101.467.22-.197-.119-.27Z" fill="#FF3000" />
    <path d="m12.297 10.465-.227-.357-.22.197.447.16Z" fill="#FF2C01" />
    <path d="m11.893 11.014-.028-.407-.289.09.317.317Z" fill="#FE2A02" />
    <path d="m11.865 10.607.432-.142-.447-.16.015.302Z" fill="#FF2C01" />
    <path d="m13.855 10.07-.294-.188-.01.361.304-.172Z" fill="#FD340A" />
    <path d="m13.476 9.474.085.409.287-.22-.372-.189Z" fill="#FE3C04" />
    <path d="m13.862 10.51-.008-.44-.303.173.311.266Z" fill="#FC2D0E" />
    <path d="m13.854 10.07.31.162.056-.403-.366.242Z" fill="#FD340A" />
    <path d="m13.476 9.474.371.189.132-.263-.503.074Z" fill="#FE3C04" />
    <path d="m13.21 9.799.265-.325-.347-.23.082.555Z" fill="#FE3504" />
    <path d="m14.272 9.422-.383-.302.09.28.293.022Z" fill="#FD4109" />
    <path d="m14.113 12.305.177.281.152-.25-.33-.031Z" fill="#F71327" />
    <path d="m13.983 8.627-.26.182.165.311.095-.493Z" fill="#FE4F03" />
    <path d="m13.252 8.28.443.178-.118-.528-.325.35Z" fill="#FF4D01" />
    <path d="m12.21 8.665-.317.317.348.03-.031-.347Z" fill="#FF3C00" />
    <path d="m12.298 10.465-.433.142.26.155.173-.297Z" fill="#FF2C01" />
    <path d="m13.854 10.07.366-.241-.373-.166.007.408Z" fill="#FD340A" />
    <path d="m14.395 9.083-.123.34.45-.188-.327-.152Z" fill="#FD4907" />
    <path d="m14.723 9.235-.152.386.358.016-.206-.402Z" fill="#FD480A" />
    <path d="m13.979 9.4.24.429.053-.407-.293-.022Z" fill="#FE4007" />
    <path d="m13.476 9.474.503-.074-.09-.28-.413.354Z" fill="#FE3C04" />
    <path d="m14.22 9.829-.241-.43-.132.264.373.166Z" fill="#FD390B" />
    <path d="m14.723 9.235.318-.314-.363-.08.045.394Z" fill="#FD480A" />
    <path d="m13.889 9.12.507-.037-.117-.342-.39.38Z" fill="#FE4505" />
    <path d="m14.678 8.842.26-.266-.396-.178.136.444Z" fill="#FD5007" />
    <path d="m14.722 9.235-.044-.393-.283.241.327.152Z" fill="#FD480A" />
    <path d="m13.321 8.692.374-.234-.443-.179.07.413Z" fill="#FF4701" />
    <path d="m13.252 8.28-.35.116.125.348.225-.465Z" fill="#FF4D01" />
    <path d="m13.49 9.074.399.046-.166-.311-.232.265Z" fill="#FE4203" />
    <path d="m17.2 6.498-.246.24.32-.084-.074-.156Z" fill="#FF8502" />
    <path d="m14.543 8.398-.43-.06.166.403.264-.343Z" fill="#FE5805" />
    <path d="m14.427 13.548.316.316.098-.379-.414.063Z" fill="#F3063B" />
    <path d="m13.983 8.627-.094.493.39-.379-.296-.114Z" fill="#FE4F03" />
    <path d="m16.327 6.563.423-.086-.245-.308-.178.394Z" fill="#FF8701" />
    <path d="m13.796 12.454-.272-.22-.047.364.319-.144Z" fill="#F71325" />
    <path d="m12.582 8.72-.341.293.338.084.003-.376Z" fill="#FF3F00" />
    <path d="m13.321 8.692-.193.552.363-.17-.17-.382Z" fill="#FF4701" />
    <path d="m16.75 6.477-.105.379.309-.119-.204-.26Z" fill="#FF8801" />
    <path d="m13.695 8.458.419-.12-.28-.188-.14.308Z" fill="#FF4F02" />
    <path d="m17.006 7.078-.052-.34-.31.118.362.222Z" fill="#FE7D04" />
    <path d="m13.834 8.15.37-.238-.306-.07-.064.308Z" fill="#FF5602" />
    <path d="m14.487 12.802.173.432.284-.126-.457-.306Z" fill="#F50C32" />
    <path d="m13.695 8.458.028.351.26-.182-.288-.17Z" fill="#FF4F02" />
    <path d="m14.494 7.676.26-.268-.171-.239-.09.507Z" fill="#FF6602" />
    <path d="m14.427 13.548.233-.314-.276-.143.043.457Z" fill="#F3063B" />
    <path d="m14.113 12.305.329.031.05-.33-.38.299Z" fill="#F71327" />
    <path d="m13.796 12.454.065-.364-.338.144.273.22Z" fill="#F71325" />
    <path d="m13.999 12.685-.203-.231-.002.46.205-.229Z" fill="#F6102B" />
    <path d="m13.999 12.685-.206.23.317.316-.111-.546Z" fill="#F6102B" />
    <path d="m14.113 12.305-.114.38.29-.099-.176-.281Z" fill="#F71327" />
    <path d="m14.505 10.226-.285-.397-.056.403.34-.006Z" fill="#FB3311" />
    <path d="m14.272 9.422-.052.407.35-.208-.298-.199Z" fill="#FD4109" />
    <path d="m14.279 8.741.399.1-.136-.443-.263.343Z" fill="#FE4F05" />
    <path d="m13.658 7.64.24.202.04-.315-.28.112Z" fill="#FF5C01" />
    <path d="m14.279 8.741-.165-.403-.131.29.296.113Z" fill="#FE4F05" />
    <path d="m13.695 8.458.288.17.13-.29-.418.12Z" fill="#FF4F02" />
    <path d="m14.938 8.576.322-.14-.285-.215-.037.355Z" fill="#FE5707" />
    <path d="m14.114 8.338.429.06-.064-.316-.365.256Z" fill="#FE5503" />
    <path d="m15.099 7.54-.345-.132.011.525.334-.393Z" fill="#FE6F03" />
    <path d="m14.494 7.676.271.257-.011-.525-.26.268Z" fill="#FF6602" />
    <path
      d="m14.975 8.221.285.214.21-.281-.495.067ZM14.975 8.221l-.21-.288-.286.149.496.14Z"
      fill="#FE5F05"
    />
    <path d="m14.99 6.941-.407.228.17.239.236-.467Z" fill="#FF7901" />
    <path d="m14.479 8.082.015-.406-.29.236.275.17Z" fill="#FE5E03" />
    <path d="m14.238 7.518-.034.394.29-.236-.256-.158Z" fill="#FF6601" />
    <path d="m13.794 7.081.144.446.357-.303-.501-.143Z" fill="#FF6700" />
    <path d="m14.692 6.897.123-.375-.388-.074.265.45Z" fill="#FF7701" />
    <path d="m14.11 6.765.185.458.085-.3-.27-.158Z" fill="#FF7100" />
    <path d="m14.99 6.941-.236.467.42-.23-.185-.237Z" fill="#FF7901" />
    <path d="m14.295 7.223-.184-.458-.317.316.501.142Z" fill="#FF6C01" />
    <path d="m14.38 6.923.203.246.11-.272-.312.026Z" fill="#FF7200" />
    <path d="m14.815 6.522.175.42.177-.242-.352-.178Z" fill="#FF7E00" />
    <path
      d="m14.583 7.17.406-.229-.297-.044-.109.272ZM14.583 7.17l-.202-.247-.086.3.288-.054Z"
      fill="#FF7001"
    />
    <path d="m14.815 6.522-.123.375.297.044-.174-.419Z" fill="#FF7E00" />
    <path d="m13.794 7.081-.317.317.461.129-.144-.446Z" fill="#FF6700" />
    <path d="m14.693 6.897-.265-.45-.047.476.312-.026Z" fill="#FF7701" />
    <path d="m13.938 7.527-.46-.129.18.241.28-.112Z" fill="#FF6201" />
    <path d="m15.112 6.182-.297.34.352.178-.055-.518Z" fill="#FF8600" />
    <path d="m14.744 6.131-.317.317.388.074-.071-.391Z" fill="#FF8300" />
    <path d="m14.295 7.223-.357.304.3-.009.057-.295Z" fill="#FF6C01" />
    <path d="m14.204 7.912.034-.394-.3.009.266.385Z" fill="#FF5E02" />
    <path d="m13.252 8.28.033-.296-.442.048.409.247Z" fill="#FF4D01" />
    <path d="m13.577 7.93-.417-.215.125.27.292-.055Z" fill="#FF5601" />
    <path d="m14.204 7.912-.37.238.28.188.09-.426Z" fill="#FF5E02" />
    <path d="m13.577 7.93.118.528.139-.308-.257-.22Z" fill="#FF5601" />
    <path d="m13.16 7.715.498-.076-.181-.24-.317.316Z" fill="#FF5400" />
    <path d="m13.898 7.842-.32.088.256.22.064-.308Z" fill="#FF5C01" />
    <path d="m13.938 7.527-.04.315.306.07-.266-.385Z" fill="#FF6201" />
    <path d="m13.577 7.93.32-.088-.239-.203-.08.29Z" fill="#FF5601" />
    <path d="m14.114 8.338.365-.256-.275-.17-.09.426Z" fill="#FE5503" />
    <path d="m14.975 8.221-.496-.14.064.317.432-.177Z" fill="#FE5F05" />
    <path d="m12.844 8.032-.317.317.375.047-.058-.364Z" fill="#FF4B00" />
    <path d="m13.658 7.64-.498.075.417.215.081-.29Z" fill="#FF5C01" />
    <path d="m13.723 8.809-.402-.117.17.382.232-.265Z" fill="#FE4903" />
    <path d="m12.843 8.032.059.364.35-.117-.409-.247Z" fill="#FF4B00" />
    <path d="m13.321 8.692-.294.052.1.5.194-.552Z" fill="#FF4701" />
    <path d="m12.843 8.032.442-.048-.125-.27-.317.318Z" fill="#FF4B00" />
    <path d="m13.252 8.28.325-.35-.291.054-.034.295Z" fill="#FF4D01" />
    <path d="m12.582 8.72-.372-.055.03.348.342-.292Z" fill="#FF3F00" />
    <path d="m12.21 8.665.372.056-.055-.372-.317.316Z" fill="#FF3C00" />
    <path d="m13.128 9.244-.1-.5-.132.268.232.232Z" fill="#FF3D02" />
    <path d="m13.252 8.28-.225.464.294-.052-.07-.413Z" fill="#FF4D01" />
    <path d="m12.582 8.72.32-.324-.375-.047.055.372Z" fill="#FF3F00" />
    <path d="m12.896 9.012-.314-.291-.003.376.317-.085Z" fill="#FF3E01" />
    <path d="m12.902 8.396-.32.325.445.023-.125-.348Z" fill="#FF4700" />
    <path d="m3.307 12.178-.584.128.566.235.018-.363Z" fill="#920200" />
    <path d="m3.29 12.54-.418.121.284.293.133-.413Z" fill="#8D0100" />
    <path d="m2.49 11.392.303-.228-.345-.185.042.413Z" fill="#9D0500" />
    <path d="m2.331 12.302.392.004-.443-.182.051.178Z" fill="#920200" />
    <path d="m2.233 11.944.047.18.35-.37-.397.19Z" fill="#960300" />
    <path d="m7.457 4.015.649.055-.262-.442-.387.387Z" fill="#FF3B00" />
    <path d="m8.23 3.241-.067.126.11-.09-.042-.036Z" fill="#FF3D00" />
    <path d="m2.233 11.944.396-.19-.44.009.044.18Z" fill="#960300" />
    <path d="m2.331 12.302.065.207.327-.203-.392-.004Z" fill="#920200" />
    <path d="m2.872 12.661.417-.12-.566-.235.149.355Z" fill="#8C0100" />
    <path d="m2.777 13.456.283-.18-.374-.017.091.197Z" fill="#840000" />
    <path d="m6.828 6.52.153-.492-.368.037.215.455Z" fill="#FE2F00" />
    <path d="m3.455 13.875-.419.076.127.214.292-.29Z" fill="#7F0000" />
    <path
      d="m3.06 13.276-.2.346.461-.136-.261-.21ZM3.06 13.276l-.448-.188.074.17.374.018Z"
      fill="#850000"
    />
    <path d="m2.448 10.979-.067-.501-.348.303.415.198Z" fill="#A30700" />
    <path d="m2.612 13.088.544-.133-.284-.294-.26.427Z" fill="#880100" />
    <path d="m3.354 11.002-.257-.525-.35.248.607.277Z" fill="#A40700" />
    <path d="m3.535 11.894.593-.318-.456-.163-.137.481Z" fill="#960300" />
    <path
      d="m2.872 12.661-.34.226.08.201.26-.427ZM2.467 12.713l.405-.052-.148-.355-.257.407Z"
      fill="#8C0100"
    />
    <path d="m3.527 10.444-.43.033.257.525.173-.558Z" fill="#AE0A00" />
    <path d="m2.859 11.5.121.52.22-.497-.341-.023Z" fill="#9B0500" />
    <path d="m3.321 13.486-.165-.532-.096.322.261.21Z" fill="#820000" />
    <path d="m2.005 10.407.012.188.364-.117-.376-.07Z" fill="#AA0900" />
    <path d="m2.793 11.164.407.359.154-.521-.561.162Z" fill="#A00600" />
    <path d="m3.805 13.658-.35.217.292.293.058-.51Z" fill="maroon" />
    <path d="m2.025 9.45.064.042-.051-.058-.013.016Z" fill="#B30C00" />
    <path d="m6.36 6.334-.231.464.438.084-.207-.548Z" fill="#FF2F00" />
    <path d="m2.011 9.49-.004.067.082-.065-.078-.002Z" fill="#B30C00" />
    <path d="m3.66 14.886.139.176.05-.042-.19-.134Z" fill="#7B0000" />
    <path d="m2.016 9.468-.005.022.077.002-.072-.024Z" fill="#B30C00" />
    <path d="m1.998 9.81.183-.12-.174-.133-.01.253Z" fill="#B10B00" />
    <path d="m3.945 14.682-.095.338.105.013-.01-.351Z" fill="#7B0000" />
    <path d="m2.448 10.979.298-.254-.365-.247.067.5Z" fill="#A30700" />
    <path d="m6.13 6.798-.382-.234.011.41.37-.176Z" fill="#FB2B00" />
    <path d="m2.082 11.183.03.184.378.025-.408-.209Z" fill="#A00600" />
    <path d="m2.057 10.998.39-.02-.414-.197.024.217Z" fill="#A30700" />
    <path d="m2.017 10.594.016.187.348-.303-.364.116Z" fill="#A80800" />
    <path d="m2.111 11.367.034.183.345-.158-.379-.025Z" fill="#9E0500" />
    <path d="m2.915 9.15-.49-.103.19.465.3-.362Z" fill="#BC0F00" />
    <path d="m2.089 9.492-.064-.042-.008.018.072.024Z" fill="#B30C00" />
    <path d="m2.381 10.478.331-.192-.185-.37-.146.562Z" fill="#A90900" />
    <path d="m2.49 11.392-.042-.413-.366.204.408.21Z" fill="#9D0500" />
    <path d="m2.859 11.5-.369-.108.14.362.229-.254Z" fill="#9B0500" />
    <path d="m7.844 3.628.4.077-.207-.27-.193.193Z" fill="#FF3C00" />
    <path d="m2.19 11.763.44-.009-.14-.362-.3.37Z" fill="#990400" />
    <path d="m2.19 11.763.3-.37-.345.157.045.213Z" fill="#990400" />
    <path d="m4.188 13.868-.383-.21-.058.51.44-.3Z" fill="#7F0000" />
    <path d="m8.274 3.277.05.027.005-.084-.055.057Z" fill="#FF3D00" />
    <path d="m2.946 13.787.375-.301-.462.136.087.165Z" fill="#810000" />
    <path d="m8.323 3.304-.05-.027-.11.09.16-.063Z" fill="#FF3D00" />
    <path d="m3.811 15.073.039-.053-.051.042.012.011Z" fill="#7A0000" />
    <path d="m3.945 14.682-.418.028.132.176.286-.204Z" fill="#7B0000" />
    <path d="m3.805 13.658-.484-.172.134.39.35-.218Z" fill="maroon" />
    <path d="m3.85 15.02.095-.338-.286.204.19.134Z" fill="#7A0000" />
    <path d="m3.945 14.682-.198-.514-.22.543.418-.03Z" fill="#7B0000" />
    <path d="m2.723 12.306-.094-.552-.35.37.444.182Z" fill="#900200" />
    <path d="m1.998 10.22.529-.304-.532.083.003.22Z" fill="#AC0900" />
    <path d="m3.4 14.532.127.178.22-.542-.347.364Z" fill="#7C0000" />
    <path d="m3.812 15.073.017.011.02-.064-.037.053Z" fill="#7A0000" />
    <path d="m4.231 14.302-.484-.134.198.514.286-.38Z" fill="#7D0000" />
    <path d="m3.868 15.093.029-.005-.047-.068.018.073Z" fill="#7A0000" />
    <path d="m1.998 10.22.007.187.376.07-.383-.258Z" fill="#AC0900" />
    <path d="m2.615 9.512-.527-.02.092.199.435-.179Z" fill="#B60C00" />
    <path
      d="m3.897 15.088.024-.012-.071-.056.047.068ZM3.848 15.09l.02.003-.019-.073-.001.07Z"
      fill="#7A0000"
    />
    <path
      d="m3.921 15.076.02-.019-.091-.037.071.056ZM3.955 15.033l-.105-.013.091.037.014-.024Z"
      fill="#7A0000"
    />
    <path d="m2.812 8.66-.387.387.49.103-.103-.49Z" fill="#C11000" />
    <path d="m2.231 9.24-.143.252.527.02-.384-.271Z" fill="#B60D00" />
    <path d="m3.85 15.02-.021.064.019.007.002-.071Z" fill="#7A0000" />
    <path d="m2.007 9.557.173.134-.091-.199-.082.065Z" fill="#B30B00" />
    <path d="m3.955 15.033.276-.73-.286.379.01.351Z" fill="#7A0000" />
    <path d="m3.689 12.37-.068.395.386-.137-.318-.258Z" fill="#8F0200" />
    <path d="m3.321 13.486.484.172-.128-.497-.356.325Z" fill="#820000" />
    <path d="m3.279 14.35.468-.182-.292-.293-.176.475Z" fill="#7D0000" />
    <path d="m2.532 12.887.34-.226-.405.052.065.174Z" fill="#8A0100" />
    <path d="m3.4 14.532.347-.364-.468.182.121.182Z" fill="#7C0000" />
    <path d="m2.944 9.657-.417.26.579.06-.162-.32Z" fill="#B60D00" />
    <path d="m2.038 9.434.05.058.144-.251-.194.193Z" fill="#B30C00" />
    <path d="m8.275 3.217-.025.01.024.05.001-.06Z" fill="#FF3D00" />
    <path d="m7.016 4.813.162.292.026-.568-.188.276Z" fill="#FF3800" />
    <path
      d="m8.231 3.241.043.036-.023-.05-.02.014ZM8.389 3.305l-.066-.001.06.036.006-.035Z"
      fill="#FF3D00"
    />
    <path d="m5.473 8.272.283-.337-.621.055.338.282Z" fill="#E31E00" />
    <path d="m3.098 10.477-.386-.191.034.44.352-.249Z" fill="#AB0900" />
    <path d="m3.321 13.486.356-.325-.52-.207.164.532Z" fill="#820000" />
    <path
      d="m8.389 3.305-.002-.017-.064.016.066.001ZM8.23 3.241l-.193.194.125-.068.069-.126Z"
      fill="#FF3D00"
    />
    <path d="m8.106 4.07.138-.365-.4-.077.262.442Z" fill="#FF3C00" />
    <path d="m8.387 3.288-.006-.02-.058.036.064-.016Z" fill="#FF3D00" />
    <path d="m7.755 4.355-.55.182.624.264-.074-.446Z" fill="#FF3B00" />
    <path d="m8.274 3.277.055-.057-.026-.006-.03.063Z" fill="#FF3D00" />
    <path d="m8.244 3.705-.082-.338-.125.068.207.27Z" fill="#FF3C00" />
    <path
      d="m8.329 3.22-.006.084.036-.065-.03-.019ZM8.303 3.214l-.028.003-.001.06.029-.063Z"
      fill="#FF3D00"
    />
    <path d="m8.106 4.07-.65-.055.299.34.35-.285Z" fill="#FF3C00" />
    <path d="m2.527 9.916-.529.303.383.259.146-.562Z" fill="#B10B00" />
    <path d="m8.38 3.268-.02-.03-.037.066.058-.036Z" fill="#FF3D00" />
    <path d="m8.163 3.367.22-.027-.06-.036-.16.063Z" fill="#FF3C00" />
    <path d="m8.383 3.34-.22.027.082.338.138-.365Z" fill="#FF3D00" />
    <path d="m7.414 5.898-.433.13.295.235.138-.365Z" fill="#FF3400" />
    <path d="m3.156 12.954.465-.19-.332-.223-.133.413Z" fill="#800" />
    <path d="m3.036 13.95.42-.075-.51-.088.09.164Z" fill="#7F0000" />
    <path d="m2.18 9.69-.183.12-.002.189.185-.308Z" fill="#B20B00" />
    <path d="m2.712 10.286-.33.192.364.247-.034-.44Z" fill="#AD0A00" />
    <path d="m4.188 13.868-.44.3.483.134-.043-.434Z" fill="#7F0000" />
    <path d="m3.805 13.658.383.21-.069-.556-.314.346Z" fill="maroon" />
    <path d="m2.448 10.979-.391.02.025.184.366-.204Z" fill="#A30700" />
    <path d="m2.793 11.164-.047-.439-.298.254.345.185Z" fill="#A00600" />
    <path d="m5.615 10.648-.32.297.044.434.276-.73Z" fill="#B80E00" />
    <path d="m3.675 8.744-.306-.402-.138.486.444-.084Z" fill="#C91300" />
    <path d="m3.698 9.544.429-.226-.165-.336-.264.562Z" fill="#BD0F00" />
    <path d="m3.098 10.477.008-.5-.394.309.386.191Z" fill="#AB0900" />
    <path d="m3.354 11.002-.608-.277.047.439.56-.162Z" fill="#A40700" />
    <path d="m3.805 10.836.226-.503-.505.111.279.392Z" fill="#A80900" />
    <path d="m2.793 11.164.066.336.341.023-.407-.36Z" fill="#A00600" />
    <path d="m4.16 10.693-.078.463.315-.148-.237-.315Z" fill="#AD0A00" />
    <path d="m3.621 12.764.363.219.023-.355-.386.136Z" fill="#8A0100" />
    <path d="m5.568 9.126.129.41.472-.35-.601-.06Z" fill="#D51800" />
    <path d="m3.621 12.765-.465.19.52.206-.055-.396Z" fill="#8A0100" />
    <path d="m3.69 12.37-.155-.476-.227.284.381.192Z" fill="#8F0200" />
    <path d="m3.677 13.161.128.497.314-.346-.442-.151Z" fill="#850000" />
    <path d="m3.69 12.37-.4.17.331.225.068-.395Z" fill="#8F0200" />
    <path d="m4.826 12.438-.282-.506-.09.663.372-.157Z" fill="#930300" />
    <path d="m4.401 13.004-.394-.376-.023.355.417.021Z" fill="#890100" />
    <path d="m3.984 12.983-.363-.218.056.396.307-.178Z" fill="#800" />
    <path d="m4.401 13.004.384-.163-.331-.246-.053.41Z" fill="#890100" />
    <path d="m4.544 11.932.015-.616-.431.26.416.356Z" fill="#990400" />
    <path d="m4.401 13.004-.417-.021.135.329.282-.308Z" fill="#890100" />
    <path d="m3.06 13.276.096-.322-.544.134.448.188Z" fill="#850000" />
    <path d="m2.86 13.622.2-.346-.283.18.082.166Z" fill="#820000" />
    <path d="m4.03 10.333-.393-.334-.11.445.504-.111Z" fill="#B20C00" />
    <path d="m2.915 9.15.316-.322-.419-.168.103.49Z" fill="#BC0F00" />
    <path d="m3.527 10.444-.421-.467-.008.5.429-.033Z" fill="#AE0A00" />
    <path d="m2.915 9.15-.3.362.329.145-.029-.507Z" fill="#BC0F00" />
    <path d="m2.98 12.02-.35-.266.093.552.257-.287Z" fill="#940300" />
    <path d="m2.467 12.713.256-.407-.327.203.07.204Z" fill="#8C0100" />
    <path
      d="m3.455 13.875-.134-.39-.375.302.51.088ZM3.455 13.875l-.292.29.116.185.176-.475Z"
      fill="#7F0000"
    />
    <path d="m4.826 12.438-.372.157.331.246.041-.403Z" fill="#930300" />
    <path d="m4.508 13.571.277-.73-.384.163.107.567Z" fill="#830000" />
    <path d="m3.677 13.161.442.151-.134-.33-.308.179Z" fill="#850000" />
    <path d="m4.508 13.571-.107-.567-.282.308.39.26Z" fill="#830000" />
    <path d="m3.535 11.894-.555.125.328.159.227-.284Z" fill="#960300" />
    <path d="m3.98 12.013.564-.082-.416-.355-.148.437Z" fill="#950300" />
    <path d="m3.526 10.444-.172.558.45-.166-.278-.392Z" fill="#AE0A00" />
    <path
      d="m3.2 11.523.335.371.137-.48-.472.109ZM3.2 11.523l.472-.11-.318-.411-.154.52Z"
      fill="#9B0500"
    />
    <path d="m3.98 12.013.148-.437-.593.318.445.119Z" fill="#950300" />
    <path d="m3.672 11.413.133-.577-.451.166.318.411Z" fill="#9E0600" />
    <path d="m5.123 10.544-.22-.453-.246.261.466.192Z" fill="#B60D00" />
    <path d="m4.128 11.576-.046-.42-.41.257.456.163Z" fill="#9D0500" />
    <path d="m3.672 11.413.41-.257-.277-.32-.133.577Z" fill="#9E0600" />
    <path d="m2.98 12.02.555-.126-.334-.371-.22.496Z" fill="#940300" />
    <path d="m3.535 11.894.154.476.291-.357-.445-.119Z" fill="#960300" />
    <path d="m2.425 9.047-.194.194.384.271-.19-.465Z" fill="#B90E00" />
    <path d="m3.232 8.828-.317.322h.608l-.291-.322Z" fill="#C31100" />
    <path d="m2.527 9.916.088-.404-.434.179.346.225Z" fill="#B10B00" />
    <path d="m3.269 9.504-.325.153.162.32.163-.473Z" fill="#BA0E00" />
    <path d="m1.995 9.999.532-.083-.347-.225-.185.308Z" fill="#AF0A00" />
    <path d="m3.106 9.977-.58-.061.186.37.394-.31Z" fill="#B30C00" />
    <path d="m2.49 11.392.369.108-.066-.336-.303.228Z" fill="#9D0500" />
    <path d="m2.98 12.02-.121-.52-.23.254.351.265Z" fill="#940300" />
    <path d="m2.723 12.306.584-.128-.327-.159-.257.287Z" fill="#900200" />
    <path d="m3.69 12.37-.382-.192-.018.363.4-.171Z" fill="#8F0200" />
    <path d="m4.152 12.314-.463.056.318.258.145-.314Z" fill="#910200" />
    <path d="m3.98 12.013.172.3.392-.381-.564.08Z" fill="#950300" />
    <path d="m3.675 8.744-.444.084.292.323.152-.407Z" fill="#C91300" />
    <path d="m4.398 9.72.031.356.435-.362-.466.006Z" fill="#C01000" />
    <path d="m2.915 9.15.029.507.325-.153-.354-.354Z" fill="#BC0F00" />
    <path d="m2.527 9.916.417-.26-.329-.144-.088.404Z" fill="#B10B00" />
    <path d="m4.007 12.628.394.376.052-.409-.446.033Z" fill="#8C0100" />
    <path d="m3.69 12.37.462-.056-.171-.301-.292.357Z" fill="#8F0200" />
    <path d="M3.523 9.15h-.608l.354.354.254-.353Z" fill="#C21100" />
    <path d="m3.962 8.982.156-.428-.443.19.287.238Z" fill="#C81300" />
    <path d="m3.637 9.999-.531-.022.42.467.11-.445Z" fill="#B50D00" />
    <path d="m3.269 9.504.429.04-.175-.393-.254.353Z" fill="#BA0E00" />
    <path d="m3.586 7.886-.774.774.557-.318.217-.456Z" fill="#D41800" />
    <path d="m2.812 8.66.42.168.137-.486-.557.318Z" fill="#C11000" />
    <path d="m4.397 11.008-.315.148.477.16-.162-.308Z" fill="#A90900" />
    <path d="m4.398 9.72-.35.076.381.28-.031-.356Z" fill="#C01000" />
    <path d="m3.637 9.999-.368-.495-.163.473.53.022Z" fill="#B50D00" />
    <path d="m4.127 9.317.27.403.213-.289-.483-.114Z" fill="#C41200" />
    <path d="m4.048 9.796-.35-.252-.061.455.41-.203Z" fill="#BC0F00" />
    <path d="m3.637 9.999.061-.455-.429-.04.368.495Z" fill="#B50D00" />
    <path d="m4.16 10.693.497-.34-.626-.02.13.36Z" fill="#AD0A00" />
    <path d="m4.048 9.796-.411.203.394.334.017-.537Z" fill="#BC0F00" />
    <path d="m7.205 4.537.55-.182-.298-.34-.252.522Z" fill="#FF3900" />
    <path d="m7.83 4.801.276-.73-.351.284.074.446Z" fill="#FF3A00" />
    <path d="m7.457 4.015-.774.775.522-.253.252-.522Z" fill="#FF3B00" />
    <path d="m6.683 4.79.065.494.268-.471-.333-.023Z" fill="#FF3700" />
    <path d="m6.981 6.028.433-.13-.382-.244-.051.374Z" fill="#F30" />
    <path d="m7.585 5.126-.38-.589-.027.568.407.021Z" fill="#FF3800" />
    <path d="m5.909 5.564.552.165-.165-.552-.387.387Z" fill="#FF3100" />
    <path d="m7.178 5.105-.43.18.284.369.146-.549Z" fill="#FF3700" />
    <path d="m7.553 5.532.276-.73-.244.324-.032.406Z" fill="#FF3600" />
    <path d="m6.086 5.978.375-.25-.552-.164.177.414Z" fill="#FF3000" />
    <path
      d="m4.007 12.628.446-.033-.301-.281-.145.314ZM4.785 12.84l.277-.73-.236.328-.04.403Z"
      fill="#8C0100"
    />
    <path d="m4.826 12.438.236-.328-.518-.178.282.506Z" fill="#930300" />
    <path d="m4.231 14.302.277-.73-.32.296.043.434Z" fill="#7D0000" />
    <path d="m4.12 13.312.068.556.32-.297-.389-.26Z" fill="#840000" />
    <path d="m4.048 9.796-.017.537.398-.257-.381-.28Z" fill="#BC0F00" />
    <path d="m5.943 8.45-.47-.178.038.438.432-.26Z" fill="#E41E00" />
    <path d="m5.062 12.11.277-.731-.406.264.129.467Z" fill="#990400" />
    <path d="m4.887 10.832-.328.484.402-.119-.074-.365Z" fill="#AF0B00" />
    <path d="m6.36 6.334.253-.269-.528-.087.275.356Z" fill="#FF2F00" />
    <path d="m6.46 5.729.153.336.419-.411-.572.075Z" fill="#F30" />
    <path d="m7.032 5.654.52-.122-.374-.427-.146.549Z" fill="#FF3500" />
    <path
      d="m7.414 5.898.139-.366-.521.122.382.244ZM6.295 5.177l.453.107-.066-.494-.387.387Z"
      fill="#FF3400"
    />
    <path d="m7.205 4.537.38.59.244-.326-.624-.264Z" fill="#FF3900" />
    <path d="m6.46 5.729.572-.075-.284-.37-.288.445Z" fill="#F30" />
    <path d="m6.828 6.52-.215-.455-.253.27.468.185Z" fill="#FE2F00" />
    <path d="m5.235 7.592.52.343.055-.361-.575.018Z" fill="#EB2200" />
    <path d="m7.585 5.126-.407-.021.375.427.032-.406Z" fill="#FF3800" />
    <path d="m6.36 6.334-.274-.356-.294.221.568.135Z" fill="#FF2F00" />
    <path d="m6.981 6.028-.153.492.448-.257-.295-.235Z" fill="#F30" />
    <path d="m6.156 7.457.138-.336-.535-.148.397.484Z" fill="#F42700" />
    <path d="m6.13 6.798.23-.464-.612.23.381.234Z" fill="#FB2B00" />
    <path d="m7 6.994.276-.731-.448.257.171.474Z" fill="#FD2D00" />
    <path d="m7.205 4.537-.522.253.333.023.189-.276Z" fill="#FF3900" />
    <path d="m6.46 5.729-.375.249.528.087-.153-.336Z" fill="#F30" />
    <path d="m6.46 5.729.288-.445-.453-.107.165.552Z" fill="#F30" />
    <path d="m6.749 5.284.43-.18-.163-.291-.267.471Z" fill="#FF3500" />
    <path d="m4.544 11.932-.392.381.301.282.091-.663Z" fill="#990400" />
    <path d="m5.459 10.17.156.478.277-.73-.433.253Z" fill="#C01000" />
    <path d="m4.128 11.576.43-.26-.476-.16.046.42Z" fill="#9D0500" />
    <path d="m3.805 10.836.355-.143-.129-.36-.226.503Z" fill="#A80900" />
    <path d="m4.543 10.691.344.141-.23-.48-.114.34Z" fill="#AF0B00" />
    <path d="M4.864 9.714 4.61 9.43l-.212.289.466-.006Z" fill="#C41200" />
    <path d="m4.902 10.091-.473-.014.228.275.245-.26Z" fill="#BD0F00" />
    <path d="m4.03 10.333.627.02-.228-.276-.398.256Z" fill="#B20C00" />
    <path d="m4.933 11.643.028-.446-.402.12.374.326Z" fill="#A00600" />
    <path d="m5.062 12.11-.13-.467-.388.289.518.178Z" fill="#990400" />
    <path d="m4.397 11.008.162.308.328-.484-.49.176Z" fill="#A90900" />
    <path d="m5.616 10.648-.493-.104.173.4.32-.296Z" fill="#B80E00" />
    <path d="m4.902 10.091.22.453.337-.373-.557-.08Z" fill="#BD0F00" />
    <path d="m4.082 11.156.078-.463-.355.143.277.32Z" fill="#A40700" />
    <path d="m4.657 10.352-.497.341.383-.002.114-.339Z" fill="#B60D00" />
    <path d="m4.96 11.197-.027.446.406-.264-.378-.182Z" fill="#A90900" />
    <path d="m4.16 10.693.237.315.146-.317-.383.002Z" fill="#AD0A00" />
    <path d="m6.169 9.186-.27-.32-.331.26.6.06Z" fill="#D81A00" />
    <path d="m5.616 10.648-.157-.477-.336.373.493.104Z" fill="#B80E00" />
    <path d="m4.559 11.316-.015.616.389-.289-.374-.327Z" fill="#A40700" />
    <path d="m5.339 11.379-.043-.434-.335.252.378.182Z" fill="#A80900" />
    <path d="m4.657 10.352.23.48.236-.288-.466-.192Z" fill="#B60D00" />
    <path d="m5.296 10.945-.173-.4-.235.287.408.113Z" fill="#B00B00" />
    <path d="m4.397 11.008.49-.176-.344-.14-.146.316Z" fill="#A90900" />
    <path d="m5.296 10.945-.408-.113.073.365.335-.252Z" fill="#B00B00" />
    <path d="m5.395 6.576.397-.377-.27-.248-.127.625Z" fill="#F82900" />
    <path d="M6.086 5.978 5.52 5.95l.271.248.294-.221Z" fill="#FF3000" />
    <path d="m5.295 6.984-.45.481.39.127.06-.608Z" fill="#F32600" />
    <path d="m6.086 5.978-.177-.414-.388.387.565.027Z" fill="#FF3000" />
    <path d="m5.545 7.322.265.252-.051-.6-.214.348Z" fill="#F12500" />
    <path d="m6.691 7.295-.397-.174-.138.336.535-.162Z" fill="#F92A00" />
    <path d="m5.294 6.984.465-.01-.364-.398-.1.408Z" fill="#F32600" />
    <path d="M4.845 7.465 4.7 7.154l-.29.396.434-.085Z" fill="#E92100" />
    <path d="m5.756 7.935.51.021-.456-.382-.054.361Z" fill="#EB2200" />
    <path d="m5.395 6.576.364.397-.011-.409-.353.012Z" fill="#F82900" />
    <path d="m5.756 7.935-.283.337.47.179-.187-.516Z" fill="#EB2200" />
    <path d="m4.89 6.868.244-.53-.774.774.53-.244Z" fill="#F02500" />
    <path d="m6.999 6.994-.308.301.031.43L7 6.994Z" fill="#FD2D00" />
    <path d="m4.412 7.55.289-.396-.34-.042.05.438Z" fill="#E31E00" />
    <path d="m4.89 6.868.505-.292-.26-.238-.245.53Z" fill="#F02500" />
    <path d="m5.395 6.576.126-.625-.387.387.261.238Z" fill="#F82900" />
    <path d="M6.36 6.334 5.792 6.2l-.044.365.612-.23Z" fill="#FF2F00" />
    <path d="m5.792 6.2-.397.376.353-.012.044-.365Z" fill="#FD2D00" />
    <path d="m4.7 7.154.19-.286-.53.244.34.042Z" fill="#EB2200" />
    <path d="m5.76 6.973-.466.01.251.339.214-.349Z" fill="#F72800" />
    <path d="m3.849 8.29-.263-.404-.217.456.48-.051Z" fill="#D21700" />
    <path d="m5.236 7.592-.391-.127.29.525.1-.398Z" fill="#EB2200" />
    <path d="m5.395 6.576-.505.292.404.116.101-.408Z" fill="#F82900" />
    <path d="m5.294 6.984-.404-.116-.19.286.594-.17Z" fill="#F32600" />
    <path d="m4.127 9.317-.08.479.35-.076-.27-.403Z" fill="#C41200" />
    <path d="m5.294 6.984-.593.17.143.311.45-.481Z" fill="#F32600" />
    <path d="m6.36 6.334.207.548.261-.362-.468-.186Z" fill="#FF2F00" />
    <path d="m7.032 5.654-.419.411.368-.037.05-.374Z" fill="#FF3500" />
    <path d="m3.586 7.886.263.405.303-.42-.566.015Z" fill="#D41800" />
    <path d="m4.36 7.112-.387.387.438.051-.05-.438Z" fill="#E82000" />
    <path d="m5.235 7.592-.1.398.62-.055-.52-.343Z" fill="#EB2200" />
    <path d="m5.294 6.984-.059.608.31-.27-.25-.338Z" fill="#F32600" />
    <path d="m3.973 7.499.179.371.26-.32-.439-.051Z" fill="#DE1C00" />
    <path d="m4.675 7.932.17-.467-.433.085.263.382Z" fill="#E01D00" />
    <path d="m4.411 7.55-.26.32.523.062-.263-.382Z" fill="#E31E00" />
    <path d="m3.586 7.886.566-.016-.179-.371-.387.387Z" fill="#D41800" />
    <path d="m4.674 7.932-.522-.062.177.372.345-.31Z" fill="#E01D00" />
    <path d="m3.675 8.744.174-.453-.48.051.306.402Z" fill="#C91300" />
    <path d="m4.152 7.87-.303.42.48-.048-.177-.372Z" fill="#DB1B00" />
    <path d="m4.652 8.683.38-.226-.337-.155-.043.38Z" fill="#D41800" />
    <path d="m4.844 7.465-.17.467.46.058-.29-.525Z" fill="#E92100" />
    <path d="m6.156 7.457-.346.117.457.382-.11-.499Z" fill="#F42700" />
    <path d="m6.294 7.121.273-.239-.438-.084.165.323Z" fill="#F92A00" />
    <path d="m6.999 6.994-.171-.474-.261.362.432.112Z" fill="#FD2D00" />
    <path d="m5.76 6.973.534.148-.165-.323-.37.175Z" fill="#F72800" />
    <path d="m6.691 7.295-.535.162.566.268-.031-.43Z" fill="#F92A00" />
    <path d="m6.999 6.994-.432-.112.124.413.308-.301Z" fill="#FD2D00" />
    <path d="m6.294 7.121.397.174-.124-.413-.273.24Z" fill="#F92A00" />
    <path d="m5.76 6.973.05.6.346-.116-.397-.484Z" fill="#F72800" />
    <path d="m5.235 7.592.575-.018-.265-.252-.31.27Z" fill="#EB2200" />
    <path d="m4.947 8.928.564-.218-.48-.253-.084.471Z" fill="#D31700" />
    <path
      d="m5.222 9.838-.32.254.557.079-.237-.333ZM5.223 9.837l.67.08-.196-.382-.474.302Z"
      fill="#C41200"
    />
    <path
      d="m4.618 9.072.328.22v-.364l-.328.144ZM5.28 9.433l.288-.307-.621-.198.334.505Z"
      fill="#CD1500"
    />
    <path d="m4.946 9.292-.328-.22-.008.36.336-.14Z" fill="#CC1500" />
    <path d="m4.864 9.714-.435.363.473.014-.038-.377Z" fill="#C41200" />
    <path d="m4.618 9.072-.491.246.483.113.008-.359Z" fill="#CD1500" />
    <path d="m5.892 9.917-.67-.08.237.334.433-.254Z" fill="#C81300" />
    <path d="m5.28 9.433-.334-.141-.082.422.417-.281Z" fill="#CD1500" />
    <path d="m4.903 10.091.32-.254-.36-.123.04.377Z" fill="#BD0F00" />
    <path d="m5.28 9.433-.416.28.359.125.058-.405Z" fill="#CD1500" />
    <path d="m5.943 8.45-.044.417.408-.046-.364-.37Z" fill="#E41E00" />
    <path d="m6.722 7.725-.566-.268.11.5.456-.232Z" fill="#F42700" />
    <path d="m5.472 8.272-.338-.282-.103.467.441-.185Z" fill="#E31E00" />
    <path d="m5.899 8.867.044-.416-.432.259.388.157Z" fill="#DC1B00" />
    <path d="m5.942 8.45.503.006-.179-.5-.324.495Z" fill="#E41E00" />
    <path d="m5.568 9.126.33-.26-.387-.156.057.416Z" fill="#D51800" />
    <path d="m5.942 8.45.365.37.138-.364-.503-.005Z" fill="#E41E00" />
    <path d="m4.947 8.928.62.198-.056-.416-.564.218Z" fill="#D31700" />
    <path d="m5.568 9.126-.288.307.417.102-.13-.409Z" fill="#D51800" />
    <path d="m5.223 9.838.474-.303-.417-.102-.057.405Z" fill="#C41200" />
    <path d="m5.899 8.867.27.32.138-.366-.408.046Z" fill="#DC1B00" />
    <path d="m6.169 9.186-.472.35.195.381.277-.73Z" fill="#D81A00" />
    <path d="m5.51 8.71-.038-.438-.44.185.479.253Z" fill="#DC1B00" />
    <path d="m4.652 8.683-.333.19.298.199.035-.39Z" fill="#D41800" />
    <path d="m4.674 7.932.02.37.44-.312-.46-.058Z" fill="#E01D00" />
    <path d="m4.33 8.242.365.06-.02-.37-.345.31Z" fill="#D81900" />
    <path d="m4.118 8.554.534.129-.323-.44-.21.31Z" fill="#D11600" />
    <path d="m5.134 7.99-.44.312.337.155.103-.467Z" fill="#E41F00" />
    <path d="m5.943 8.45.324-.494-.511-.02.187.515Z" fill="#E41E00" />
    <path d="m6.446 8.456.276-.731-.455.231.179.5Z" fill="#E72000" />
    <path d="m4.864 9.714.082-.422-.336.14.254.282Z" fill="#C41200" />
    <path d="m5.28 9.433-.333-.505-.001.364.335.141Z" fill="#CD1500" />
    <path d="m3.85 8.29.268.264.211-.312-.48.049Z" fill="#D21700" />
    <path d="m3.698 9.544.265-.562-.44.169.175.393Z" fill="#BD0F00" />
    <path d="m4.127 9.318.192-.446-.357.11.165.336Z" fill="#C41200" />
    <path d="m3.698 9.544.35.252.079-.479-.43.227Z" fill="#BD0F00" />
    <path d="m3.675 8.744.443-.19-.269-.263-.174.453Z" fill="#C91300" />
    <path d="m4.652 8.683-.534-.13.2.32.334-.19Z" fill="#D41800" />
    <path d="m4.118 8.554-.156.428.357-.11-.2-.318Z" fill="#D11600" />
    <path d="m3.523 9.15.44-.168-.287-.238-.153.407Z" fill="#C21100" />
    <path d="m4.652 8.683-.034.389.329-.144-.295-.245Z" fill="#D41800" />
    <path d="m4.127 9.318.49-.246-.298-.2-.192.446Z" fill="#C41200" />
    <path d="m5.032 8.457-.38.226.295.245.085-.47Z" fill="#DC1B00" />
    <path d="m4.33 8.242.322.44.043-.38-.365-.06Z" fill="#D81900" />
    <path d="m7.728 17.315-.348.246.164.055.184-.3Z" fill="#92010C" />
    <path d="m12.81 17.493.11-.488-.48.268.37.22Z" fill="#CD0160" />
    <path d="m7.67 16.968-.307.202.365.145-.059-.348Z" fill="#91010B" />
    <path d="m11.928 17.766.185-.403-.389-.082.204.485Z" fill="#C60151" />
    <path d="m12.18 17.016-.456.265.39.082.065-.347Z" fill="#CA0158" />
    <path d="m7.544 17.616.165.051.019-.352-.184.301Z" fill="#91000B" />
    <path d="m12.82 16.692.1.313.225-.358-.325.045Z" fill="#CF0162" />
    <path d="m8.24 17.806.17.037.183-.299-.352.262Z" fill="#9A0114" />
    <path d="m7.001 17.42.128-.532-.288.465.16.066Z" fill="#8A0005" />
    <path d="m6.841 17.353-.114-.435-.07.353.184.082Z" fill="#880004" />
    <path d="m7.364 17.17-.235-.282-.128.531.363-.25Z" fill="#8D0008" />
    <path d="m8.25 17.394.37-.18-.411-.372.04.552Z" fill="#9A0113" />
    <path d="m13.5 17.197.076-.474-.431-.076.355.55Z" fill="#D10069" />
    <path d="m7.001 17.42.189.073.174-.323-.363.25Z" fill="#8A0005" />
    <path d="m7.876 17.715.373-.32-.521-.08.148.4Z" fill="#95010F" />
    <path d="m7.363 17.17.017.391.348-.246-.365-.145Z" fill="#8D0008" />
    <path d="m8.593 17.544-.344-.15-.008.412.352-.262Z" fill="#9F0118" />
    <path d="m13.376 16.352.2.371.173-.357-.373-.014Z" fill="#D3016A" />
    <path d="m9.584 17.594-.308-.265.024.642.284-.377Z" fill="#AC0229" />
    <path d="m10.581 17.575-.23.42.174-.01.056-.41Z" fill="#B9023A" />
    <path d="m9.824 18 .26-.345-.5-.061.24.406Z" fill="#AF022D" />
    <path d="m6.668 16.381-.023-.428-.406.436.429-.008Z" fill="#840001" />
    <path d="m6.727 16.918-.227.279.157.074.07-.353Z" fill="#850002" />
    <path d="m8.022 17.133-.353-.165.06.347.293-.182Z" fill="#96010F" />
    <path d="m10.176 18 .175-.006-.267-.339.092.345Z" fill="#B30233" />
    <path d="m9.65 17.994-.066-.4-.11.39.175.01Z" fill="#AD022A" />
    <path d="m6.842 17.353.287-.465-.401.03.114.435Z" fill="#880004" />
    <path d="m12.307 16.727-.126-.392-.185.34.31.052Z" fill="#CC015A" />
    <path d="m9.474 17.985.11-.391-.284.377.174.014Z" fill="#AB0227" />
    <path d="m9.9 16.756-.45.136.15.313.3-.449Z" fill="#B3032D" />
    <path d="m12.505 16.093.037.424.355-.255-.392-.17Z" fill="#CF025D" />
    <path d="m9.276 17.329-.149.625.174.017-.025-.642Z" fill="#A80223" />
    <path d="m8.923 17.529-.142.38.173.024-.03-.404Z" fill="#A3011E" />
    <path d="m8.581 17.875.2.034-.189-.365-.011.331Z" fill="#9F0119" />
    <path d="m8.072 17.766.169.04.008-.412-.177.372Z" fill="#980112" />
    <path
      d="m11.084 17.58-.203-.29-.3.285.503.006ZM11.084 17.58l.355-.065-.245-.446-.11.512Z"
      fill="#BE0243"
    />
    <path d="m8.022 17.133-.294.182.521.08-.227-.262Z" fill="#96010F" />
    <path d="m4.855 16.126.013.015.046-.058-.059.043Z" fill="#7A0000" />
    <path d="m6.11 16.039.535-.086-.507-.286-.028.372Z" fill="#7F0000" />
    <path d="m4.847 16.037-.006.019.041.002-.035-.02Z" fill="#7A0000" />
    <path d="m11.76 17.806-.322-.29.152.327.17-.037Z" fill="#C4014E" />
    <path d="m8.924 17.529-.304-.315-.027.33.33-.015Z" fill="#A3011E" />
    <path d="m5.008 16.256-.094-.173-.046.058.14.115Z" fill="#7A0000" />
    <path d="m11.724 17.28-.257-.479-.274.268.531.212Z" fill="#C5014F" />
    <path d="m5.562 15.754.18.34.079-.577-.259.237Z" fill="#7D0000" />
    <path d="m5.183 15.692.206.414.173-.352-.379-.062Z" fill="#7B0000" />
    <path d="m4.882 16.058-.043.017.007.034.036-.05Z" fill="#7A0000" />
    <path
      d="m4.882 16.058-.04-.002-.003.019.043-.017ZM4.882 16.058l-.036.051.068-.026-.032-.025Z"
      fill="#7A0000"
    />
    <path d="m12.919 15.925.459-.49-.557.167.098.323Z" fill="#D20263" />
    <path d="m4.855 16.126.06-.043-.069.026.01.017Z" fill="#7A0000" />
    <path d="m14.531 16.093.137.408.164-.12-.3-.288Z" fill="#D60073" />
    <path d="m5.668 16.73.209-.299-.378.187.17.112Z" fill="#7D0000" />
    <path d="m5.39 16.106.11.512.242-.524-.352.012Z" fill="#7B0000" />
    <path d="m4.914 16.083.094.173.084-.339-.178.166Z" fill="#7A0000" />
    <path d="m6.166 17.025.254-.293-.405.208.151.085Z" fill="#800001" />
    <path d="m11.419 17.875.17-.032-.15-.328-.02.36Z" fill="#C10249" />
    <path d="m6.727 16.918-.408.188.181.091.227-.279Z" fill="#850002" />
    <path d="m10.35 17.994.232-.419-.498.08.267.34Z" fill="#B50236" />
    <path d="m10.582 17.575.299-.285-.493-.217.194.502Z" fill="#B9023A" />
    <path d="m6.42 16.732-.254.293.153.081.101-.374Z" fill="#820001" />
    <path d="m11.219 17.909.2-.034-.335-.294.135.328Z" fill="#BF0245" />
    <path d="m6.32 17.106.407-.188-.307-.186-.1.374Z" fill="#820001" />
    <path d="m5.742 16.093-.243.525.378-.186-.135-.338Z" fill="#7D0000" />
    <path d="m9.6 17.204-.016.39.335-.256-.32-.134Z" fill="#AD0228" />
    <path d="m5.877 16.431.138.51.224-.552-.362.043Z" fill="#7D0000" />
    <path d="m4.867 16.008.225-.09.091-.226-.316.316Z" fill="#7A0000" />
    <path d="m10 11.005-.034-.086-.03.02.065.066Z" fill="#E51620" />
    <path d="m8.934 12.544-.373.436.21.21.163-.646Z" fill="#D3111B" />
    <path d="m4.866 16.008-.02.03.036.02-.016-.05Z" fill="#7A0000" />
    <path d="m4.915 16.083-.048-.074.015.05.033.024Z" fill="#7A0000" />
    <path d="m6.239 16.389-.224.551.405-.209-.181-.343Z" fill="maroon" />
    <path d="m5.39 16.106-.207-.414-.09.225.297.19Z" fill="#7B0000" />
    <path d="m9.966 10.92.035.085v-.092l-.035.006Z" fill="#E51620" />
    <path d="m9.584 17.594.065.4.175.006-.24-.406Z" fill="#AC0229" />
    <path d="m8.994 17.007-.07.522.352-.2-.282-.322Z" fill="#A5021E" />
    <path d="m15.134 16.008-.317-.317.091.226.226.09Z" fill="#D60074" />
    <path d="m10 18.002.176-.002-.092-.345-.084.347Z" fill="#B10230" />
    <path d="m6.907 16.626-.24-.245-.247.35.487-.105Z" fill="#870003" />
    <path d="m10.7 17.971.173-.017-.291-.379.118.396Z" fill="#B9023C" />
    <path d="m8.593 17.544.189.365.142-.38-.331.015Z" fill="#9F0118" />
    <path d="m10.582 17.575-.057.41.175-.014-.118-.396Z" fill="#B9023A" />
    <path d="m7.71 17.667.166.048-.148-.4-.019.352Z" fill="#93010D" />
    <path d="m6.668 16.381-.43.008.182.343.248-.35Z" fill="#840001" />
    <path d="m10.582 17.575.291.38.21-.374-.502-.006Z" fill="#B9023A" />
    <path d="m8.249 17.394-.373.321.196.051.177-.372Z" fill="#9A0113" />
    <path d="m11.084 17.58-.21.374.172-.02.038-.353Z" fill="#BE0243" />
    <path d="m11.439 17.515-.355.066.335.294.02-.36Z" fill="#C2024A" />
    <path d="m14.183 16.32.149.41.17-.113-.32-.297Z" fill="#D50071" />
    <path d="m11.76 17.806.168-.04-.204-.485.035.525Z" fill="#C4014E" />
    <path d="m12.92 17.005-.11.488.189-.074-.079-.415Z" fill="#CF0163" />
    <path d="m13.145 16.647-.248-.385-.077.43.325-.045Z" fill="#D10167" />
    <path d="m11.724 17.28-.286.235.321.291-.035-.525Z" fill="#C5014F" />
    <path d="m14.183 16.32-.193.25.342.16-.15-.41Z" fill="#D50071" />
    <path d="m10.835 12.745.27.219.088-.387-.358.168Z" fill="#DE122B" />
    <path d="m7.67 16.968.352.165-.14-.477-.213.312Z" fill="#91010B" />
    <path d="m12.124 17.715-.01-.353-.186.404.196-.05Z" fill="#C80155" />
    <path d="m12.44 17.273-.15.394.166-.051-.015-.343Z" fill="#CB015B" />
    <path d="m12.542 16.517.007.434.27-.259-.277-.175Z" fill="#CE015E" />
    <path d="m12.113 17.362.178.305.15-.394-.328.09Z" fill="#C80156" />
    <path d="m7.656 15.03.29.056-.14-.561-.15.505Z" fill="#9C040A" />
    <path d="m6.015 16.94-.138-.509-.012.421.15.088Z" fill="#7F0000" />
    <path d="m12.44 17.273.016.343.164-.055-.18-.288Z" fill="#CB015B" />
    <path d="m10 18.002.084-.347-.26.345.176.002Z" fill="#B10230" />
    <path d="m12.44 17.273.48-.268-.371-.054-.109.322Z" fill="#CB015B" />
    <path d="m12.92 17.005.24.348.184-.082-.424-.267Z" fill="#CF0163" />
    <path d="m8.924 17.529.203.425.15-.625-.353.2Z" fill="#A3011E" />
    <path d="m13.344 17.27.156-.073-.355-.55.199.624Z" fill="#D00067" />
    <path d="m10 11.005-.065-.065-.158.158.224-.093Z" fill="#E51620" />
    <path d="m9.127 17.954-.203-.425.03.404.173.021Z" fill="#A60122" />
    <path d="m13.145 16.647-.225.358.424.266-.199-.624Z" fill="#D10167" />
    <path d="M10 11.411v-.406l-.223.093.224.313Z" fill="#E41620" />
    <path d="m13 17.42.16-.067-.24-.349.08.415Z" fill="#CE0162" />
    <path d="m6.138 15.667-.317-.15-.08.576.397-.426Z" fill="#810000" />
    <path d="m12.113 17.362.011.353.167-.048-.178-.305Z" fill="#C80156" />
    <path d="m10.582 17.575-.284-.179-.214.259.498-.08Z" fill="#B9023A" />
    <path
      d="m13.576 16.723-.075.474.18-.09-.105-.384ZM13.576 16.723l.41.217.004-.37-.414.153Z"
      fill="#D3006B"
    />
    <path d="m13.854 16.039.33-.097-.288-.245-.042.342Z" fill="#D5006E" />
    <path d="m14.136 16.852-.145-.281-.005.369.15-.088Z" fill="#D4006F" />
    <path d="M10.383 11.257 10 11.41l.268.276.114-.43Z" fill="#E51621" />
    <path d="m10 11.411-.381-.154-.004.313.386-.159Z" fill="#E41620" />
    <path d="m13.834 17.025-.258-.302.105.383.153-.081Z" fill="#D3006D" />
    <path d="m5.333 16.502.166.116-.11-.512-.056.395Z" fill="#7B0000" />
    <path d="m13.376 16.352.373.014.106-.327-.48.313Z" fill="#D3016A" />
    <path d="m10 11.005.066-.065-.03-.02-.035.085Z" fill="#E51620" />
    <path d="m10 11.005.036-.086-.035-.006v.092Z" fill="#E51620" />
    <path d="m13.51 14.782-.326-.14.056.378.27-.238Z" fill="#D60363" />
    <path d="m10.225 11.098-.159-.158-.066.065.225.093Z" fill="#E51620" />
    <path d="m14.183 16.32.318.297.167-.116-.485-.181Z" fill="#D50071" />
    <path d="m13.99 16.57.193-.25-.434.046.241.205Z" fill="#D4006F" />
    <path d="m11.046 17.933.173-.024-.135-.328-.038.352Z" fill="#BD0242" />
    <path d="m15.134 16.008-.011.06.031-.031-.02-.03Z" fill="#D60074" />
    <path d="m14.503 15.77-.318.172.346.15-.028-.322Z" fill="#D60072" />
    <path d="m13.576 16.723.258.302.152-.085-.41-.217Z" fill="#D3006B" />
    <path d="m14.183 16.32.485.181-.137-.408-.348.227Z" fill="#D50071" />
    <path d="m9.302 11.573.313-.004.004-.312-.317.316Z" fill="#E0151E" />
    <path d="m15.143 16.128-.057-.045.044.06.013-.015Z" fill="#D60074" />
    <path d="m14.185 15.942-.33.097.328.28.002-.377Z" fill="#D50071" />
    <path d="m6.85 14.966-.268.203.253.169.015-.372Z" fill="#900203" />
    <path d="m14.993 16.255.138-.113-.045-.059-.093.172Z" fill="#D60074" />
    <path d="m8.985 11.89.355.355.101-.343-.456-.012Z" fill="#DB141D" />
    <path
      d="m15.153 16.111-.03-.043.02.06.01-.017ZM15.086 16.083l.036-.015.012-.06-.048.075Z"
      fill="#D60074"
    />
    <path d="m15.153 16.111.006-.018-.036-.025.03.043Z" fill="#D60074" />
    <path d="m15.16 16.093.002-.019-.04-.006.037.025Z" fill="#D60074" />
    <path d="m10.269 11.687-.155.31.379-.005-.224-.305Z" fill="#E41622" />
    <path d="m15.086 16.083.057.045-.02-.06-.037.015Z" fill="#D60074" />
    <path d="m10.298 17.396-.379-.058.165.317.214-.259Z" fill="#B60235" />
    <path d="m7.496 16.132-.2-.291-.152.314.352-.023Z" fill="#900107" />
    <path d="m15.162 16.074-.002-.019-.037.013.039.006Z" fill="#D60074" />
    <path d="m10.224 11.098-.223.313.382-.154-.159-.159Z" fill="#E51620" />
    <path d="m5.092 15.917-.084.339.381-.15-.297-.189Z" fill="#7A0000" />
    <path d="m10.7 11.573-.207.42.523-.103-.317-.317Z" fill="#E41523" />
    <path d="m14.993 16.255-.085-.338-.377.176.462.162Z" fill="#D60074" />
    <path d="m4.915 16.083.177-.166-.225.092.048.074Z" fill="#7A0000" />
    <path d="m9.302 11.573.14.33.173-.334-.313.004Z" fill="#E0151E" />
    <path d="m14.908 15.917.178.166.048-.075-.226-.091Z" fill="#D60074" />
    <path d="m9.584 17.594.5.061-.165-.317-.335.256Z" fill="#AC0229" />
    <path d="m10.298 17.396-.237-.354-.142.296.379.058Z" fill="#B60235" />
    <path d="m15.16 16.055-.006-.018-.031.031.037-.013Z" fill="#D60074" />
    <path d="m14.832 16.38.16-.125-.46-.162.3.287Z" fill="#D60073" />
    <path d="m5.39 16.106-.382.15.16.125.221-.275Z" fill="#7B0000" />
    <path d="m14.992 16.255.094-.172-.178-.166.085.338Z" fill="#D60074" />
    <path d="m6.727 16.918.18-.292-.487.106.307.186Z" fill="#850002" />
    <path d="m6.907 16.626-.18.292.402-.03-.222-.262Z" fill="#870003" />
    <path d="m9.166 16.724.438-.135-.34-.18-.098.316Z" fill="#A80220" />
    <path d="m7.514 14.23-.407.079.126.313.281-.392Z" fill="#A4060B" />
    <path d="m12.505 16.093-.324.242.361.182-.037-.424Z" fill="#CF025D" />
    <path d="m8.62 17.214-.003-.41-.408.038.41.372Z" fill="#9F0118" />
    <path d="m7.814 16.285-.318-.153-.15.394.468-.24Z" fill="#95010B" />
    <path d="m6.907 16.626.237-.47-.477.225.24.245Z" fill="#870003" />
    <path d="m10.383 11.257-.114.43.43-.114-.316-.316Z" fill="#E51621" />
    <path d="m10 11.411.225-.313-.224-.093v.406Z" fill="#E41620" />
    <path d="m12.567 15.785-.311-.038.25.346.061-.308Z" fill="#D1025D" />
    <path d="m12.919 15.925-.352-.14-.062.308.414-.168Z" fill="#D20263" />
    <path d="m8.249 17.394.344.15.026-.33-.37.18Z" fill="#9A0113" />
    <path d="m8.41 17.843.171.032.012-.33-.182.298Z" fill="#9D0117" />
    <path d="m13.99 16.57-.24-.204-.174.357.414-.152Z" fill="#D4006F" />
    <path d="m14.332 16.73-.342-.16.145.282.197-.122Z" fill="#D50071" />
    <path d="m14.23 15.595-.139-.445-.194.547.333-.101Z" fill="#D60170" />
    <path d="M13.855 16.039 13.248 16l.127.351.48-.313Z" fill="#D5006E" />
    <path d="m5.877 16.431.233-.392-.368.054.135.338Z" fill="#7D0000" />
    <path d="m5.5 15.375-.317.317.38.062-.063-.38Z" fill="#7E0000" />
    <path d="m5.5 15.375.32.142-.003-.459-.317.317Z" fill="#7E0000" />
    <path d="m5.5 15.375.062.379.259-.237-.321-.142Z" fill="#7E0000" />
    <path d="m5.817 15.058.004.459.458-.313-.462-.146Z" fill="#830000" />
    <path d="m6.28 15.204-.46.313.318.15.141-.463Z" fill="#860101" />
    <path d="m6.134 14.741-.317.317.462.146-.145-.463Z" fill="#890101" />
    <path d="m14.5 15.374.003.396.314-.079-.316-.317Z" fill="#D60170" />
    <path d="m5.333 16.502.057-.396-.221.275.164.12Z" fill="#7B0000" />
    <path d="m5.562 15.754-.172.352.352-.013-.18-.34Z" fill="#7D0000" />
    <path d="m14.818 15.691-.315.079.405.147-.09-.226Z" fill="#D60073" />
    <path d="m14.23 15.595.273.175-.002-.396-.27.221Z" fill="#D60170" />
    <path d="m14.183 16.32.348-.227-.346-.151-.002.378Z" fill="#D50071" />
    <path d="m14.908 15.917-.405-.147.028.323.377-.176Z" fill="#D60074" />
    <path d="m13.854 16.039.042-.342-.362.071.32.27Z" fill="#D5006E" />
    <path d="m14.183 16.32-.328-.281-.106.327.434-.046Z" fill="#D50071" />
    <path d="m14.091 15.15.14.445.27-.22-.41-.225Z" fill="#D6016C" />
    <path d="m13.896 15.697.289.245.045-.347-.334.102Z" fill="#D5016E" />
    <path d="m14.5 15.374-.633-.633.224.409.41.224Z" fill="#D60170" />
    <path d="m14.091 15.15-.224-.41-.202.377.426.033Z" fill="#D6016C" />
    <path d="m8.668 12.207.336.019-.02-.336-.316.317Z" fill="#D4121B" />
    <path d="m9.615 11.57.221.22.165-.379-.386.159Z" fill="#E2161F" />
    <path d="m9.836 11.79.278.207.155-.31-.433.104Z" fill="#E21520" />
    <path d="m10.358 12.293-.244-.296-.083.337.327-.04Z" fill="#E01424" />
    <path d="m13.145 16.647.23-.295-.478-.09.248.385Z" fill="#D10167" />
    <path d="m12.542 16.517-.235.21.242.224-.007-.434Z" fill="#CE015E" />
    <path d="m12.178 14.928.001.413.458-.208-.46-.204Z" fill="#D30651" />
    <path d="m12.542 16.517.278.175.077-.43-.355.255Z" fill="#CE015E" />
    <path d="m12.18 17.016-.067.347.328-.09-.261-.257Z" fill="#CA0158" />
    <path d="m12.92 17.005-.1-.313-.271.26.371.052Z" fill="#CF0163" />
    <path d="m14.185 15.942.318-.172-.273-.175-.045.347Z" fill="#D50071" />
    <path d="m10 11.411-.223-.313-.159.159.383.154Z" fill="#E41620" />
    <path d="m9.836 11.79.433-.103-.268-.276-.165.38Z" fill="#E21520" />
    <path d="m9.704 12.145.41-.148-.278-.206-.132.354Z" fill="#DF1420" />
    <path d="m10.493 11.992-.379.005.244.296.135-.3Z" fill="#E21524" />
    <path d="m10.358 12.293.01.324.319-.299-.33-.025Z" fill="#E01424" />
    <path d="m10.687 12.318-.32.3.467.127-.147-.427Z" fill="#E11327" />
    <path d="m11.016 11.89-.523.102.193.326.33-.428Z" fill="#E21427" />
    <path d="m10.7 11.573-.431.114.224.306.207-.42Z" fill="#E41523" />
    <path d="m9.675 13.767-.097-.383-.344.194.44.189Z" fill="#CB0D22" />
    <path d="m10.687 12.318-.194-.325-.135.3.329.025Z" fill="#E11327" />
    <path d="m8.538 12.583.396-.04-.266-.336-.13.376Z" fill="#CD1019" />
    <path d="m11.296 16.369-.22-.265-.1.3.32-.035Z" fill="#C50347" />
    <path d="m10.367 12.617-.336-.283.046.427.29-.144Z" fill="#DE1326" />
    <path d="m12.178 14.928.336-.136-.33-.33-.006.466Z" fill="#D30651" />
    <path d="m10.588 13.912-.24-.362-.169.508.41-.146Z" fill="#D20D30" />
    <path d="m11.912 15.656-.552.253.284.152.268-.405Z" fill="#CE0451" />
    <path d="m6.645 15.953-.1-.415-.407.129.507.286Z" fill="#850000" />
    <path d="m6.279 15.204-.141.463.407-.13-.266-.334Z" fill="#860101" />
    <path d="m11.777 16.355-.133-.294-.348.308.481-.014Z" fill="#C90350" />
    <path d="m12.18 17.016-.184-.341-.216.267.4.074Z" fill="#CA0158" />
    <path d="m6.545 15.538.46.108-.17-.308-.29.2Z" fill="#870000" />
    <path d="m7.195 15.424-.36-.086.17.308.19-.222Z" fill="#910205" />
    <path d="m7.006 15.646-.461-.108.1.415.36-.307Z" fill="#8C0103" />
    <path d="m7.681 13.75-.28-.276-.175.458.455-.182Z" fill="#AE090E" />
    <path d="m12.919 15.925-.022.337.35-.261-.328-.076Z" fill="#D20263" />
    <path d="m12.181 16.335.324-.242-.543-.085.22.327Z" fill="#CC0258" />
    <path d="m7.36 14.934-.51.032.277.174.233-.206Z" fill="#980307" />
    <path d="m7.232 14.622-.125-.313-.211.333.336-.02Z" fill="#9A0407" />
    <path d="m6.941 15.937.064-.29-.36.306.296-.016Z" fill="#890002" />
    <path d="m7.881 16.656.49-.352-.273-.175-.217.527Z" fill="#95010C" />
    <path d="m13.248 16 .286-.232-.156-.334-.13.567Z" fill="#D30168" />
    <path d="m12.637 15.133-.458.208.325.108.133-.316Z" fill="#D4045A" />
    <path d="m12.181 16.335-.218-.327-.186.347.404-.02Z" fill="#CC0258" />
    <path d="m11.724 17.28.056-.338-.314-.14.258.479Z" fill="#C5014F" />
    <path d="m6.582 15.17-.037.368.29-.2-.253-.169Z" fill="#8A0101" />
    <path d="m6.538 14.868-.404-.127.145.463.259-.336Z" fill="#8D0202" />
    <path d="m6.667 16.381.477-.226-.202-.218-.275.444Z" fill="#840001" />
    <path d="m7.296 15.84-.1-.416-.19.222.29.195Z" fill="#8F0105" />
    <path d="m6.907 16.626.222.262.216-.362-.438.1Z" fill="#870003" />
    <path d="m7.195 15.424.1.417.17-.305-.27-.112Z" fill="#910205" />
    <path d="m12.919 15.925-.414.168.392.169.022-.337Z" fill="#D20263" />
    <path d="m12.821 15.602-.184-.469-.133.316.317.153Z" fill="#D30260" />
    <path d="m13.378 15.434-.46.49.33.077.13-.567Z" fill="#D50267" />
    <path d="m12.567 15.785.352.14-.098-.323-.254.183Z" fill="#D1025D" />
    <path d="m11.962 16.008.543.085-.25-.346-.293.261Z" fill="#CC0353" />
    <path d="m11.996 16.675.185-.34-.404.02.219.32Z" fill="#CA0255" />
    <path d="m11.912 15.655.267-.314-.505.049.238.265Z" fill="#CE0451" />
    <path d="m11.962 16.008.294-.261-.345-.091.051.352Z" fill="#CC0353" />
    <path d="m11.996 16.675-.219-.32-.31.447.529-.127Z" fill="#CA0255" />
    <path d="m12.307 16.727-.311-.052.183.34.128-.288Z" fill="#CC015A" />
    <path d="m10.846 14.324-.258-.412-.131.277.389.135Z" fill="#D00A36" />
    <path d="m9.356 15.958.257.292.176-.36-.433.068Z" fill="#AF0422" />
    <path d="m11.345 15.545.566.11-.237-.265-.33.155Z" fill="#CA0546" />
    <path d="m11.467 16.802-.387-.098.114.365.273-.267Z" fill="#C5024B" />
    <path d="m12.549 16.951-.242-.224-.128.289.37-.065Z" fill="#CD015E" />
    <path d="m12.181 16.335.126.392.235-.21-.36-.182Z" fill="#CC0258" />
    <path d="m12.179 15.341-.268.315.345.09-.077-.405Z" fill="#D10454" />
    <path d="m11.031 15.36.504-.27-.304-.13-.2.4Z" fill="#C9063F" />
    <path d="m12.256 15.747.311.038-.063-.336-.248.298Z" fill="#CF0358" />
    <path d="m12.179 15.341-.001-.412-.296.182.297.23Z" fill="#D10454" />
    <path d="m13.04 15.317-.219.285.557-.168-.339-.117Z" fill="#D40362" />
    <path d="m13.665 15.117-.425-.097.138.414.287-.316Z" fill="#D60268" />
    <path d="m7.195 15.424.461-.394-.296-.096-.165.49Z" fill="#910205" />
    <path d="m6.134 14.741.404.127-.087-.444-.317.317Z" fill="#890101" />
    <path d="m6.667 16.381.274-.444-.296.016.022.428Z" fill="#840001" />
    <path d="m7.296 15.84-.354.097.202.218.152-.314Z" fill="#8F0105" />
    <path d="m6.942 15.937.354-.096-.29-.195-.064.29Z" fill="#890002" />
    <path d="m7.144 16.155.201.37.15-.393-.351.023Z" fill="#8B0104" />
    <path d="m8.994 17.007-.377-.203.002.41.375-.207Z" fill="#A5021E" />
    <path d="m7.957 15.837-.203-.222-.258.517.46-.295Z" fill="#9A020C" />
    <path d="m7.144 16.155-.237.471.438-.1-.201-.37Z" fill="#8B0104" />
    <path d="m7.496 16.132.317.153.144-.448-.461.295Z" fill="#900107" />
    <path d="m7.129 16.888.54.08-.324-.442-.216.362Z" fill="#8A0005" />
    <path d="m7.345 16.526.324.442.212-.312-.536-.13Z" fill="#8D0106" />
    <path d="m7.225 13.932-.458.176.34.2.118-.376Z" fill="#A4060A" />
    <path d="m7.806 14.525-.292-.295-.282.392.574-.097Z" fill="#A5060C" />
    <path d="m7.656 15.03-.46.394.27.112.19-.506Z" fill="#9C040A" />
    <path d="m6.835 15.338.36.086-.068-.284-.292.198Z" fill="#8C0102" />
    <path d="m7.363 17.17-.174.323.19.068-.016-.391Z" fill="#8D0008" />
    <path d="m7.67 16.968-.541-.08.235.282.306-.203Z" fill="#91010B" />
    <path d="m5.865 16.852.012-.42-.209.298.197.122Z" fill="#7E0000" />
    <path d="m6.11 16.039-.233.392.362-.043-.129-.35Z" fill="#7F0000" />
    <path d="m8.25 17.394-.041-.552-.187.291.227.261Z" fill="#9A0113" />
    <path d="m8.022 17.133.187-.291-.328-.186.141.477Z" fill="#96010F" />
    <path d="m10.582 17.575-.194-.502-.09.323.284.18Z" fill="#B9023A" />
    <path d="m10.297 17.396.09-.323-.326-.031.236.354Z" fill="#B60235" />
    <path d="m11.467 16.802-.17-.433-.217.335.387.098Z" fill="#C5024B" />
    <path d="m7.943 15.382.004-.296-.29-.056.286.352Z" fill="#9D040C" />
    <path d="m9.34 12.245-.406.299.296.134.11-.433Z" fill="#DB131E" />
    <path d="m10.114 11.997-.41.148.326.189.084-.337Z" fill="#E21522" />
    <path d="m6.645 15.953-.535.086.129.35.406-.436Z" fill="#850000" />
    <path d="m6.138 15.667-.396.426.368-.054.028-.372Z" fill="#810000" />
    <path d="m12.81 17.492-.37-.219.18.288.19-.069Z" fill="#CD0160" />
    <path d="m12.18 17.016.26.257.109-.322-.37.065Z" fill="#CA0158" />
    <path d="m13.701 15.439.39-.289-.426-.033.036.322Z" fill="#D5016A" />
    <path d="m13.378 15.434-.138-.414-.2.297.338.117Z" fill="#D50267" />
    <path d="m13.665 15.117-.156-.335-.27.238.426.098Z" fill="#D60268" />
    <path d="m13.701 15.439-.036-.322-.287.317.323.005Z" fill="#D5016A" />
    <path d="m12.637 15.133-.123-.34-.336.136.46.204Z" fill="#D4045A" />
    <path d="m12.895 14.847-.381-.055.123.341.258-.286Z" fill="#D5045C" />
    <path d="m13.534 15.768.167-.329-.323-.005.156.334Z" fill="#D4016A" />
    <path d="m14.091 15.15-.39.289.195.258.195-.547Z" fill="#D6016C" />
    <path d="m12.986 14.347-.09.5.288-.206-.198-.294Z" fill="#D70658" />
    <path d="m13.04 15.317-.403-.184.184.469.218-.285Z" fill="#D40362" />
    <path d="m12.18 17.016-.4-.074-.056.339.455-.265Z" fill="#CA0158" />
    <path d="m13.04 15.317.2-.297-.345-.173.144.47Z" fill="#D40362" />
    <path d="m11.996 16.675-.53.127.314.14.216-.267Z" fill="#CA0255" />
    <path d="m10.347 13.55-.39-.058.03.314.36-.256Z" fill="#D40E2A" />
    <path d="m10.303 16.669.134-.318-.408.027.274.29Z" fill="#B80335" />
    <path d="m11.296 16.369.17.433.311-.447-.48.014Z" fill="#C50347" />
    <path d="m11.962 16.008-.318.053.133.294.185-.347Z" fill="#CC0353" />
    <path d="m11.911 15.656-.267.405.318-.053-.05-.352Z" fill="#CE0451" />
    <path d="m11.644 16.06-.284-.151-.064.46.348-.308Z" fill="#CA034D" />
    <path d="m11.36 15.909-.284.195.22.265.064-.46Z" fill="#C80448" />
    <path d="m11.076 16.104-.32-.128-.039.29.36-.162Z" fill="#C40443" />
    <path d="m10.85 15.648.226.456.284-.195-.51-.261Z" fill="#C5053D" />
    <path d="m10.717 16.266.258.139.101-.3-.359.161Z" fill="#BF043C" />
    <path d="m10.459 15.695-.197.36.494-.08-.297-.28Z" fill="#C00536" />
    <path d="m10.88 17.29.313-.22-.408-.14.096.36Z" fill="#BD0240" />
    <path d="m10.786 16.93.294-.226-.376-.135.082.362Z" fill="#BD023E" />
    <path d="m11.08 16.704-.295.227.408.138-.114-.365Z" fill="#C10344" />
    <path d="m10.704 16.569.376.135-.105-.3-.27.165Z" fill="#BE033C" />
    <path d="m11.296 16.369-.32.036.103.3.217-.336Z" fill="#C50347" />
    <path d="m10.303 16.669.482.262-.081-.362-.4.1Z" fill="#B80335" />
    <path d="m10.388 17.073.493.217-.095-.36-.398.143Z" fill="#B80237" />
    <path d="m11.084 17.58.11-.51-.313.22.203.29Z" fill="#BE0243" />
    <path d="m11.724 17.28-.53-.21.244.445.286-.234Z" fill="#C5014F" />
    <path d="m12.256 15.747.248-.298-.325-.108.077.406Z" fill="#CF0358" />
    <path d="m12.821 15.602-.317-.153.063.336.254-.183Z" fill="#D30260" />
    <path d="m7.813 16.285.285-.156-.141-.292-.144.448Z" fill="#95010B" />
    <path d="m8.592 14.562.32-.15-.29-.204-.03.354Z" fill="#B20815" />
    <path d="m6.45 14.425.445.217-.128-.534-.317.316Z" fill="#910303" />
    <path d="m7.514 14.23.391-.158-.224-.322-.167.48Z" fill="#A4060B" />
    <path d="m7.881 16.656.328.186.184-.238-.512.052Z" fill="#95010C" />
    <path d="m7.345 16.526.536.13-.067-.37-.469.24Z" fill="#8D0106" />
    <path d="m7.466 15.536.289.08.188-.234-.477.154Z" fill="#940207" />
    <path d="m8.617 16.804-.224-.2-.184.238.408-.038Z" fill="#A00217" />
    <path d="m9.9 16.756.162.286.242-.373-.404.087Z" fill="#B3032D" />
    <path d="m8.994 17.007.456-.115-.285-.168-.17.283Z" fill="#A5021E" />
    <path d="m9.44 11.902.396-.111-.222-.222-.173.333Z" fill="#DF151E" />
    <path d="m9.667 12.585.068.436.342-.26-.41-.176Z" fill="#DA1320" />
    <path d="m9.34 12.245.364-.1-.263-.243-.102.343Z" fill="#DB131E" />
    <path d="m9.44 11.902.264.243.132-.354-.395.111Z" fill="#DF151E" />
    <path d="m7.233 14.622-.337.02-.046.324.383-.344Z" fill="#9A0407" />
    <path d="m9.441 11.902-.14-.329-.316.317.456.012Z" fill="#DF151E" />
    <path d="m9.34 12.245-.355-.355.019.336.336.019Z" fill="#DB131E" />
    <path d="m7.225 13.932.176-.458-.634.634.458-.176Z" fill="#A4060A" />
    <path d="m9.23 12.678-.162.501.331-.087-.169-.414Z" fill="#D4121D" />
    <path d="m7.4 13.474.281.276.173-.456-.453.18Z" fill="#AE090E" />
    <path d="m9.235 13.577-.47-.091.19.274.28-.183Z" fill="#C80E1D" />
    <path d="m13.855 16.039-.32-.27-.287.232.607.038Z" fill="#D5006E" />
    <path d="m13.701 15.439-.167.33.362-.072-.195-.258Z" fill="#D5016A" />
    <path d="m12.662 14.461.324-.114-.186-.44-.138.554Z" fill="#D60655" />
    <path d="m11.502 13.895-.216.24.377.217-.161-.457Z" fill="#D70B3D" />
    <path d="m7.195 15.424.165-.49-.233.206.068.284Z" fill="#910205" />
    <path d="m7.807 14.525-.447.41.296.095.15-.505Z" fill="#A5060C" />
    <path d="m9.613 16.25-.256-.292-.092.452.348-.16Z" fill="#B10427" />
    <path d="m8.416 15.941.279.291.032-.485-.311.194Z" fill="#A10313" />
    <path d="m8.62 17.214.303.315.07-.522-.374.207Z" fill="#9F0118" />
    <path d="m8.695 16.232-.302.372.499-.104-.197-.268Z" fill="#A30317" />
    <path d="m9.45 16.892-.456.115.282.322.174-.437Z" fill="#AC0225" />
    <path d="m8.892 16.5-.275.304.377.203-.102-.507Z" fill="#A5021B" />
    <path d="m8.984 16.067-.092.433.373-.09-.28-.343Z" fill="#A9031C" />
    <path d="m8.416 15.94-.46-.103.141.292.32-.188Z" fill="#A10313" />
    <path d="m8.892 16.5-.5.104.225.2.275-.304Z" fill="#A5021B" />
    <path d="m7.881 16.656.512-.052-.023-.3-.489.352Z" fill="#95010C" />
    <path d="m9.6 17.204-.15-.312-.174.437.324-.125Z" fill="#AD0228" />
    <path d="m9.604 16.59-.154.302.45-.136-.296-.167Z" fill="#AF0328" />
    <path d="m9.584 17.594.016-.39-.324.125.308.265Z" fill="#AC0229" />
    <path d="m9.6 17.204.32.134.141-.296-.461.162Z" fill="#AD0228" />
    <path d="m10.03 16.378-.426.211.296.167.13-.378Z" fill="#B6032F" />
    <path d="m9.265 16.41.339.18.01-.34-.35.16Z" fill="#AB0321" />
    <path d="m9.357 15.958-.373.109.28.343.093-.452Z" fill="#AF0422" />
    <path d="m8.892 16.5.102.507.172-.283-.274-.224Z" fill="#A5021B" />
    <path d="m9.589 15.544-.233.414.433-.068-.2-.346Z" fill="#B60625" />
    <path d="m9.004 15.355.26-.181-.493-.033.233.214Z" fill="#AF061B" />
    <path d="m8.727 15.747.257.32.141-.42-.398.1Z" fill="#A70417" />
    <path d="m8.393 16.604.302-.372-.324.072.022.3Z" fill="#9D0213" />
    <path d="m9.604 16.59-.438.134.284.168.154-.303Z" fill="#AF0328" />
    <path d="m8.892 16.5.274.224.099-.314-.373.09Z" fill="#A5021B" />
    <path d="m10.262 16.054-.2-.458-.272.294.472.164Z" fill="#BB0433" />
    <path d="m9.125 15.647-.141.42.373-.109-.232-.311Z" fill="#AE051E" />
    <path d="m10.061 15.596.201.458.197-.36-.398-.098Z" fill="#BC062E" />
    <path d="m9.125 15.647.232.311.232-.414-.464.103Z" fill="#AE051E" />
    <path d="m10.603 14.786.319-.057-.077-.405-.242.462Z" fill="#CA0935" />
    <path d="m9.589 15.544.472.052-.215-.214-.257.162Z" fill="#B60625" />
    <path d="m8.351 15.217.397-.386-.572.069.175.317Z" fill="#A60512" />
    <path d="m8.416 15.94.311-.193-.375-.167.064.36Z" fill="#A10313" />
    <path d="m8.416 15.94-.064-.36-.395.257.46.104Z" fill="#A10313" />
    <path d="m8.416 15.94-.045.364.324-.072-.279-.291Z" fill="#A10313" />
    <path d="m7.943 15.382.014.455.395-.257-.41-.198Z" fill="#9D040C" />
    <path d="m7.296 15.84.2.292.259-.517-.46.226Z" fill="#8F0105" />
    <path d="m8.892 16.5.092-.433-.289.165.197.268Z" fill="#A5021B" />
    <path d="m8.695 16.232.29-.165-.258-.32-.032.485Z" fill="#A30317" />
    <path d="m10.303 16.669-.274-.29-.13.377.405-.087Z" fill="#B80335" />
    <path d="m10.061 15.596-.472-.052.2.346.272-.294Z" fill="#BC062E" />
    <path d="m9.79 15.89-.177.36.416.128-.24-.488Z" fill="#B6052A" />
    <path d="m10.262 16.054.175.297.28-.085-.455-.212Z" fill="#BB0433" />
    <path d="m9.042 14.082.296.306.07-.364-.366.058Z" fill="#BF0B1B" />
    <path d="m8.748 14.831.165-.42-.32.15.155.27Z" fill="#B10717" />
    <path d="m7.881 16.656.216-.527-.284.156.068.371Z" fill="#95010C" />
    <path d="m8.416 15.94-.318.189.272.175.046-.363Z" fill="#A10313" />
    <path d="m8.64 15.436-.289-.219v.363l.29-.144Z" fill="#A80516" />
    <path d="m7.466 15.536.477-.154-.287-.352-.19.506Z" fill="#940207" />
    <path d="m10.061 15.596.398.099-.134-.31-.264.211Z" fill="#BC062E" />
    <path d="m8.771 15.141.492.033-.218-.435-.274.402Z" fill="#AE0618" />
    <path d="m8.64 15.436-.288.144.375.167-.086-.31Z" fill="#A80516" />
    <path d="m9.045 14.74-.132-.329-.165.42.297-.092Z" fill="#B6081B" />
    <path d="m8.64 15.436.087.31.277-.391-.363.081Z" fill="#A80516" />
    <path d="m9.125 15.647.464-.103-.326-.37-.138.473Z" fill="#AE051E" />
    <path d="m9.005 15.355-.278.392.398-.1-.12-.292Z" fill="#AF061B" />
    <path d="m8.747 14.831-.396.386.42-.076-.024-.31Z" fill="#B10717" />
    <path d="m7.296 15.84.459-.225-.29-.08-.17.306Z" fill="#8F0105" />
    <path d="m7.956 15.837-.013-.455-.189.233.202.222Z" fill="#9A020C" />
    <path d="m9.846 15.382.215.214.264-.211-.48-.003Z" fill="#BB062A" />
    <path d="m9.846 15.382.033-.302-.314.005.28.297Z" fill="#BB062A" />
    <path d="M8.352 15.58v-.363l-.41.165.41.198Z" fill="#A20412" />
    <path d="m8.201 14.505-.394.02.37.375.024-.395Z" fill="#AC0711" />
    <path d="m8.771 15.142-.42.075.29.22.13-.295Z" fill="#AE0618" />
    <path d="m8.351 15.217-.175-.317-.23.186.405.131Z" fill="#A60512" />
    <path d="m9.565 15.085.024.459.257-.162-.281-.297Z" fill="#BA0724" />
    <path d="m9.263 15.174.254-.4-.472-.035.218.435Z" fill="#B5071F" />
    <path d="m8.351 15.217-.404-.13-.004.295.408-.165Z" fill="#A60512" />
    <path d="m7.807 14.525.14.561.23-.186-.37-.375Z" fill="#A5060C" />
    <path d="m8.64 15.436.364-.081-.232-.213-.131.294Z" fill="#A80516" />
    <path d="m9.125 15.647.138-.473-.259.18.12.293Z" fill="#AE051E" />
    <path d="m9.517 14.774-.254.4.302-.09-.048-.31Z" fill="#BD0823" />
    <path d="m8.622 14.208.333-.448-.598.213.265.235Z" fill="#B70916" />
    <path d="m8.176 14.9.572-.069-.156-.27-.416.339Z" fill="#A70610" />
    <path d="m8.772 15.141.273-.402-.297.092.024.31Z" fill="#AE0618" />
    <path d="m9.808 14.797-.29-.023.047.31.243-.287Z" fill="#C00927" />
    <path d="m9.687 14.267-.279-.243-.07.364.349-.121Z" fill="#C50B24" />
    <path d="m8.913 14.411.132.328.293-.351-.425.023Z" fill="#B90919" />
    <path d="m9.042 14.082-.13.33.426-.024-.296-.306Z" fill="#BF0B1B" />
    <path d="m9.565 15.085-.302.089.326.37-.024-.46Z" fill="#BA0724" />
    <path d="m9.809 14.797-.244.288.314-.005-.07-.283Z" fill="#C00927" />
    <path d="m9.88 15.08.578-.005-.239-.289-.34.294Z" fill="#BE0729" />
    <path d="m9.94 14.536-.422.238.29.023.132-.261Z" fill="#C50A29" />
    <path d="m9.338 14.388-.293.351.472.035-.18-.386Z" fill="#BF0A1F" />
    <path d="m9.042 14.082-.087-.322-.333.448.42-.126Z" fill="#BF0B1B" />
    <path d="m9.94 14.536-.253-.27-.17.508.423-.238Z" fill="#C50A29" />
    <path d="m9.988 13.806-.301.46.492-.208-.191-.252Z" fill="#CE0D27" />
    <path d="m9.958 13.492.39.058-.147-.357-.243.3Z" fill="#D20F25" />
    <path d="m9.235 13.577-.28.183.453.264-.173-.447Z" fill="#C80E1D" />
    <path d="m9.338 14.388.18.386.169-.507-.35.121Z" fill="#BF0A1F" />
    <path d="m9.408 14.024.267-.257-.44-.19.173.447Z" fill="#C50C20" />
    <path d="m9.94 14.536.246-.175-.5-.094.253.269Z" fill="#C50A29" />
    <path d="m9.675 13.767-.267.257.279.243-.012-.5Z" fill="#CB0D22" />
    <path d="m9.958 13.492-.223-.47-.156.362.379.108Z" fill="#D20F25" />
    <path d="m8.764 13.486.47.091-.166-.398-.304.307Z" fill="#C30D18" />
    <path d="M10.457 14.496v-.307l-.27.172.27.135Z" fill="#CB0A31" />
    <path d="m11.255 14.456.306.304.102-.408-.408.104Z" fill="#D1093E" />
    <path d="m8.955 13.76-.191-.274-.407.486.598-.212Z" fill="#C20C1A" />
    <path d="m9.408 14.024-.453-.264.087.322.366-.058Z" fill="#C50C20" />
    <path d="m8.377 13.54-.02.432.407-.486-.387.053Z" fill="#BD0C14" />
    <path d="m7.107 14.309-.34-.201.128.534.212-.333Z" fill="#9D0507" />
    <path d="m9.042 14.082-.42.126.29.203.13-.33Z" fill="#BF0B1B" />
    <path d="m8.622 14.208-.264-.236-.186.235.45.001Z" fill="#B70916" />
    <path d="m10.367 12.617-.29.144.399.162-.109-.306Z" fill="#DE1326" />
    <path d="m10.03 12.334-.326-.19-.037.44.364-.25Z" fill="#DF1422" />
    <path d="m9.704 12.145-.365.1.328.34.037-.44Z" fill="#DF1420" />
    <path d="m9.667 12.585-.437.093.17.414.267-.507Z" fill="#DA1320" />
    <path d="m9.4 13.092-.166.486.344-.194-.179-.292Z" fill="#D1101E" />
    <path d="m9.234 13.578.165-.486-.331.087.166.399Z" fill="#C80E1D" />
    <path d="m9.958 13.492-.38-.108.097.383.283-.275Z" fill="#D20F25" />
    <path d="m9.579 13.384.156-.363-.336.071.18.292Z" fill="#CF0F21" />
    <path d="m9.988 13.806-.03-.314-.283.275.313.04Z" fill="#CE0D27" />
    <path d="m10.514 13.274-.313-.08.146.356.167-.276Z" fill="#D8102B" />
    <path d="m9.735 13.021-.068-.436-.268.507.336-.07Z" fill="#D51121" />
    <path d="m9.667 12.585-.328-.34-.109.433.437-.093Z" fill="#DA1320" />
    <path d="m9.687 14.267.301-.46-.313-.04.012.5Z" fill="#C50B24" />
    <path d="m10.347 13.55-.36.256.192.252.168-.508Z" fill="#D40E2A" />
    <path d="m10.077 12.761.124.433.275-.271-.399-.162Z" fill="#DB1224" />
    <path d="m9.734 13.021.223.471.244-.299-.467-.171Z" fill="#D51121" />
    <path d="m8.934 12.544.405-.299-.335-.019-.07.318Z" fill="#D3111B" />
    <path d="m9.23 12.678-.296-.134.134.635.162-.5Z" fill="#D4121D" />
    <path d="m8.668 12.207.266.337.07-.318-.336-.019Z" fill="#D4121B" />
    <path d="m8.081 13.794-.227-.5-.173.456.4.044Z" fill="#B40A11" />
    <path d="m10.303 16.669-.242.373.327.03-.085-.403Z" fill="#B80335" />
    <path d="m9.6 17.204.461-.162-.161-.286-.3.448Z" fill="#AD0228" />
    <path d="m10.785 16.93-.482-.261.085.404.397-.142Z" fill="#BD023E" />
    <path d="m10.437 16.351-.134.318.4-.1-.266-.218Z" fill="#BC0437" />
    <path d="m10.704 16.569.271-.164-.258-.139-.013.303Z" fill="#BE033C" />
    <path d="m10.03 16.378.407-.027-.175-.297-.233.324Z" fill="#B6032F" />
    <path d="m9.79 15.89.24.488.232-.324-.472-.164Z" fill="#B6052A" />
    <path d="m9.604 16.59.425-.212-.416-.129-.009.34Z" fill="#AF0328" />
    <path d="m10.262 16.054.455.212.04-.29-.495.078Z" fill="#BB0433" />
    <path d="m10.704 16.569.013-.303-.28.085.267.218Z" fill="#BE033C" />
    <path d="m12.637 15.133.402.184-.144-.47-.258.286Z" fill="#D4045A" />
    <path d="m12.357 13.849.065.35.378-.292-.443-.058Z" fill="#D8094A" />
    <path d="m13.234 14.107-.05.534.366-.217-.316-.317Z" fill="#D70658" />
    <path d="m12.661 14.461-.147.331.381.055-.234-.386Z" fill="#D60655" />
    <path d="m13.665 15.117.202-.376-.358.04.156.336Z" fill="#D60268" />
    <path d="m13.234 14.107-.248.24.198.294.05-.534Z" fill="#D70658" />
    <path d="m12.8 13.907.186.44.248-.24-.434-.2Z" fill="#D80850" />
    <path d="m12.896 14.847.09-.5-.324.114.233.386Z" fill="#D5045C" />
    <path d="m13.234 14.107-.634-.633.2.433.434.2Z" fill="#D70658" />
    <path d="m12.8 13.907-.2-.433-.243.375.443.058Z" fill="#D80850" />
    <path d="m11.36 15.909-.015-.364-.495.103.51.26Z" fill="#C80448" />
    <path d="m13.867 14.74-.317-.316-.04.358.357-.041Z" fill="#D60267" />
    <path d="m10.678 15.353-.22-.278-.133.31.353-.032Z" fill="#C50639" />
    <path d="m8.201 14.505-.025.395.416-.339-.39-.056Z" fill="#AC0711" />
    <path d="m6.582 15.17-.044-.302-.259.335.303-.034Z" fill="#8A0101" />
    <path d="m10.187 14.36.032.426.238-.29-.27-.135Z" fill="#CA0B2C" />
    <path d="m11.882 15.11-.322-.35-.025.33.347.02Z" fill="#D0064D" />
    <path d="m13.24 15.02-.056-.379-.288.206.344.173Z" fill="#D50362" />
    <path d="m13.55 14.424-.366.217.325.14.041-.357Z" fill="#D60460" />
    <path d="m8.622 14.208-.42.297.39.056.03-.353Z" fill="#B70916" />
    <path d="m7.807 14.525.366-.318-.268-.135-.098.453Z" fill="#A5060C" />
    <path d="m7.36 14.934-.127-.312-.383.344.51-.032Z" fill="#980307" />
    <path d="m7.226 13.932.288.298.167-.48-.455.182Z" fill="#A4060A" />
    <path d="m9.88 15.08.34-.294-.411.01.07.284Z" fill="#BE0729" />
    <path d="m10.846 14.324-.39-.135.002.307.388-.172Z" fill="#D00A36" />
    <path
      d="m8.172 14.207-.365.318.394-.02-.029-.298ZM8.172 14.207l-.091-.413-.176.278.267.135Z"
      fill="#B00811"
    />
    <path d="M8.622 14.208h-.45l.03.297.42-.297Z" fill="#B70916" />
    <path d="m8.081 13.794.091.413.186-.235-.277-.178Z" fill="#B40A11" />
    <path d="m8.56 12.98.374-.436-.396.04.023.396Z" fill="#C80F18" />
    <path d="m8.934 12.544-.163.645.297-.01-.134-.635Z" fill="#D3111B" />
    <path d="m8.081 13.794-.4-.044.225.322.175-.278Z" fill="#B40A11" />
    <path d="m8.377 13.54-.15-.36-.373.114.523.245Z" fill="#BD0C14" />
    <path d="m8.764 13.486.304-.307-.296.01-.008.297Z" fill="#C30D18" />
    <path d="m8.034 12.84.192.34.335-.2-.527-.14Z" fill="#C20D15" />
    <path d="m8.034 12.84-.18.454.372-.115-.192-.338Z" fill="#C20D15" />
    <path d="m8.034 12.84-.633.634.453-.18.18-.454Z" fill="#C20D15" />
    <path d="m8.377 13.54-.523-.246.227.5.296-.255Z" fill="#BD0C14" />
    <path d="m8.226 13.18.151.36.394-.35-.545-.01Z" fill="#C00D15" />
    <path d="m8.668 12.207-.634.633.504-.257.13-.376Z" fill="#D4121B" />
    <path d="m8.226 13.18.545.01-.21-.21-.335.2Z" fill="#C00D15" />
    <path d="m8.034 12.84.527.14-.023-.397-.504.258Z" fill="#C20D15" />
    <path d="m7.806 14.525-.574.097.128.312.446-.41Z" fill="#A5060C" />
    <path d="m7.905 14.072-.39.158.291.295.1-.453Z" fill="#AD080F" />
    <path d="m7.226 13.932-.12.377.408-.079-.288-.298Z" fill="#A4060A" />
    <path d="m6.545 15.538.037-.369-.303.034.266.335Z" fill="#870000" />
    <path d="m6.85 14.966-.015.372.292-.198-.277-.174Z" fill="#900203" />
    <path d="m6.895 14.642-.357.226.312.098.045-.324Z" fill="#950305" />
    <path d="m6.581 15.17.269-.204-.312-.098.043.301Z" fill="#8A0101" />
    <path d="m9.687 14.267.5.094-.008-.303-.492.209Z" fill="#C50B24" />
    <path d="m6.895 14.642-.445-.217.087.443.358-.226Z" fill="#950305" />
    <path d="m10.22 14.786-.034-.425-.247.175.28.25Z" fill="#C6092E" />
    <path d="m9.88 15.08-.034.302.479.003-.446-.305Z" fill="#BE0729" />
    <path d="m10.85 15.648-.173-.295-.218.342.39-.047Z" fill="#C5053D" />
    <path d="m10.756 15.976.093-.328-.39.047.297.28Z" fill="#C2043C" />
    <path d="m10.325 15.385.133-.31-.579.005.446.305Z" fill="#C10632" />
    <path d="m11.23 14.96-.308-.231-.063.336.372-.105Z" fill="#CD0741" />
    <path d="m10.834 12.745-.021.407.292-.188-.27-.22Z" fill="#DE122B" />
    <path d="M10.22 14.786h.383l-.146-.29-.238.29Z" fill="#C6092E" />
    <path d="m10.458 15.075.22.278.181-.289-.401.011Z" fill="#C50833" />
    <path d="m9.809 14.797.41-.011-.28-.25-.13.26Z" fill="#C00927" />
    <path d="M10.603 14.786h-.384l.24.29.144-.29Z" fill="#CA0935" />
    <path d="m11.345 15.545.015.364.551-.254-.566-.11Z" fill="#CA0546" />
    <path d="m10.603 14.786-.145.29.401-.012-.256-.278Z" fill="#CA0935" />
    <path d="m10.459 15.695.219-.342-.353.032.134.31Z" fill="#C00536" />
    <path d="m10.677 15.353.354.006-.172-.295-.182.29Z" fill="#C50639" />
    <path d="m10.85 15.648-.094.328.32.128-.227-.456Z" fill="#C5053D" />
    <path d="m11.031 15.36-.354-.007.172.295.182-.289Z" fill="#C9063F" />
    <path d="m11.231 14.96.33-.2-.305-.304-.025.504Z" fill="#CD0741" />
    <path d="m10.603 14.786.256.279.063-.336-.319.057Z" fill="#CA0935" />
    <path d="m10.457 14.19.131-.278-.409.146.278.131Z" fill="#CE0B2F" />
    <path d="m10.862 13.566.327-.258-.377-.156.05.414Z" fill="#D70E31" />
    <path d="m10.187 14.36.27-.17-.278-.132.008.303Z" fill="#CA0B2C" />
    <path d="m10.603 14.786.243-.462-.389.172.146.29Z" fill="#CA0935" />
    <path d="m12.897 16.262.479.09-.128-.351-.351.26Z" fill="#D10163" />
    <path d="m13.576 16.723-.2-.37-.231.294.431.076Z" fill="#D3006B" />
    <path d="m11.19 13.308.218-.219-.303-.126.084.345Z" fill="#DA0E34" />
    <path d="m10.687 12.318.316-.098.013-.33-.33.428Z" fill="#E11327" />
    <path d="m11.333 12.207-.317-.317-.014.33.33-.013Z" fill="#E0122C" />
    <path d="m11.02 13.951.21-.289-.368-.096.159.385Z" fill="#D40C37" />
    <path d="m10.86 15.064.171.295.2-.399-.372.104Z" fill="#C9073B" />
    <path d="m10.835 12.745.168-.524-.316.097.148.427Z" fill="#DE122B" />
    <path d="m10.922 14.729.333-.273-.41-.132.077.405Z" fill="#CD093A" />
    <path d="m11.286 14.135.216-.24-.271-.232.055.472Z" fill="#D40B3C" />
    <path d="m11.02 13.951.266.184-.056-.472-.21.288Z" fill="#D40C37" />
    <path d="m11.031 15.36.314.185.19-.455-.504.27Z" fill="#C9063F" />
    <path d="m11.882 15.11-.347-.02.139.3.208-.28Z" fill="#D0064D" />
    <path d="m11.56 14.76-.329.2.304.13.026-.33Z" fill="#D10845" />
    <path d="m12.18 15.341-.298-.23-.208.278.505-.048Z" fill="#D10454" />
    <path d="m11.882 15.11.296-.181-.267-.238-.03.42Z" fill="#D0064D" />
    <path d="m8.358 13.972.02-.433-.297.255.277.178Z" fill="#B60A13" />
    <path d="m8.772 13.19-.395.35.387-.054.008-.297Z" fill="#C80E19" />
    <path d="m11.535 15.09-.19.455.33-.155-.14-.3Z" fill="#CF0647" />
    <path d="m10.85 15.648.495-.103-.313-.186-.182.289Z" fill="#C5053D" />
    <path d="m10.922 14.729.309.231.024-.504-.333.273Z" fill="#CD093A" />
    <path d="m10.588 13.912.257.412.175-.373-.432-.04Z" fill="#D20D30" />
    <path d="m11.56 14.76.322.35.029-.419-.35.07Z" fill="#D10845" />
    <path d="m10.846 14.324.41.132.03-.321-.44.19Z" fill="#D00A36" />
    <path d="m12.662 14.461-.24-.263-.237.264h.476Z" fill="#D60655" />
    <path d="m12.6 13.474-.434.045.191.33.243-.375Z" fill="#D90A48" />
    <path d="m12.662 14.461-.477.001.329.33.148-.33Z" fill="#D60655" />
    <path d="m12.185 14.462-.225-.408-.297.298.522.11Z" fill="#D5074D" />
    <path d="m11.663 14.352-.103.408.35-.069-.247-.34Z" fill="#D40944" />
    <path d="m11.663 14.352.297-.298-.458-.16.161.458Z" fill="#D40944" />
    <path d="m12.283 13.157-.316-.317-.025.341.341-.024Z" fill="#DB0C40" />
    <path d="m12.423 14.198-.463-.144.225.408.238-.264Z" fill="#D7084E" />
    <path d="m12.178 14.928.007-.466-.274.23.267.236Z" fill="#D30651" />
    <path d="m11.663 14.352.248.34.274-.23-.522-.11Z" fill="#D40944" />
    <path d="m12.166 13.52.434-.046-.317-.317-.117.362Z" fill="#DA0B43" />
    <path d="m10.476 12.923.337.229.021-.407-.358.178Z" fill="#DB1129" />
    <path d="m11.189 13.308.042.354.394-.354h-.436Z" fill="#DA0E34" />
    <path d="m11.96 14.054-.132-.36-.326.2.458.16Z" fill="#D70946" />
    <path d="m12.8 13.907-.378.291.24.263.138-.554Z" fill="#D80850" />
    <path d="m11.96 14.054.463.144-.066-.35-.397.206Z" fill="#D70946" />
    <path d="m10.846 14.324.44-.189-.265-.184-.175.373Z" fill="#D00A36" />
    <path d="m11.663 14.352-.377-.217-.03.321.407-.104Z" fill="#D40944" />
    <path d="m11.502 13.895.326-.2-.203-.386-.123.586Z" fill="#D70B3D" />
    <path d="M11.189 13.308h.436l-.218-.219-.218.219Z" fill="#DA0E34" />
    <path d="m10.514 13.274-.038-.351-.275.27.313.08Z" fill="#D8102B" />
    <path d="m10.348 13.55.514.016-.348-.292-.166.276Z" fill="#D40E2A" />
    <path d="m10.862 13.566-.514-.016.24.362.274-.346Z" fill="#D70E31" />
    <path d="m10.476 12.923.038.35.299-.121-.337-.23Z" fill="#DB1129" />
    <path d="m10.514 13.274.348.292-.05-.414-.298.122Z" fill="#D8102B" />
    <path d="m10.588 13.912.433.04-.16-.386-.273.346Z" fill="#D20D30" />
    <path d="m11.193 12.577.457-.054-.317-.316-.14.37Z" fill="#DF112E" />
    <path d="m11.942 13.181.224.338.117-.362-.34.024Z" fill="#DB0D3C" />
    <path d="m11.828 13.695.132.359.397-.205-.53-.154Z" fill="#D90B40" />
    <path d="m11.942 13.181.025-.34-.33.012.305.328Z" fill="#DB0D3C" />
    <path d="m12.357 13.849-.191-.33-.338.175.529.155Z" fill="#D8094A" />
    <path d="m11.194 12.577-.089.387.303.125-.214-.512Z" fill="#DF112E" />
    <path d="m11.625 13.309-.394.354.271.232.123-.586Z" fill="#DB0D3A" />
    <path d="m10.862 13.566.369.096-.042-.354-.327.258Z" fill="#D70E31" />
    <path d="m11.828 13.695.114-.514-.317.128.203.386Z" fill="#D90B40" />
    <path d="m11.942 13.181-.114.514.338-.176-.224-.338Z" fill="#DB0D3C" />
    <path d="m11.193 12.577-.19-.357-.168.525.358-.168Z" fill="#DF112E" />
    <path d="m11.19 13.308-.085-.345-.293.189.377.156Z" fill="#DA0E34" />
    <path d="m11.193 12.577.215.512.23-.236-.445-.276Z" fill="#DF112E" />
    <path d="m11.625 13.309.317-.128-.305-.328-.012.456Z" fill="#DB0D3A" />
    <path d="m11.637 12.853-.23.236.218.22.012-.456Z" fill="#DD0F35" />
    <path d="m11.002 12.22.191.357.14-.37-.33.013Z" fill="#E11329" />
    <path d="m11.967 12.84-.317-.316-.013.329.33-.013Z" fill="#DC0E39" />
    <path d="m11.193 12.577.444.276.013-.33-.457.054Z" fill="#DF112E" />
    <path d="m9.667 12.585.41.176-.046-.427-.364.251Z" fill="#DA1320" />
    <path d="m10.201 13.194-.124-.433-.343.26.467.172Z" fill="#D71027" />
    <path d="m10.367 12.617.108.306.36-.178-.468-.128Z" fill="#DE1326" />
    <path d="m10.03 12.334.337.283-.01-.324-.326.04Z" fill="#DF1422" />
  </svg>
);
export default KLAY;
